(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', '@js-joda/core', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('@js-joda/core'), require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'));
  else {
    if (typeof this['@js-joda/core'] === 'undefined') {
      throw new Error("Error loading module 'Kotlin-DateTime-library-kotlinx-datetime'. Its dependency '@js-joda/core' was not found. Please, check whether '@js-joda/core' is loaded prior to 'Kotlin-DateTime-library-kotlinx-datetime'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Kotlin-DateTime-library-kotlinx-datetime'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Kotlin-DateTime-library-kotlinx-datetime'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'Kotlin-DateTime-library-kotlinx-datetime'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'Kotlin-DateTime-library-kotlinx-datetime'.");
    }
    root['Kotlin-DateTime-library-kotlinx-datetime'] = factory(typeof this['Kotlin-DateTime-library-kotlinx-datetime'] === 'undefined' ? {} : this['Kotlin-DateTime-library-kotlinx-datetime'], this['@js-joda/core'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core']);
  }
}(globalThis, function (_, $module$_js_joda_core_gcv2k, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Instant = $module$_js_joda_core_gcv2k.Instant;
  var LocalDate = $module$_js_joda_core_gcv2k.LocalDate;
  var LocalDateTime = $module$_js_joda_core_gcv2k.LocalDateTime;
  var LocalTime = $module$_js_joda_core_gcv2k.LocalTime;
  var ZoneOffset = $module$_js_joda_core_gcv2k.ZoneOffset;
  var ChronoField = $module$_js_joda_core_gcv2k.ChronoField;
  var DateTimeFormatterBuilder = $module$_js_joda_core_gcv2k.DateTimeFormatterBuilder;
  var ResolverStyle = $module$_js_joda_core_gcv2k.ResolverStyle;
  var toString = kotlin_kotlin.$_$.lb;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.n1;
  var protoOf = kotlin_kotlin.$_$.hb;
  var objectCreate = kotlin_kotlin.$_$.gb;
  var captureStack = kotlin_kotlin.$_$.r9;
  var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.p1;
  var IllegalArgumentException_init_$Init$_1 = kotlin_kotlin.$_$.l1;
  var IllegalArgumentException_init_$Init$_2 = kotlin_kotlin.$_$.r1;
  var IllegalArgumentException = kotlin_kotlin.$_$.he;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.c2;
  var RuntimeException_init_$Init$_0 = kotlin_kotlin.$_$.b2;
  var RuntimeException = kotlin_kotlin.$_$.ne;
  var VOID = kotlin_kotlin.$_$.g;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var getStringHashCode = kotlin_kotlin.$_$.fa;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.m2;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ia;
  var initMetadataForObject = kotlin_kotlin.$_$.ma;
  var Long = kotlin_kotlin.$_$.je;
  var ensureNotNull = kotlin_kotlin.$_$.ef;
  var toLong = kotlin_kotlin.$_$.jb;
  var ArithmeticException = kotlin_kotlin.$_$.zd;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var KMutableProperty1 = kotlin_kotlin.$_$.xb;
  var getPropertyCallableRef = kotlin_kotlin.$_$.ea;
  var KMutableProperty0 = kotlin_kotlin.$_$.wb;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.d1;
  var Enum = kotlin_kotlin.$_$.ee;
  var initMetadataForInterface = kotlin_kotlin.$_$.ka;
  var toString_0 = kotlin_kotlin.$_$.t2;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.u1;
  var isInterface = kotlin_kotlin.$_$.va;
  var isArray = kotlin_kotlin.$_$.na;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var hashCode = kotlin_kotlin.$_$.ga;
  var listOf = kotlin_kotlin.$_$.q7;
  var get_indices = kotlin_kotlin.$_$.h7;
  var charSequenceLength = kotlin_kotlin.$_$.v9;
  var joinToString = kotlin_kotlin.$_$.i7;
  var equals = kotlin_kotlin.$_$.z9;
  var getBooleanHashCode = kotlin_kotlin.$_$.ca;
  var KProperty0 = kotlin_kotlin.$_$.yb;
  var lazy = kotlin_kotlin.$_$.kf;
  var padStart = kotlin_kotlin.$_$.wc;
  var abs = kotlin_kotlin.$_$.mb;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.l;
  var getOrNull = kotlin_kotlin.$_$.c7;
  var listOf_0 = kotlin_kotlin.$_$.p7;
  var emptyList = kotlin_kotlin.$_$.s6;
  var toString_1 = kotlin_kotlin.$_$.pf;
  var charSequenceGet = kotlin_kotlin.$_$.u9;
  var isDigit = kotlin_kotlin.$_$.nc;
  var get_lastIndex = kotlin_kotlin.$_$.tc;
  var toSet = kotlin_kotlin.$_$.q8;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var distinct = kotlin_kotlin.$_$.p6;
  var to = kotlin_kotlin.$_$.qf;
  var single = kotlin_kotlin.$_$.f8;
  var Collection = kotlin_kotlin.$_$.g5;
  var Char = kotlin_kotlin.$_$.ae;
  var numberRangeToNumber = kotlin_kotlin.$_$.bb;
  var toIntOrNull = kotlin_kotlin.$_$.ld;
  var mutableListOf = kotlin_kotlin.$_$.t7;
  var removeLastOrNull = kotlin_kotlin.$_$.z7;
  var sortWith = kotlin_kotlin.$_$.g8;
  var compareValues = kotlin_kotlin.$_$.t8;
  var Exception = kotlin_kotlin.$_$.ge;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.j1;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.c1;
  var joinTo = kotlin_kotlin.$_$.j7;
  var plus = kotlin_kotlin.$_$.w7;
  var toMutableList = kotlin_kotlin.$_$.o8;
  var addAll = kotlin_kotlin.$_$.t5;
  var firstOrNull = kotlin_kotlin.$_$.x6;
  var drop = kotlin_kotlin.$_$.r6;
  var repeat = kotlin_kotlin.$_$.yc;
  var sortedWith = kotlin_kotlin.$_$.h8;
  var charSequenceSubSequence = kotlin_kotlin.$_$.w9;
  var binarySearch = kotlin_kotlin.$_$.x5;
  var startsWith = kotlin_kotlin.$_$.gd;
  var checkCountOverflow = kotlin_kotlin.$_$.z5;
  var compareTo = kotlin_kotlin.$_$.x9;
  var removePrefix = kotlin_kotlin.$_$.xc;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.i2;
  var Comparable = kotlin_kotlin.$_$.be;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var enumEntries = kotlin_kotlin.$_$.l9;
  var numberToLong = kotlin_kotlin.$_$.fb;
  var numberToInt = kotlin_kotlin.$_$.eb;
  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.m1;
  var ArithmeticException_init_$Create$ = kotlin_kotlin.$_$.e1;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(DateTimeFormatException, 'DateTimeFormatException', DateTimeFormatException_init_$Create$, IllegalArgumentException);
  initMetadataForClass(DateTimeArithmeticException, 'DateTimeArithmeticException', DateTimeArithmeticException_init_$Create$, RuntimeException);
  function set_fractionOfSecond(value) {
    this.s1z(value == null ? null : value.c26(9));
  }
  function get_fractionOfSecond() {
    var tmp0_safe_receiver = this.t1z();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.format.TimeFieldContainer.<get-fractionOfSecond>.<anonymous>' call
      tmp = new DecimalFraction(tmp0_safe_receiver, 9);
    }
    return tmp;
  }
  initMetadataForInterface(TimeFieldContainer, 'TimeFieldContainer');
  initMetadataForInterface(UtcOffsetFieldContainer, 'UtcOffsetFieldContainer');
  initMetadataForClass(DateTimeComponentsContents, 'DateTimeComponentsContents', VOID, VOID, [TimeFieldContainer, UtcOffsetFieldContainer]);
  initMetadataForCompanion(Companion);
  initMetadataForObject(Formats, 'Formats');
  initMetadataForClass(DateTimeComponents, 'DateTimeComponents');
  function appendAlternativeParsingImpl(otherFormats, mainFormat) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(otherFormats.length);
    var inductionVariable = 0;
    var last = otherFormats.length;
    while (inductionVariable < last) {
      var item = otherFormats[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlinx.datetime.format.AbstractDateTimeFormatBuilder.appendAlternativeParsingImpl.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_0 = this.k22();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.format.AbstractDateTimeFormatBuilder.appendAlternativeParsingImpl.<anonymous>.<anonymous>' call
      item(this_0);
      var tmp$ret$1 = this_0.f22().b21();
      destination.e(tmp$ret$1);
    }
    var others = destination;
    // Inline function 'kotlin.also' call
    var this_1 = this.k22();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.format.AbstractDateTimeFormatBuilder.appendAlternativeParsingImpl.<anonymous>' call
    mainFormat(this_1);
    var main = this_1.f22().b21();
    this.f22().i22(new AlternativesParsingFormatStructure(main, others));
  }
  function appendOptionalImpl(onZero, format) {
    var tmp = this.f22();
    // Inline function 'kotlin.also' call
    var this_0 = this.k22();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.format.AbstractDateTimeFormatBuilder.appendOptionalImpl.<anonymous>' call
    format(this_0);
    tmp.i22(new OptionalFormatStructure(onZero, this_0.f22().b21()));
  }
  function chars(value) {
    return this.f22().i22(new ConstantFormatStructure(value));
  }
  function build() {
    return new CachedFormatStructure(this.f22().b21().s23_1);
  }
  initMetadataForInterface(AbstractDateTimeFormatBuilder, 'AbstractDateTimeFormatBuilder');
  function year$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.p22(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.p22.call(this, padding);
    }
    return tmp;
  }
  function monthNumber$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.q22(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.q22.call(this, padding);
    }
    return tmp;
  }
  function dayOfMonth$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.q20(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.q20.call(this, padding);
    }
    return tmp;
  }
  initMetadataForInterface(WithDate, 'WithDate');
  function year(padding) {
    return this.n22(new BasicFormatStructure(new YearDirective(padding)));
  }
  function monthNumber(padding) {
    return this.n22(new BasicFormatStructure(new MonthDirective(padding)));
  }
  function monthName(names) {
    return this.n22(new BasicFormatStructure(new MonthNameDirective(names)));
  }
  function dayOfMonth(padding) {
    return this.n22(new BasicFormatStructure(new DayDirective(padding)));
  }
  function dayOfWeek(names) {
    return this.n22(new BasicFormatStructure(new DayOfWeekDirective(names)));
  }
  function date(format) {
    var tmp;
    if (format instanceof LocalDateFormat) {
      this.n22(format.y23_1);
      tmp = Unit_instance;
    }
    return tmp;
  }
  initMetadataForInterface(AbstractWithDateBuilder, 'AbstractWithDateBuilder', VOID, VOID, [WithDate]);
  function hour$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.t22(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.t22.call(this, padding);
    }
    return tmp;
  }
  function minute$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.u22(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.u22.call(this, padding);
    }
    return tmp;
  }
  function second$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.v22(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.v22.call(this, padding);
    }
    return tmp;
  }
  initMetadataForInterface(WithTime, 'WithTime');
  function hour(padding) {
    return this.o22(new BasicFormatStructure(new HourDirective(padding)));
  }
  function minute(padding) {
    return this.o22(new BasicFormatStructure(new MinuteDirective(padding)));
  }
  function second(padding) {
    return this.o22(new BasicFormatStructure(new SecondDirective(padding)));
  }
  function secondFraction(minLength, maxLength) {
    return this.o22(new BasicFormatStructure(new FractionalSecondDirective(minLength, maxLength)));
  }
  function time(format) {
    var tmp;
    if (format instanceof LocalTimeFormat) {
      this.o22(format.f26_1);
      tmp = Unit_instance;
    }
    return tmp;
  }
  initMetadataForInterface(AbstractWithTimeBuilder, 'AbstractWithTimeBuilder', VOID, VOID, [WithTime]);
  function addFormatStructureForDate(structure) {
    this.g22(structure);
  }
  function addFormatStructureForTime(structure) {
    this.g22(structure);
  }
  initMetadataForInterface(AbstractWithDateTimeBuilder, 'AbstractWithDateTimeBuilder', VOID, VOID, [AbstractWithDateBuilder, AbstractWithTimeBuilder, WithDate, WithTime]);
  function offsetHours$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.x22(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.x22.call(this, padding);
    }
    return tmp;
  }
  function offsetMinutesOfHour$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.y22(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.y22.call(this, padding);
    }
    return tmp;
  }
  function offsetSecondsOfMinute$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.a23(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.a23.call(this, padding);
    }
    return tmp;
  }
  initMetadataForInterface(WithUtcOffset, 'WithUtcOffset');
  function offsetHours(padding) {
    return this.j22(new SignedFormatStructure(new BasicFormatStructure(new UtcOffsetWholeHoursDirective(padding)), true));
  }
  function offsetMinutesOfHour(padding) {
    return this.j22(new BasicFormatStructure(new UtcOffsetMinuteOfHourDirective(padding)));
  }
  function offsetSecondsOfMinute(padding) {
    return this.j22(new BasicFormatStructure(new UtcOffsetSecondOfMinuteDirective(padding)));
  }
  function offset(format) {
    var tmp;
    if (format instanceof UtcOffsetFormat) {
      this.j22(format.a28_1);
      tmp = Unit_instance;
    }
    return tmp;
  }
  initMetadataForInterface(AbstractWithOffsetBuilder, 'AbstractWithOffsetBuilder', VOID, VOID, [WithUtcOffset]);
  initMetadataForClass(Builder, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithDateTimeBuilder, AbstractWithOffsetBuilder, WithTime, WithUtcOffset, WithDate]);
  initMetadataForClass(AbstractDateTimeFormat, 'AbstractDateTimeFormat');
  initMetadataForClass(DateTimeComponentsFormat, 'DateTimeComponentsFormat', VOID, AbstractDateTimeFormat);
  initMetadataForClass(TwoDigitNumber, 'TwoDigitNumber');
  initMetadataForClass(Padding, 'Padding', VOID, Enum);
  initMetadataForClass(IncompleteLocalDate, 'IncompleteLocalDate', IncompleteLocalDate);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(MonthNames, 'MonthNames');
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(DayOfWeekNames, 'DayOfWeekNames');
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(Builder_0, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithDateBuilder]);
  initMetadataForClass(LocalDateFormat, 'LocalDateFormat', VOID, AbstractDateTimeFormat);
  initMetadataForClass(SignedIntFieldFormatDirective, 'SignedIntFieldFormatDirective');
  initMetadataForClass(YearDirective, 'YearDirective', VOID, SignedIntFieldFormatDirective);
  initMetadataForClass(UnsignedIntFieldFormatDirective, 'UnsignedIntFieldFormatDirective');
  initMetadataForClass(MonthDirective, 'MonthDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(NamedUnsignedIntFieldFormatDirective, 'NamedUnsignedIntFieldFormatDirective');
  initMetadataForClass(MonthNameDirective, 'MonthNameDirective', VOID, NamedUnsignedIntFieldFormatDirective);
  initMetadataForClass(DayDirective, 'DayDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(DayOfWeekDirective, 'DayOfWeekDirective', VOID, NamedUnsignedIntFieldFormatDirective);
  initMetadataForObject(DateFields, 'DateFields');
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(Builder_1, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithDateTimeBuilder]);
  initMetadataForClass(LocalDateTimeFormat, 'LocalDateTimeFormat', VOID, AbstractDateTimeFormat);
  initMetadataForClass(IncompleteLocalDateTime, 'IncompleteLocalDateTime', IncompleteLocalDateTime, VOID, [TimeFieldContainer]);
  initMetadataForClass(IncompleteLocalTime, 'IncompleteLocalTime', IncompleteLocalTime, VOID, [TimeFieldContainer]);
  initMetadataForClass(AmPmMarker, 'AmPmMarker', VOID, Enum);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(Builder_2, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithTimeBuilder]);
  initMetadataForClass(LocalTimeFormat, 'LocalTimeFormat', VOID, AbstractDateTimeFormat);
  initMetadataForClass(HourDirective, 'HourDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(MinuteDirective, 'MinuteDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(SecondDirective, 'SecondDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(DecimalFractionFieldFormatDirective, 'DecimalFractionFieldFormatDirective');
  initMetadataForClass(FractionalSecondDirective, 'FractionalSecondDirective', VOID, DecimalFractionFieldFormatDirective);
  initMetadataForObject(TimeFields, 'TimeFields');
  initMetadataForClass(IncompleteUtcOffset, 'IncompleteUtcOffset', IncompleteUtcOffset, VOID, [UtcOffsetFieldContainer]);
  initMetadataForClass(UtcOffsetWholeHoursDirective, 'UtcOffsetWholeHoursDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(Builder_3, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithOffsetBuilder]);
  initMetadataForClass(UtcOffsetFormat, 'UtcOffsetFormat', VOID, AbstractDateTimeFormat);
  initMetadataForClass(OffsetFields$sign$1);
  initMetadataForObject(OffsetFields, 'OffsetFields');
  initMetadataForClass(UtcOffsetMinuteOfHourDirective, 'UtcOffsetMinuteOfHourDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(UtcOffsetSecondOfMinuteDirective, 'UtcOffsetSecondOfMinuteDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(AppendableFormatStructure, 'AppendableFormatStructure', AppendableFormatStructure);
  initMetadataForClass(AssignableString, 'AssignableString');
  initMetadataForClass(AbstractFieldSpec, 'AbstractFieldSpec');
  initMetadataForClass(GenericFieldSpec, 'GenericFieldSpec', VOID, AbstractFieldSpec);
  function getterNotNull(container) {
    var tmp0_elvis_lhs = this.l29(container);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('Field ' + this.s28() + ' is not set');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  initMetadataForInterface(Accessor, 'Accessor');
  initMetadataForClass(PropertyAccessor, 'PropertyAccessor', VOID, VOID, [Accessor]);
  initMetadataForClass(UnsignedFieldSpec, 'UnsignedFieldSpec', VOID, AbstractFieldSpec);
  initMetadataForClass(ConcatenatedFormatStructure, 'ConcatenatedFormatStructure');
  initMetadataForClass(CachedFormatStructure, 'CachedFormatStructure', VOID, ConcatenatedFormatStructure);
  initMetadataForInterface(NonConcatenatedFormatStructure, 'NonConcatenatedFormatStructure');
  initMetadataForClass(BasicFormatStructure, 'BasicFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
  initMetadataForClass(ConstantFormatStructure, 'ConstantFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
  initMetadataForClass(SignedFormatStructure, 'SignedFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
  initMetadataForCompanion(Companion_7);
  initMetadataForClass(PropertyWithDefault, 'PropertyWithDefault');
  initMetadataForClass(OptionalFormatStructure, 'OptionalFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
  initMetadataForClass(AlternativesParsingFormatStructure, 'AlternativesParsingFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
  initMetadataForClass(ComparisonPredicate, 'ComparisonPredicate');
  initMetadataForObject(Truth, 'Truth');
  initMetadataForClass(ConjunctionPredicate, 'ConjunctionPredicate');
  function format$default(obj, builder, minusNotRequired, $super) {
    minusNotRequired = minusNotRequired === VOID ? false : minusNotRequired;
    var tmp;
    if ($super === VOID) {
      this.e2a(obj, builder, minusNotRequired);
      tmp = Unit_instance;
    } else {
      tmp = $super.e2a.call(this, obj, builder, minusNotRequired);
    }
    return tmp;
  }
  initMetadataForInterface(FormatterStructure, 'FormatterStructure');
  initMetadataForClass(SpacePaddedFormatter, 'SpacePaddedFormatter', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(SignedFormatter, 'SignedFormatter', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(ConditionalFormatter, 'ConditionalFormatter', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(ConcatenatedFormatter, 'ConcatenatedFormatter', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(SignedIntFormatterStructure, 'SignedIntFormatterStructure', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(UnsignedIntFormatterStructure, 'UnsignedIntFormatterStructure', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(StringFormatterStructure, 'StringFormatterStructure', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(DecimalFractionFormatterStructure, 'DecimalFractionFormatterStructure', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(ConstantStringFormatterStructure, 'ConstantStringFormatterStructure', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(NumberConsumer, 'NumberConsumer');
  initMetadataForClass(FractionPartConsumer, 'FractionPartConsumer', VOID, NumberConsumer);
  initMetadataForClass(ConstantNumberConsumer, 'ConstantNumberConsumer', VOID, NumberConsumer);
  initMetadataForObject(ExpectedInt, 'ExpectedInt');
  initMetadataForClass(TooManyDigits, 'TooManyDigits');
  initMetadataForClass(TooFewDigits, 'TooFewDigits');
  initMetadataForClass(WrongConstant, 'WrongConstant');
  initMetadataForClass(Conflicting, 'Conflicting');
  initMetadataForClass(UnsignedIntConsumer, 'UnsignedIntConsumer', VOID, NumberConsumer);
  initMetadataForClass(ParseError, 'ParseError');
  initMetadataForCompanion(Companion_8);
  initMetadataForClass(ParserState, 'ParserState');
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0');
  initMetadataForClass(Parser, 'Parser');
  initMetadataForClass(ParserStructure, 'ParserStructure');
  initMetadataForClass(ParseException, 'ParseException', VOID, Exception);
  initMetadataForClass(TrieNode, 'TrieNode', TrieNode);
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0');
  initMetadataForClass(StringSetParserOperation, 'StringSetParserOperation');
  initMetadataForClass(NumberSpanParserOperation, 'NumberSpanParserOperation');
  initMetadataForClass(PlainStringParserOperation, 'PlainStringParserOperation');
  initMetadataForClass(SignParser, 'SignParser');
  initMetadataForClass(UnconditionalModification, 'UnconditionalModification');
  initMetadataForClass(DecimalFraction, 'DecimalFraction', VOID, VOID, [Comparable]);
  initMetadataForObject(InstantIso8601Serializer, 'InstantIso8601Serializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(LocalDateIso8601Serializer, 'LocalDateIso8601Serializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(LocalDateTimeIso8601Serializer, 'LocalDateTimeIso8601Serializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(LocalTimeIso8601Serializer, 'LocalTimeIso8601Serializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UtcOffsetSerializer, 'UtcOffsetSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(DayOfWeek_0, 'DayOfWeek', VOID, Enum);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(Instant_0, 'Instant', VOID, VOID, [Comparable], VOID, VOID, {0: InstantIso8601Serializer_getInstance});
  initMetadataForCompanion(Companion_10);
  initMetadataForObject(Formats_0, 'Formats');
  initMetadataForClass(LocalDate_0, 'LocalDate', VOID, VOID, [Comparable], VOID, VOID, {0: LocalDateIso8601Serializer_getInstance});
  initMetadataForCompanion(Companion_11);
  initMetadataForObject(Formats_1, 'Formats');
  initMetadataForClass(LocalDateTime_0, 'LocalDateTime', VOID, VOID, [Comparable], VOID, VOID, {0: LocalDateTimeIso8601Serializer_getInstance});
  initMetadataForCompanion(Companion_12);
  initMetadataForObject(Formats_2, 'Formats');
  initMetadataForClass(LocalTime_0, 'LocalTime', VOID, VOID, [Comparable], VOID, VOID, {0: LocalTimeIso8601Serializer_getInstance});
  initMetadataForCompanion(Companion_13);
  initMetadataForObject(Formats_3, 'Formats');
  initMetadataForClass(UtcOffset, 'UtcOffset', VOID, VOID, VOID, VOID, VOID, {0: UtcOffsetSerializer_getInstance});
  //endregion
  function get_isoDayNumber(_this__u8e3s4) {
    return _this__u8e3s4.f2_1 + 1 | 0;
  }
  function DayOfWeek(isoDayNumber) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(1 <= isoDayNumber ? isoDayNumber <= 7 : false)) {
      // Inline function 'kotlinx.datetime.DayOfWeek.<anonymous>' call
      var message = 'Expected ISO day-of-week number in 1..7, got ' + isoDayNumber;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return get_entries().p(isoDayNumber - 1 | 0);
  }
  function DateTimeFormatException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    DateTimeFormatException.call($this);
    return $this;
  }
  function DateTimeFormatException_init_$Create$() {
    var tmp = DateTimeFormatException_init_$Init$(objectCreate(protoOf(DateTimeFormatException)));
    captureStack(tmp, DateTimeFormatException_init_$Create$);
    return tmp;
  }
  function DateTimeFormatException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    DateTimeFormatException.call($this);
    return $this;
  }
  function DateTimeFormatException_init_$Create$_0(message) {
    var tmp = DateTimeFormatException_init_$Init$_0(message, objectCreate(protoOf(DateTimeFormatException)));
    captureStack(tmp, DateTimeFormatException_init_$Create$_0);
    return tmp;
  }
  function DateTimeFormatException_init_$Init$_1(cause, $this) {
    IllegalArgumentException_init_$Init$_1(cause, $this);
    DateTimeFormatException.call($this);
    return $this;
  }
  function DateTimeFormatException_init_$Create$_1(cause) {
    var tmp = DateTimeFormatException_init_$Init$_1(cause, objectCreate(protoOf(DateTimeFormatException)));
    captureStack(tmp, DateTimeFormatException_init_$Create$_1);
    return tmp;
  }
  function DateTimeFormatException_init_$Init$_2(message, cause, $this) {
    IllegalArgumentException_init_$Init$_2(message, cause, $this);
    DateTimeFormatException.call($this);
    return $this;
  }
  function DateTimeFormatException_init_$Create$_2(message, cause) {
    var tmp = DateTimeFormatException_init_$Init$_2(message, cause, objectCreate(protoOf(DateTimeFormatException)));
    captureStack(tmp, DateTimeFormatException_init_$Create$_2);
    return tmp;
  }
  function DateTimeFormatException() {
    captureStack(this, DateTimeFormatException);
  }
  function DateTimeArithmeticException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    DateTimeArithmeticException.call($this);
    return $this;
  }
  function DateTimeArithmeticException_init_$Create$() {
    var tmp = DateTimeArithmeticException_init_$Init$(objectCreate(protoOf(DateTimeArithmeticException)));
    captureStack(tmp, DateTimeArithmeticException_init_$Create$);
    return tmp;
  }
  function DateTimeArithmeticException_init_$Init$_0(cause, $this) {
    RuntimeException_init_$Init$_0(cause, $this);
    DateTimeArithmeticException.call($this);
    return $this;
  }
  function DateTimeArithmeticException_init_$Create$_0(cause) {
    var tmp = DateTimeArithmeticException_init_$Init$_0(cause, objectCreate(protoOf(DateTimeArithmeticException)));
    captureStack(tmp, DateTimeArithmeticException_init_$Create$_0);
    return tmp;
  }
  function DateTimeArithmeticException() {
    captureStack(this, DateTimeArithmeticException);
  }
  function format(_this__u8e3s4, format, offset) {
    offset = offset === VOID ? Companion_getInstance_13().t1x_1 : offset;
    var instant = _this__u8e3s4;
    return format_0(format, format$lambda(instant, offset));
  }
  function format$lambda($instant, $offset) {
    return function ($this$format) {
      $this$format.i1y($instant, $offset);
      return Unit_instance;
    };
  }
  function getIsoDateFormat() {
    return Formats_getInstance_0().k1y();
  }
  function getIsoDateTimeFormat() {
    return Formats_getInstance_1().l1y_1;
  }
  function getIsoTimeFormat() {
    return Formats_instance_2.k1y();
  }
  function getIsoUtcOffsetFormat() {
    return Formats_instance_3.k1y();
  }
  var timeZoneField;
  function get_emptyDateTimeComponentsContents() {
    _init_properties_DateTimeComponents_kt__9iimb5();
    return emptyDateTimeComponentsContents;
  }
  var emptyDateTimeComponentsContents;
  function DateTimeComponentsContents(date, time, offset, timeZoneId) {
    date = date === VOID ? new IncompleteLocalDate() : date;
    time = time === VOID ? new IncompleteLocalTime() : time;
    offset = offset === VOID ? new IncompleteUtcOffset() : offset;
    timeZoneId = timeZoneId === VOID ? null : timeZoneId;
    this.m1y_1 = date;
    this.n1y_1 = time;
    this.o1y_1 = offset;
    this.p1y_1 = timeZoneId;
  }
  protoOf(DateTimeComponentsContents).q1y = function (_set____db54di) {
    this.m1y_1.t1y_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).v1y = function () {
    return this.m1y_1.t1y_1;
  };
  protoOf(DateTimeComponentsContents).w1y = function (_set____db54di) {
    this.m1y_1.u1y_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).x1y = function () {
    return this.m1y_1.u1y_1;
  };
  protoOf(DateTimeComponentsContents).y1y = function (_set____db54di) {
    this.m1y_1.s1y_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).z1y = function () {
    return this.m1y_1.s1y_1;
  };
  protoOf(DateTimeComponentsContents).a1z = function (_set____db54di) {
    this.m1y_1.r1y_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).b1z = function () {
    return this.m1y_1.r1y_1;
  };
  protoOf(DateTimeComponentsContents).c1z = function (_set____db54di) {
    this.n1y_1.f1z_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).j1z = function () {
    return this.n1y_1.f1z_1;
  };
  protoOf(DateTimeComponentsContents).k1z = function (value) {
    this.n1y_1.k1z(value);
  };
  protoOf(DateTimeComponentsContents).l1z = function () {
    return this.n1y_1.l1z();
  };
  protoOf(DateTimeComponentsContents).m1z = function (_set____db54di) {
    this.n1y_1.d1z_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).n1z = function () {
    return this.n1y_1.d1z_1;
  };
  protoOf(DateTimeComponentsContents).o1z = function (_set____db54di) {
    this.n1y_1.e1z_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).p1z = function () {
    return this.n1y_1.e1z_1;
  };
  protoOf(DateTimeComponentsContents).q1z = function (_set____db54di) {
    this.n1y_1.g1z_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).r1z = function () {
    return this.n1y_1.g1z_1;
  };
  protoOf(DateTimeComponentsContents).s1z = function (_set____db54di) {
    this.n1y_1.i1z_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).t1z = function () {
    return this.n1y_1.i1z_1;
  };
  protoOf(DateTimeComponentsContents).u1z = function (_set____db54di) {
    this.n1y_1.h1z_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).v1z = function () {
    return this.n1y_1.h1z_1;
  };
  protoOf(DateTimeComponentsContents).w1z = function (_set____db54di) {
    this.o1y_1.x1z_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).b20 = function () {
    return this.o1y_1.x1z_1;
  };
  protoOf(DateTimeComponentsContents).c20 = function (_set____db54di) {
    this.o1y_1.z1z_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).d20 = function () {
    return this.o1y_1.z1z_1;
  };
  protoOf(DateTimeComponentsContents).e20 = function (_set____db54di) {
    this.o1y_1.a20_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).f20 = function () {
    return this.o1y_1.a20_1;
  };
  protoOf(DateTimeComponentsContents).g20 = function (_set____db54di) {
    this.o1y_1.y1z_1 = _set____db54di;
  };
  protoOf(DateTimeComponentsContents).h20 = function () {
    return this.o1y_1.y1z_1;
  };
  protoOf(DateTimeComponentsContents).i20 = function () {
    return new DateTimeComponentsContents(this.m1y_1.i20(), this.n1y_1.i20(), this.o1y_1.i20(), this.p1y_1);
  };
  protoOf(DateTimeComponentsContents).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof DateTimeComponentsContents) {
      tmp_2 = other.m1y_1.equals(this.m1y_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = other.n1y_1.equals(this.n1y_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = other.o1y_1.equals(this.o1y_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = other.p1y_1 == this.p1y_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DateTimeComponentsContents).hashCode = function () {
    var tmp = this.m1y_1.hashCode() ^ this.n1y_1.hashCode() ^ this.o1y_1.hashCode();
    var tmp0_safe_receiver = this.p1y_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp ^ (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs);
  };
  function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda($this$Format) {
    $this$Format.j20(get_ISO_DATE());
    var tmp = [DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda];
    alternativeParsing($this$Format, tmp, DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_0);
    $this$Format.k20();
    char($this$Format, _Char___init__impl__6a9atx(58));
    $this$Format.l20();
    char($this$Format, _Char___init__impl__6a9atx(58));
    $this$Format.m20();
    optional($this$Format, VOID, DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_1);
    var tmp_0 = [DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_2];
    alternativeParsing($this$Format, tmp_0, DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_3);
    return Unit_instance;
  }
  function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda($this$alternativeParsing) {
    char($this$alternativeParsing, _Char___init__impl__6a9atx(116));
    return Unit_instance;
  }
  function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_0($this$alternativeParsing) {
    char($this$alternativeParsing, _Char___init__impl__6a9atx(84));
    return Unit_instance;
  }
  function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_1($this$optional) {
    char($this$optional, _Char___init__impl__6a9atx(46));
    $this$optional.n20(1, 9);
    return Unit_instance;
  }
  function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_2($this$alternativeParsing) {
    $this$alternativeParsing.o20();
    return Unit_instance;
  }
  function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_3($this$alternativeParsing) {
    $this$alternativeParsing.p20(Formats_instance_3.k1y());
    return Unit_instance;
  }
  function DateTimeComponents$Formats$RFC_1123$lambda($this$Format) {
    var tmp = [DateTimeComponents$Formats$RFC_1123$lambda$lambda];
    alternativeParsing($this$Format, tmp, DateTimeComponents$Formats$RFC_1123$lambda$lambda_0);
    $this$Format.q20(Padding_NONE_getInstance());
    char($this$Format, _Char___init__impl__6a9atx(32));
    $this$Format.t20(Companion_getInstance_0().s20_1);
    char($this$Format, _Char___init__impl__6a9atx(32));
    $this$Format.u20();
    char($this$Format, _Char___init__impl__6a9atx(32));
    $this$Format.k20();
    char($this$Format, _Char___init__impl__6a9atx(58));
    $this$Format.l20();
    optional($this$Format, VOID, DateTimeComponents$Formats$RFC_1123$lambda$lambda_1);
    $this$Format.v20(' ');
    var tmp_0 = DateTimeComponents$Formats$RFC_1123$lambda$lambda_2;
    var tmp_1 = [tmp_0, DateTimeComponents$Formats$RFC_1123$lambda$lambda_3];
    alternativeParsing($this$Format, tmp_1, DateTimeComponents$Formats$RFC_1123$lambda$lambda_4);
    return Unit_instance;
  }
  function DateTimeComponents$Formats$RFC_1123$lambda$lambda($this$alternativeParsing) {
    return Unit_instance;
  }
  function DateTimeComponents$Formats$RFC_1123$lambda$lambda_0($this$alternativeParsing) {
    $this$alternativeParsing.y20(Companion_getInstance_1().x20_1);
    $this$alternativeParsing.v20(', ');
    return Unit_instance;
  }
  function DateTimeComponents$Formats$RFC_1123$lambda$lambda_1($this$optional) {
    char($this$optional, _Char___init__impl__6a9atx(58));
    $this$optional.m20();
    return Unit_instance;
  }
  function DateTimeComponents$Formats$RFC_1123$lambda$lambda_2($this$alternativeParsing) {
    $this$alternativeParsing.v20('UT');
    return Unit_instance;
  }
  function DateTimeComponents$Formats$RFC_1123$lambda$lambda_3($this$alternativeParsing) {
    $this$alternativeParsing.v20('Z');
    return Unit_instance;
  }
  function DateTimeComponents$Formats$RFC_1123$lambda$lambda_4($this$alternativeParsing) {
    optional($this$alternativeParsing, 'GMT', DateTimeComponents$Formats$RFC_1123$lambda$lambda$lambda);
    return Unit_instance;
  }
  function DateTimeComponents$Formats$RFC_1123$lambda$lambda$lambda($this$optional) {
    $this$optional.p20(Formats_instance_3.z20());
    return Unit_instance;
  }
  function Companion() {
  }
  protoOf(Companion).a21 = function (block) {
    var builder = new Builder(new AppendableFormatStructure());
    block(builder);
    return new DateTimeComponentsFormat(builder.b21());
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function Formats() {
    Formats_instance = this;
    var tmp = this;
    var tmp_0 = Companion_instance;
    tmp.c21_1 = tmp_0.a21(DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda);
    var tmp_1 = this;
    var tmp_2 = Companion_instance;
    tmp_1.d21_1 = tmp_2.a21(DateTimeComponents$Formats$RFC_1123$lambda);
  }
  var Formats_instance;
  function Formats_getInstance() {
    if (Formats_instance == null)
      new Formats();
    return Formats_instance;
  }
  function DateTimeComponents(contents) {
    contents = contents === VOID ? new DateTimeComponentsContents() : contents;
    this.u1x_1 = contents;
    this.v1x_1 = year$factory(this.u1x_1.m1y_1);
    this.w1x_1 = new TwoDigitNumber(monthNumber$factory(this.u1x_1.m1y_1));
    this.x1x_1 = new TwoDigitNumber(dayOfMonth$factory(this.u1x_1.m1y_1));
    this.y1x_1 = new TwoDigitNumber(hour$factory(this.u1x_1.n1y_1));
    this.z1x_1 = new TwoDigitNumber(hourOfAmPm$factory(this.u1x_1.n1y_1));
    this.a1y_1 = amPm$factory(this.u1x_1.n1y_1);
    this.b1y_1 = new TwoDigitNumber(minute$factory(this.u1x_1.n1y_1));
    this.c1y_1 = new TwoDigitNumber(second$factory(this.u1x_1.n1y_1));
    this.d1y_1 = isNegative$factory(this.u1x_1.o1y_1);
    this.e1y_1 = new TwoDigitNumber(totalHoursAbs$factory(this.u1x_1.o1y_1));
    this.f1y_1 = new TwoDigitNumber(minutesOfHour$factory(this.u1x_1.o1y_1));
    this.g1y_1 = new TwoDigitNumber(secondsOfMinute$factory(this.u1x_1.o1y_1));
    this.h1y_1 = timeZoneId$factory_0(this.u1x_1);
  }
  protoOf(DateTimeComponents).e21 = function (localDateTime) {
    this.u1x_1.m1y_1.h21(localDateTime.g21());
    this.u1x_1.n1y_1.j21(localDateTime.i21());
  };
  protoOf(DateTimeComponents).k21 = function (utcOffset) {
    this.u1x_1.o1y_1.l21(utcOffset);
  };
  protoOf(DateTimeComponents).i1y = function (instant, utcOffset) {
    var smallerInstant = Companion_getInstance_9().t21(instant.n21().p2(new Long(2036907392, 73)), instant.o21());
    this.e21(toLocalDateTime(smallerInstant, utcOffset));
    this.k21(utcOffset);
    var tmp = ensureNotNull(this.b1z());
    // Inline function 'kotlin.Long.times' call
    var tmp$ret$0 = instant.n21().o2(new Long(2036907392, 73)).n2(toLong(10000));
    this.a1z(tmp + tmp$ret$0.c3() | 0);
  };
  protoOf(DateTimeComponents).a1z = function (_set____db54di) {
    var this_0 = this.v1x_1;
    year$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(DateTimeComponents).b1z = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v1x_1;
    year$factory_1();
    return this_0.get();
  };
  protoOf(DateTimeComponents).t1z = function () {
    return this.u1x_1.n1y_1.i1z_1;
  };
  protoOf(DateTimeComponents).u21 = function () {
    return this.u1x_1.o1y_1.u21();
  };
  protoOf(DateTimeComponents).v21 = function () {
    return this.u1x_1.n1y_1.v21();
  };
  protoOf(DateTimeComponents).w21 = function () {
    var offset = this.u21();
    var time = this.v21();
    var truncatedDate = this.u1x_1.m1y_1.i20();
    truncatedDate.r1y_1 = requireParsedField(truncatedDate.r1y_1, 'year') % 10000 | 0;
    var tmp;
    try {
      var secDelta = safeMultiply(toLong(ensureNotNull(this.b1z()) / 10000 | 0), new Long(2036907392, 73));
      var epochDays = toLong(truncatedDate.x21().z21());
      // Inline function 'kotlin.Long.minus' call
      // Inline function 'kotlin.Long.plus' call
      // Inline function 'kotlin.Long.times' call
      var this_0 = epochDays.n2(toLong(86400));
      var other = time.b22();
      var this_1 = this_0.l2(toLong(other));
      var other_0 = offset.d22();
      var tmp$ret$2 = this_1.m2(toLong(other_0));
      tmp = safeAdd(secDelta, tmp$ret$2);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ArithmeticException) {
        var e = $p;
        throw DateTimeFormatException_init_$Create$_2('The parsed date is outside the range representable by Instant', e);
      } else {
        throw $p;
      }
    }
    var totalSeconds = tmp;
    if (totalSeconds.a1(Companion_getInstance_9().r21_1.n21()) < 0 || totalSeconds.a1(Companion_getInstance_9().s21_1.n21()) > 0)
      throw DateTimeFormatException_init_$Create$_0('The parsed date is outside the range representable by Instant');
    var tmp_1 = Companion_getInstance_9();
    var tmp0_elvis_lhs = this.t1z();
    return tmp_1.t21(totalSeconds, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs);
  };
  function Builder(actualBuilder) {
    this.e22_1 = actualBuilder;
  }
  protoOf(Builder).f22 = function () {
    return this.e22_1;
  };
  protoOf(Builder).g22 = function (structure) {
    this.e22_1.i22(structure);
  };
  protoOf(Builder).j22 = function (structure) {
    this.e22_1.i22(structure);
  };
  protoOf(Builder).k22 = function () {
    return new Builder(new AppendableFormatStructure());
  };
  function DateTimeComponentsFormat(actualFormat) {
    AbstractDateTimeFormat.call(this);
    this.c23_1 = actualFormat;
  }
  protoOf(DateTimeComponentsFormat).d23 = function () {
    return this.c23_1;
  };
  protoOf(DateTimeComponentsFormat).e23 = function (value) {
    return value.u1x_1;
  };
  protoOf(DateTimeComponentsFormat).f23 = function (value) {
    return this.e23(value instanceof DateTimeComponents ? value : THROW_CCE());
  };
  protoOf(DateTimeComponentsFormat).g23 = function (intermediate) {
    return new DateTimeComponents(intermediate);
  };
  protoOf(DateTimeComponentsFormat).h23 = function (intermediate) {
    return this.g23(intermediate instanceof DateTimeComponentsContents ? intermediate : THROW_CCE());
  };
  protoOf(DateTimeComponentsFormat).i23 = function () {
    return get_emptyDateTimeComponentsContents();
  };
  function TwoDigitNumber(reference) {
    this.l23_1 = reference;
  }
  function format_0(_this__u8e3s4, block) {
    _init_properties_DateTimeComponents_kt__9iimb5();
    // Inline function 'kotlin.apply' call
    var this_0 = new DateTimeComponents();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.format.format.<anonymous>' call
    block(this_0);
    return _this__u8e3s4.j23(this_0);
  }
  function timeZoneId$factory() {
    return getPropertyCallableRef('timeZoneId', 1, KMutableProperty1, function (receiver) {
      return receiver.p1y_1;
    }, function (receiver, value) {
      receiver.p1y_1 = value;
      return Unit_instance;
    });
  }
  function year$factory($b0) {
    return getPropertyCallableRef('year', 0, KMutableProperty0, function () {
      return $b0.r1y_1;
    }, function (value) {
      $b0.r1y_1 = value;
      return Unit_instance;
    });
  }
  function monthNumber$factory($b0) {
    return getPropertyCallableRef('monthNumber', 0, KMutableProperty0, function () {
      return $b0.s1y_1;
    }, function (value) {
      $b0.s1y_1 = value;
      return Unit_instance;
    });
  }
  function dayOfMonth$factory($b0) {
    return getPropertyCallableRef('dayOfMonth', 0, KMutableProperty0, function () {
      return $b0.t1y_1;
    }, function (value) {
      $b0.t1y_1 = value;
      return Unit_instance;
    });
  }
  function hour$factory($b0) {
    return getPropertyCallableRef('hour', 0, KMutableProperty0, function () {
      return $b0.d1z_1;
    }, function (value) {
      $b0.d1z_1 = value;
      return Unit_instance;
    });
  }
  function hourOfAmPm$factory($b0) {
    return getPropertyCallableRef('hourOfAmPm', 0, KMutableProperty0, function () {
      return $b0.e1z_1;
    }, function (value) {
      $b0.e1z_1 = value;
      return Unit_instance;
    });
  }
  function amPm$factory($b0) {
    return getPropertyCallableRef('amPm', 0, KMutableProperty0, function () {
      return $b0.f1z_1;
    }, function (value) {
      $b0.f1z_1 = value;
      return Unit_instance;
    });
  }
  function minute$factory($b0) {
    return getPropertyCallableRef('minute', 0, KMutableProperty0, function () {
      return $b0.g1z_1;
    }, function (value) {
      $b0.g1z_1 = value;
      return Unit_instance;
    });
  }
  function second$factory($b0) {
    return getPropertyCallableRef('second', 0, KMutableProperty0, function () {
      return $b0.h1z_1;
    }, function (value) {
      $b0.h1z_1 = value;
      return Unit_instance;
    });
  }
  function isNegative$factory($b0) {
    return getPropertyCallableRef('isNegative', 0, KMutableProperty0, function () {
      return $b0.x1z_1;
    }, function (value) {
      $b0.x1z_1 = value;
      return Unit_instance;
    });
  }
  function totalHoursAbs$factory($b0) {
    return getPropertyCallableRef('totalHoursAbs', 0, KMutableProperty0, function () {
      return $b0.y1z_1;
    }, function (value) {
      $b0.y1z_1 = value;
      return Unit_instance;
    });
  }
  function minutesOfHour$factory($b0) {
    return getPropertyCallableRef('minutesOfHour', 0, KMutableProperty0, function () {
      return $b0.z1z_1;
    }, function (value) {
      $b0.z1z_1 = value;
      return Unit_instance;
    });
  }
  function secondsOfMinute$factory($b0) {
    return getPropertyCallableRef('secondsOfMinute', 0, KMutableProperty0, function () {
      return $b0.a20_1;
    }, function (value) {
      $b0.a20_1 = value;
      return Unit_instance;
    });
  }
  function timeZoneId$factory_0($b0) {
    return getPropertyCallableRef('timeZoneId', 0, KMutableProperty0, function () {
      return $b0.p1y_1;
    }, function (value) {
      $b0.p1y_1 = value;
      return Unit_instance;
    });
  }
  function year$factory_0() {
    return getPropertyCallableRef('year', 1, KMutableProperty1, function (receiver) {
      return receiver.b1z();
    }, function (receiver, value) {
      return receiver.a1z(value);
    });
  }
  function year$factory_1() {
    return getPropertyCallableRef('year', 1, KMutableProperty1, function (receiver) {
      return receiver.b1z();
    }, function (receiver, value) {
      return receiver.a1z(value);
    });
  }
  var properties_initialized_DateTimeComponents_kt_io5e5;
  function _init_properties_DateTimeComponents_kt__9iimb5() {
    if (!properties_initialized_DateTimeComponents_kt_io5e5) {
      properties_initialized_DateTimeComponents_kt_io5e5 = true;
      timeZoneField = new GenericFieldSpec(new PropertyAccessor(timeZoneId$factory()));
      emptyDateTimeComponentsContents = new DateTimeComponentsContents();
    }
  }
  function AbstractDateTimeFormat() {
  }
  protoOf(AbstractDateTimeFormat).j23 = function (value) {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.format.AbstractDateTimeFormat.format.<anonymous>' call
    this.d23().p23().q23(this.f23(value), this_0);
    return this_0.toString();
  };
  protoOf(AbstractDateTimeFormat).k23 = function (input) {
    var tmp;
    try {
      tmp = Parser__match$default_impl_x2xlti(_Parser___init__impl__gdyfby(this.d23().r23()), input, this.i23());
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ParseException) {
        var e = $p;
        throw DateTimeFormatException_init_$Create$_2("Failed to parse value from '" + toString(input) + "'", e);
      } else {
        throw $p;
      }
    }
    var matched = tmp;
    try {
      return this.h23(matched);
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e_0 = $p;
        var message = e_0.message;
        throw DateTimeFormatException_init_$Create$_2(message == null ? "The value parsed from '" + toString(input) + "' is invalid" : '' + message + " (when parsing '" + toString(input) + "')", e_0);
      } else {
        throw $p;
      }
    }
  };
  var Padding_NONE_instance;
  var Padding_ZERO_instance;
  var Padding_SPACE_instance;
  var Padding_entriesInitialized;
  function Padding_initEntries() {
    if (Padding_entriesInitialized)
      return Unit_instance;
    Padding_entriesInitialized = true;
    Padding_NONE_instance = new Padding('NONE', 0);
    Padding_ZERO_instance = new Padding('ZERO', 1);
    Padding_SPACE_instance = new Padding('SPACE', 2);
  }
  function Padding(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Padding_NONE_getInstance() {
    Padding_initEntries();
    return Padding_NONE_instance;
  }
  function Padding_ZERO_getInstance() {
    Padding_initEntries();
    return Padding_ZERO_instance;
  }
  function Padding_SPACE_getInstance() {
    Padding_initEntries();
    return Padding_SPACE_instance;
  }
  function WithDate() {
  }
  function WithTime() {
  }
  function WithUtcOffset() {
  }
  function char(_this__u8e3s4, value) {
    return _this__u8e3s4.v20(toString_0(value));
  }
  function optional(_this__u8e3s4, ifZero, format) {
    ifZero = ifZero === VOID ? '' : ifZero;
    var tmp;
    if (isInterface(_this__u8e3s4, AbstractDateTimeFormatBuilder)) {
      _this__u8e3s4.m22(ifZero, typeof format === 'function' ? format : THROW_CCE());
      tmp = Unit_instance;
    } else {
      throw IllegalStateException_init_$Create$('impossible');
    }
    return tmp;
  }
  function alternativeParsing(_this__u8e3s4, alternativeFormats, primaryFormat) {
    var tmp;
    if (isInterface(_this__u8e3s4, AbstractDateTimeFormatBuilder)) {
      var tmp_0 = (isArray(alternativeFormats) ? alternativeFormats : THROW_CCE()).slice();
      _this__u8e3s4.l22(tmp_0, typeof primaryFormat === 'function' ? primaryFormat : THROW_CCE());
      tmp = Unit_instance;
    } else {
      throw IllegalStateException_init_$Create$('impossible');
    }
    return tmp;
  }
  function AbstractDateTimeFormatBuilder() {
  }
  function get_ISO_DATE() {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    // Inline function 'kotlin.getValue' call
    var this_0 = ISO_DATE$delegate;
    ISO_DATE$factory();
    return this_0.v();
  }
  var ISO_DATE$delegate;
  function get_ISO_DATE_BASIC() {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    // Inline function 'kotlin.getValue' call
    var this_0 = ISO_DATE_BASIC$delegate;
    ISO_DATE_BASIC$factory();
    return this_0.v();
  }
  var ISO_DATE_BASIC$delegate;
  function get_emptyIncompleteLocalDate() {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    return emptyIncompleteLocalDate;
  }
  var emptyIncompleteLocalDate;
  function IncompleteLocalDate(year, monthNumber, dayOfMonth, isoDayOfWeek) {
    year = year === VOID ? null : year;
    monthNumber = monthNumber === VOID ? null : monthNumber;
    dayOfMonth = dayOfMonth === VOID ? null : dayOfMonth;
    isoDayOfWeek = isoDayOfWeek === VOID ? null : isoDayOfWeek;
    this.r1y_1 = year;
    this.s1y_1 = monthNumber;
    this.t1y_1 = dayOfMonth;
    this.u1y_1 = isoDayOfWeek;
  }
  protoOf(IncompleteLocalDate).a1z = function (_set____db54di) {
    this.r1y_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDate).b1z = function () {
    return this.r1y_1;
  };
  protoOf(IncompleteLocalDate).y1y = function (_set____db54di) {
    this.s1y_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDate).z1y = function () {
    return this.s1y_1;
  };
  protoOf(IncompleteLocalDate).q1y = function (_set____db54di) {
    this.t1y_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDate).v1y = function () {
    return this.t1y_1;
  };
  protoOf(IncompleteLocalDate).w1y = function (_set____db54di) {
    this.u1y_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDate).x1y = function () {
    return this.u1y_1;
  };
  protoOf(IncompleteLocalDate).x21 = function () {
    var date = LocalDate_init_$Create$(requireParsedField(this.r1y_1, 'year'), requireParsedField(this.s1y_1, 'monthNumber'), requireParsedField(this.t1y_1, 'dayOfMonth'));
    var tmp0_safe_receiver = this.u1y_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(tmp0_safe_receiver === get_isoDayNumber(date.t23()))) {
        throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of week is ' + DayOfWeek(tmp0_safe_receiver).toString() + ' but the date is ' + date.toString() + ', which is a ' + date.t23().toString()));
      }
    }
    return date;
  };
  protoOf(IncompleteLocalDate).h21 = function (date) {
    this.r1y_1 = date.b1z();
    this.s1y_1 = date.z1y();
    this.t1y_1 = date.v1y();
    this.u1y_1 = get_isoDayNumber(date.t23());
  };
  protoOf(IncompleteLocalDate).i20 = function () {
    return new IncompleteLocalDate(this.r1y_1, this.s1y_1, this.t1y_1, this.u1y_1);
  };
  protoOf(IncompleteLocalDate).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof IncompleteLocalDate) {
      tmp_2 = this.r1y_1 == other.r1y_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.s1y_1 == other.s1y_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t1y_1 == other.t1y_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.u1y_1 == other.u1y_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IncompleteLocalDate).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.r1y_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(tmp$ret$0, 31);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.s1y_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    var tmp$ret$1 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
    var tmp_0 = tmp + imul(tmp$ret$1, 31) | 0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_1 = this.t1y_1;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
    var tmp$ret$2 = tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
    var tmp_1 = tmp_0 + imul(tmp$ret$2, 31) | 0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_2 = this.u1y_1;
    var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    var tmp$ret$3 = tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2;
    return tmp_1 + imul(tmp$ret$3, 31) | 0;
  };
  protoOf(IncompleteLocalDate).toString = function () {
    var tmp0_elvis_lhs = this.r1y_1;
    var tmp = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
    var tmp1_elvis_lhs = this.s1y_1;
    var tmp_0 = toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
    var tmp2_elvis_lhs = this.t1y_1;
    var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
    var tmp3_elvis_lhs = this.u1y_1;
    return tmp + '-' + tmp_0 + '-' + tmp_1 + ' (day of week is ' + toString(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs) + ')';
  };
  function Companion_0() {
    Companion_instance_0 = this;
    this.r20_1 = new MonthNames(listOf(['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']));
    this.s20_1 = new MonthNames(listOf(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']));
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function String$toString$ref() {
    var l = function (p0) {
      return toString(p0);
    };
    l.callableName = 'toString';
    return l;
  }
  function MonthNames(names) {
    Companion_getInstance_0();
    this.u23_1 = names;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.u23_1.j() === 12)) {
      // Inline function 'kotlinx.datetime.format.MonthNames.<anonymous>' call
      var message = 'Month names must contain exactly 12 elements';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = get_indices(this.u23_1).g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.datetime.format.MonthNames.<anonymous>' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = this.u23_1.p(element);
      // Inline function 'kotlin.contracts.contract' call
      if (!(charSequenceLength(this_0) > 0)) {
        // Inline function 'kotlinx.datetime.format.MonthNames.<anonymous>.<anonymous>' call
        var message_0 = 'A month name can not be empty';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      var inductionVariable = 0;
      if (inductionVariable < element)
        do {
          var ix2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.contracts.contract' call
          if (!!(this.u23_1.p(element) === this.u23_1.p(ix2))) {
            // Inline function 'kotlinx.datetime.format.MonthNames.<anonymous>.<anonymous>' call
            var message_1 = "Month names must be unique, but '" + this.u23_1.p(element) + "' was repeated";
            throw IllegalArgumentException_init_$Create$(toString(message_1));
          }
        }
         while (inductionVariable < element);
    }
  }
  protoOf(MonthNames).toString = function () {
    return joinToString(this.u23_1, ', ', 'MonthNames(', ')', VOID, VOID, String$toString$ref());
  };
  protoOf(MonthNames).equals = function (other) {
    var tmp;
    if (other instanceof MonthNames) {
      tmp = equals(this.u23_1, other.u23_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(MonthNames).hashCode = function () {
    return hashCode(this.u23_1);
  };
  function Companion_1() {
    Companion_instance_1 = this;
    this.w20_1 = new DayOfWeekNames(listOf(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']));
    this.x20_1 = new DayOfWeekNames(listOf(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']));
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function String$toString$ref_0() {
    var l = function (p0) {
      return toString(p0);
    };
    l.callableName = 'toString';
    return l;
  }
  function DayOfWeekNames(names) {
    Companion_getInstance_1();
    this.v23_1 = names;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.v23_1.j() === 7)) {
      // Inline function 'kotlinx.datetime.format.DayOfWeekNames.<anonymous>' call
      var message = 'Day of week names must contain exactly 7 elements';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = get_indices(this.v23_1).g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.datetime.format.DayOfWeekNames.<anonymous>' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = this.v23_1.p(element);
      // Inline function 'kotlin.contracts.contract' call
      if (!(charSequenceLength(this_0) > 0)) {
        // Inline function 'kotlinx.datetime.format.DayOfWeekNames.<anonymous>.<anonymous>' call
        var message_0 = 'A day-of-week name can not be empty';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      var inductionVariable = 0;
      if (inductionVariable < element)
        do {
          var ix2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.contracts.contract' call
          if (!!(this.v23_1.p(element) === this.v23_1.p(ix2))) {
            // Inline function 'kotlinx.datetime.format.DayOfWeekNames.<anonymous>.<anonymous>' call
            var message_1 = "Day-of-week names must be unique, but '" + this.v23_1.p(element) + "' was repeated";
            throw IllegalArgumentException_init_$Create$(toString(message_1));
          }
        }
         while (inductionVariable < element);
    }
  }
  protoOf(DayOfWeekNames).toString = function () {
    return joinToString(this.v23_1, ', ', 'DayOfWeekNames(', ')', VOID, VOID, String$toString$ref_0());
  };
  protoOf(DayOfWeekNames).equals = function (other) {
    var tmp;
    if (other instanceof DayOfWeekNames) {
      tmp = equals(this.v23_1, other.v23_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DayOfWeekNames).hashCode = function () {
    return hashCode(this.v23_1);
  };
  function Companion_2() {
  }
  protoOf(Companion_2).w23 = function (block) {
    var builder = new Builder_0(new AppendableFormatStructure());
    block(builder);
    return new LocalDateFormat(builder.b21());
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function Builder_0(actualBuilder) {
    this.x23_1 = actualBuilder;
  }
  protoOf(Builder_0).f22 = function () {
    return this.x23_1;
  };
  protoOf(Builder_0).n22 = function (structure) {
    return this.x23_1.i22(structure);
  };
  protoOf(Builder_0).k22 = function () {
    return new Builder_0(new AppendableFormatStructure());
  };
  function LocalDateFormat(actualFormat) {
    AbstractDateTimeFormat.call(this);
    this.y23_1 = actualFormat;
  }
  protoOf(LocalDateFormat).d23 = function () {
    return this.y23_1;
  };
  protoOf(LocalDateFormat).z23 = function (value) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IncompleteLocalDate();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.format.LocalDateFormat.intermediateFromValue.<anonymous>' call
    this_0.h21(value);
    return this_0;
  };
  protoOf(LocalDateFormat).f23 = function (value) {
    return this.z23(value instanceof LocalDate_0 ? value : THROW_CCE());
  };
  protoOf(LocalDateFormat).a24 = function (intermediate) {
    return intermediate.x21();
  };
  protoOf(LocalDateFormat).h23 = function (intermediate) {
    return this.a24(intermediate instanceof IncompleteLocalDate ? intermediate : THROW_CCE());
  };
  protoOf(LocalDateFormat).i23 = function () {
    return get_emptyIncompleteLocalDate();
  };
  function requireParsedField(field, name) {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    if (field == null) {
      throw DateTimeFormatException_init_$Create$_0('Can not create a ' + name + ' from the given input: the field ' + name + ' is missing');
    }
    return field;
  }
  function AbstractWithDateBuilder() {
  }
  function YearDirective(padding, isYearOfEra) {
    isYearOfEra = isYearOfEra === VOID ? false : isYearOfEra;
    var tmp = DateFields_getInstance().b24_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 4 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 4 : null;
    SignedIntFieldFormatDirective.call(this, tmp, tmp_0, null, tmp$ret$1, 4);
    this.k24_1 = padding;
    this.l24_1 = isYearOfEra;
  }
  protoOf(YearDirective).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof YearDirective) {
      tmp_0 = this.k24_1.equals(other.k24_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.l24_1 === other.l24_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(YearDirective).hashCode = function () {
    return imul(this.k24_1.hashCode(), 31) + getBooleanHashCode(this.l24_1) | 0;
  };
  function MonthDirective(padding) {
    var tmp = DateFields_getInstance().c24_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.w24_1 = padding;
  }
  protoOf(MonthDirective).equals = function (other) {
    var tmp;
    if (other instanceof MonthDirective) {
      tmp = this.w24_1.equals(other.w24_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(MonthDirective).hashCode = function () {
    return this.w24_1.hashCode();
  };
  function MonthNameDirective(names) {
    NamedUnsignedIntFieldFormatDirective.call(this, DateFields_getInstance().c24_1, names.u23_1, 'monthName');
    this.e25_1 = names;
  }
  protoOf(MonthNameDirective).equals = function (other) {
    var tmp;
    if (other instanceof MonthNameDirective) {
      tmp = equals(this.e25_1.u23_1, other.e25_1.u23_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(MonthNameDirective).hashCode = function () {
    return hashCode(this.e25_1.u23_1);
  };
  function DayDirective(padding) {
    var tmp = DateFields_getInstance().d24_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.m25_1 = padding;
  }
  protoOf(DayDirective).equals = function (other) {
    var tmp;
    if (other instanceof DayDirective) {
      tmp = this.m25_1.equals(other.m25_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DayDirective).hashCode = function () {
    return this.m25_1.hashCode();
  };
  function DayOfWeekDirective(names) {
    NamedUnsignedIntFieldFormatDirective.call(this, DateFields_getInstance().e24_1, names.v23_1, 'dayOfWeekName');
    this.q25_1 = names;
  }
  protoOf(DayOfWeekDirective).equals = function (other) {
    var tmp;
    if (other instanceof DayOfWeekDirective) {
      tmp = equals(this.q25_1.v23_1, other.q25_1.v23_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DayOfWeekDirective).hashCode = function () {
    return hashCode(this.q25_1.v23_1);
  };
  function DateFields() {
    DateFields_instance = this;
    this.b24_1 = new GenericFieldSpec(new PropertyAccessor(year$factory_2()));
    this.c24_1 = new UnsignedFieldSpec(new PropertyAccessor(monthNumber$factory_0()), 1, 12);
    this.d24_1 = new UnsignedFieldSpec(new PropertyAccessor(dayOfMonth$factory_0()), 1, 31);
    this.e24_1 = new UnsignedFieldSpec(new PropertyAccessor(isoDayOfWeek$factory()), 1, 7);
  }
  var DateFields_instance;
  function DateFields_getInstance() {
    if (DateFields_instance == null)
      new DateFields();
    return DateFields_instance;
  }
  function ISO_DATE$delegate$lambda() {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    var tmp = Companion_instance_2;
    return tmp.w23(ISO_DATE$delegate$lambda$lambda);
  }
  function ISO_DATE$delegate$lambda$lambda($this$build) {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    $this$build.u20();
    char($this$build, _Char___init__impl__6a9atx(45));
    $this$build.r22();
    char($this$build, _Char___init__impl__6a9atx(45));
    $this$build.s22();
    return Unit_instance;
  }
  function ISO_DATE_BASIC$delegate$lambda() {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    var tmp = Companion_instance_2;
    return tmp.w23(ISO_DATE_BASIC$delegate$lambda$lambda);
  }
  function ISO_DATE_BASIC$delegate$lambda$lambda($this$build) {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    $this$build.u20();
    $this$build.r22();
    $this$build.s22();
    return Unit_instance;
  }
  function ISO_DATE$factory() {
    return getPropertyCallableRef('ISO_DATE', 0, KProperty0, function () {
      return get_ISO_DATE();
    }, null);
  }
  function ISO_DATE_BASIC$factory() {
    return getPropertyCallableRef('ISO_DATE_BASIC', 0, KProperty0, function () {
      return get_ISO_DATE_BASIC();
    }, null);
  }
  function year$factory_2() {
    return getPropertyCallableRef('year', 1, KMutableProperty1, function (receiver) {
      return receiver.b1z();
    }, function (receiver, value) {
      return receiver.a1z(value);
    });
  }
  function monthNumber$factory_0() {
    return getPropertyCallableRef('monthNumber', 1, KMutableProperty1, function (receiver) {
      return receiver.z1y();
    }, function (receiver, value) {
      return receiver.y1y(value);
    });
  }
  function dayOfMonth$factory_0() {
    return getPropertyCallableRef('dayOfMonth', 1, KMutableProperty1, function (receiver) {
      return receiver.v1y();
    }, function (receiver, value) {
      return receiver.q1y(value);
    });
  }
  function isoDayOfWeek$factory() {
    return getPropertyCallableRef('isoDayOfWeek', 1, KMutableProperty1, function (receiver) {
      return receiver.x1y();
    }, function (receiver, value) {
      return receiver.w1y(value);
    });
  }
  var properties_initialized_LocalDateFormat_kt_fmnlhc;
  function _init_properties_LocalDateFormat_kt__k1uk9u() {
    if (!properties_initialized_LocalDateFormat_kt_fmnlhc) {
      properties_initialized_LocalDateFormat_kt_fmnlhc = true;
      ISO_DATE$delegate = lazy(ISO_DATE$delegate$lambda);
      ISO_DATE_BASIC$delegate = lazy(ISO_DATE_BASIC$delegate$lambda);
      emptyIncompleteLocalDate = new IncompleteLocalDate();
    }
  }
  function get_ISO_DATETIME() {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    // Inline function 'kotlin.getValue' call
    var this_0 = ISO_DATETIME$delegate;
    ISO_DATETIME$factory();
    return this_0.v();
  }
  var ISO_DATETIME$delegate;
  function get_emptyIncompleteLocalDateTime() {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    return emptyIncompleteLocalDateTime;
  }
  var emptyIncompleteLocalDateTime;
  function Companion_3() {
  }
  protoOf(Companion_3).r25 = function (block) {
    var builder = new Builder_1(new AppendableFormatStructure());
    block(builder);
    return new LocalDateTimeFormat(builder.b21());
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function Builder_1(actualBuilder) {
    this.s25_1 = actualBuilder;
  }
  protoOf(Builder_1).f22 = function () {
    return this.s25_1;
  };
  protoOf(Builder_1).g22 = function (structure) {
    this.s25_1.i22(structure);
  };
  protoOf(Builder_1).k22 = function () {
    return new Builder_1(new AppendableFormatStructure());
  };
  function LocalDateTimeFormat(actualFormat) {
    AbstractDateTimeFormat.call(this);
    this.t25_1 = actualFormat;
  }
  protoOf(LocalDateTimeFormat).d23 = function () {
    return this.t25_1;
  };
  protoOf(LocalDateTimeFormat).u25 = function (value) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IncompleteLocalDateTime();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.format.LocalDateTimeFormat.intermediateFromValue.<anonymous>' call
    this_0.x25(value);
    return this_0;
  };
  protoOf(LocalDateTimeFormat).f23 = function (value) {
    return this.u25(value instanceof LocalDateTime_0 ? value : THROW_CCE());
  };
  protoOf(LocalDateTimeFormat).y25 = function (intermediate) {
    return intermediate.z25();
  };
  protoOf(LocalDateTimeFormat).h23 = function (intermediate) {
    return this.y25(intermediate instanceof IncompleteLocalDateTime ? intermediate : THROW_CCE());
  };
  protoOf(LocalDateTimeFormat).i23 = function () {
    return get_emptyIncompleteLocalDateTime();
  };
  function IncompleteLocalDateTime(date, time) {
    date = date === VOID ? new IncompleteLocalDate() : date;
    time = time === VOID ? new IncompleteLocalTime() : time;
    this.v25_1 = date;
    this.w25_1 = time;
  }
  protoOf(IncompleteLocalDateTime).q1y = function (_set____db54di) {
    this.v25_1.t1y_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).v1y = function () {
    return this.v25_1.t1y_1;
  };
  protoOf(IncompleteLocalDateTime).w1y = function (_set____db54di) {
    this.v25_1.u1y_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).x1y = function () {
    return this.v25_1.u1y_1;
  };
  protoOf(IncompleteLocalDateTime).y1y = function (_set____db54di) {
    this.v25_1.s1y_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).z1y = function () {
    return this.v25_1.s1y_1;
  };
  protoOf(IncompleteLocalDateTime).a1z = function (_set____db54di) {
    this.v25_1.r1y_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).b1z = function () {
    return this.v25_1.r1y_1;
  };
  protoOf(IncompleteLocalDateTime).c1z = function (_set____db54di) {
    this.w25_1.f1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).j1z = function () {
    return this.w25_1.f1z_1;
  };
  protoOf(IncompleteLocalDateTime).k1z = function (value) {
    this.w25_1.k1z(value);
  };
  protoOf(IncompleteLocalDateTime).l1z = function () {
    return this.w25_1.l1z();
  };
  protoOf(IncompleteLocalDateTime).m1z = function (_set____db54di) {
    this.w25_1.d1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).n1z = function () {
    return this.w25_1.d1z_1;
  };
  protoOf(IncompleteLocalDateTime).o1z = function (_set____db54di) {
    this.w25_1.e1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).p1z = function () {
    return this.w25_1.e1z_1;
  };
  protoOf(IncompleteLocalDateTime).q1z = function (_set____db54di) {
    this.w25_1.g1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).r1z = function () {
    return this.w25_1.g1z_1;
  };
  protoOf(IncompleteLocalDateTime).s1z = function (_set____db54di) {
    this.w25_1.i1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).t1z = function () {
    return this.w25_1.i1z_1;
  };
  protoOf(IncompleteLocalDateTime).u1z = function (_set____db54di) {
    this.w25_1.h1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).v1z = function () {
    return this.w25_1.h1z_1;
  };
  protoOf(IncompleteLocalDateTime).z25 = function () {
    return LocalDateTime_init_$Create$(this.v25_1.x21(), this.w25_1.v21());
  };
  protoOf(IncompleteLocalDateTime).x25 = function (dateTime) {
    this.v25_1.h21(dateTime.g21());
    this.w25_1.j21(dateTime.i21());
  };
  protoOf(IncompleteLocalDateTime).i20 = function () {
    return new IncompleteLocalDateTime(this.v25_1.i20(), this.w25_1.i20());
  };
  function AbstractWithDateTimeBuilder() {
  }
  function ISO_DATETIME$delegate$lambda() {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    var tmp = Companion_instance_3;
    return tmp.r25(ISO_DATETIME$delegate$lambda$lambda);
  }
  function ISO_DATETIME$delegate$lambda$lambda($this$build) {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    $this$build.j20(get_ISO_DATE());
    var tmp = [ISO_DATETIME$delegate$lambda$lambda$lambda];
    alternativeParsing($this$build, tmp, ISO_DATETIME$delegate$lambda$lambda$lambda_0);
    $this$build.w22(get_ISO_TIME());
    return Unit_instance;
  }
  function ISO_DATETIME$delegate$lambda$lambda$lambda($this$alternativeParsing) {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    char($this$alternativeParsing, _Char___init__impl__6a9atx(116));
    return Unit_instance;
  }
  function ISO_DATETIME$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    char($this$alternativeParsing, _Char___init__impl__6a9atx(84));
    return Unit_instance;
  }
  function ISO_DATETIME$factory() {
    return getPropertyCallableRef('ISO_DATETIME', 0, KProperty0, function () {
      return get_ISO_DATETIME();
    }, null);
  }
  var properties_initialized_LocalDateTimeFormat_kt_67ys6r;
  function _init_properties_LocalDateTimeFormat_kt__aloigl() {
    if (!properties_initialized_LocalDateTimeFormat_kt_67ys6r) {
      properties_initialized_LocalDateTimeFormat_kt_67ys6r = true;
      ISO_DATETIME$delegate = lazy(ISO_DATETIME$delegate$lambda);
      emptyIncompleteLocalDateTime = new IncompleteLocalDateTime();
    }
  }
  function get_ISO_TIME() {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    // Inline function 'kotlin.getValue' call
    var this_0 = ISO_TIME$delegate;
    ISO_TIME$factory();
    return this_0.v();
  }
  var ISO_TIME$delegate;
  function get_emptyIncompleteLocalTime() {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    return emptyIncompleteLocalTime;
  }
  var emptyIncompleteLocalTime;
  function TimeFieldContainer() {
  }
  function IncompleteLocalTime(hour, hourOfAmPm, amPm, minute, second, nanosecond) {
    hour = hour === VOID ? null : hour;
    hourOfAmPm = hourOfAmPm === VOID ? null : hourOfAmPm;
    amPm = amPm === VOID ? null : amPm;
    minute = minute === VOID ? null : minute;
    second = second === VOID ? null : second;
    nanosecond = nanosecond === VOID ? null : nanosecond;
    this.d1z_1 = hour;
    this.e1z_1 = hourOfAmPm;
    this.f1z_1 = amPm;
    this.g1z_1 = minute;
    this.h1z_1 = second;
    this.i1z_1 = nanosecond;
  }
  protoOf(IncompleteLocalTime).m1z = function (_set____db54di) {
    this.d1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).n1z = function () {
    return this.d1z_1;
  };
  protoOf(IncompleteLocalTime).o1z = function (_set____db54di) {
    this.e1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).p1z = function () {
    return this.e1z_1;
  };
  protoOf(IncompleteLocalTime).c1z = function (_set____db54di) {
    this.f1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).j1z = function () {
    return this.f1z_1;
  };
  protoOf(IncompleteLocalTime).q1z = function (_set____db54di) {
    this.g1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).r1z = function () {
    return this.g1z_1;
  };
  protoOf(IncompleteLocalTime).u1z = function (_set____db54di) {
    this.h1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).v1z = function () {
    return this.h1z_1;
  };
  protoOf(IncompleteLocalTime).s1z = function (_set____db54di) {
    this.i1z_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).t1z = function () {
    return this.i1z_1;
  };
  protoOf(IncompleteLocalTime).v21 = function () {
    var tmp0_safe_receiver = this.d1z_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.format.IncompleteLocalTime.toLocalTime.<anonymous>' call
      var tmp0_safe_receiver_0 = this.e1z_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!((((tmp0_safe_receiver + 11 | 0) % 12 | 0) + 1 | 0) === tmp0_safe_receiver_0)) {
          // Inline function 'kotlinx.datetime.format.IncompleteLocalTime.toLocalTime.<anonymous>.<anonymous>.<anonymous>' call
          var message = 'Inconsistent hour and hour-of-am-pm: hour is ' + tmp0_safe_receiver + ', but hour-of-am-pm is ' + tmp0_safe_receiver_0;
          throw IllegalArgumentException_init_$Create$(toString(message));
        }
      }
      var tmp1_safe_receiver = this.f1z_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(tmp1_safe_receiver.equals(AmPmMarker_PM_getInstance()) === tmp0_safe_receiver >= 12)) {
          // Inline function 'kotlinx.datetime.format.IncompleteLocalTime.toLocalTime.<anonymous>.<anonymous>.<anonymous>' call
          var message_0 = 'Inconsistent hour and the AM/PM marker: hour is ' + tmp0_safe_receiver + ', but the AM/PM marker is ' + tmp1_safe_receiver.toString();
          throw IllegalArgumentException_init_$Create$(toString(message_0));
        }
      }
      tmp = tmp0_safe_receiver;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver_0 = this.e1z_1;
      var tmp_1;
      if (tmp1_safe_receiver_0 == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.datetime.format.IncompleteLocalTime.toLocalTime.<anonymous>' call
        var tmp0_safe_receiver_1 = this.f1z_1;
        var tmp_2;
        if (tmp0_safe_receiver_1 == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlinx.datetime.format.IncompleteLocalTime.toLocalTime.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlinx.datetime.format.IncompleteLocalTime.toLocalTime.<anonymous>.<anonymous>.<anonymous>' call
          tmp_2 = (tmp1_safe_receiver_0 === 12 ? 0 : tmp1_safe_receiver_0) + (tmp0_safe_receiver_1.equals(AmPmMarker_PM_getInstance()) ? 12 : 0) | 0;
        }
        tmp_1 = tmp_2;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_0;
    var tmp_3;
    if (tmp3_elvis_lhs == null) {
      throw DateTimeFormatException_init_$Create$_0('Incomplete time: missing hour');
    } else {
      tmp_3 = tmp3_elvis_lhs;
    }
    var hour = tmp_3;
    var tmp_4 = requireParsedField(this.g1z_1, 'minute');
    var tmp4_elvis_lhs = this.h1z_1;
    var tmp_5 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
    var tmp5_elvis_lhs = this.i1z_1;
    return LocalTime_init_$Create$(hour, tmp_4, tmp_5, tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs);
  };
  protoOf(IncompleteLocalTime).j21 = function (localTime) {
    this.d1z_1 = localTime.n1z();
    this.e1z_1 = ((localTime.n1z() + 11 | 0) % 12 | 0) + 1 | 0;
    this.f1z_1 = localTime.n1z() >= 12 ? AmPmMarker_PM_getInstance() : AmPmMarker_AM_getInstance();
    this.g1z_1 = localTime.r1z();
    this.h1z_1 = localTime.v1z();
    this.i1z_1 = localTime.t1z();
  };
  protoOf(IncompleteLocalTime).i20 = function () {
    return new IncompleteLocalTime(this.d1z_1, this.e1z_1, this.f1z_1, this.g1z_1, this.h1z_1, this.i1z_1);
  };
  protoOf(IncompleteLocalTime).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    if (other instanceof IncompleteLocalTime) {
      tmp_4 = this.d1z_1 == other.d1z_1;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.e1z_1 == other.e1z_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = equals(this.f1z_1, other.f1z_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.g1z_1 == other.g1z_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.h1z_1 == other.h1z_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.i1z_1 == other.i1z_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IncompleteLocalTime).hashCode = function () {
    var tmp6_elvis_lhs = this.d1z_1;
    var tmp = imul(tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs, 31);
    var tmp5_elvis_lhs = this.e1z_1;
    var tmp_0 = tmp + imul(tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs, 31) | 0;
    var tmp3_safe_receiver = this.f1z_1;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.hashCode();
    var tmp_1 = tmp_0 + imul(tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs, 31) | 0;
    var tmp2_elvis_lhs = this.g1z_1;
    var tmp_2 = tmp_1 + imul(tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs, 31) | 0;
    var tmp1_elvis_lhs = this.h1z_1;
    var tmp_3 = tmp_2 + imul(tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs, 31) | 0;
    var tmp0_elvis_lhs = this.i1z_1;
    return tmp_3 + (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) | 0;
  };
  protoOf(IncompleteLocalTime).toString = function () {
    var tmp0_elvis_lhs = this.d1z_1;
    var tmp = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
    var tmp1_elvis_lhs = this.g1z_1;
    var tmp_0 = toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
    var tmp2_elvis_lhs = this.h1z_1;
    var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
    var tmp3_safe_receiver = this.i1z_1;
    var tmp_2;
    if (tmp3_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.format.IncompleteLocalTime.toString.<anonymous>' call
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.format.IncompleteLocalTime.toString.<anonymous>.<anonymous>' call
      var it = tmp3_safe_receiver.toString();
      tmp_2 = padStart(it, 9 - it.length | 0, _Char___init__impl__6a9atx(48));
    }
    var tmp4_elvis_lhs = tmp_2;
    return tmp + ':' + tmp_0 + ':' + tmp_1 + '.' + (tmp4_elvis_lhs == null ? '???' : tmp4_elvis_lhs);
  };
  var AmPmMarker_AM_instance;
  var AmPmMarker_PM_instance;
  var AmPmMarker_entriesInitialized;
  function AmPmMarker_initEntries() {
    if (AmPmMarker_entriesInitialized)
      return Unit_instance;
    AmPmMarker_entriesInitialized = true;
    AmPmMarker_AM_instance = new AmPmMarker('AM', 0);
    AmPmMarker_PM_instance = new AmPmMarker('PM', 1);
  }
  function AmPmMarker(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_4() {
  }
  protoOf(Companion_4).d26 = function (block) {
    var builder = new Builder_2(new AppendableFormatStructure());
    block(builder);
    return new LocalTimeFormat(builder.b21());
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function Builder_2(actualBuilder) {
    this.e26_1 = actualBuilder;
  }
  protoOf(Builder_2).f22 = function () {
    return this.e26_1;
  };
  protoOf(Builder_2).o22 = function (structure) {
    this.e26_1.i22(structure);
  };
  protoOf(Builder_2).k22 = function () {
    return new Builder_2(new AppendableFormatStructure());
  };
  function LocalTimeFormat(actualFormat) {
    AbstractDateTimeFormat.call(this);
    this.f26_1 = actualFormat;
  }
  protoOf(LocalTimeFormat).d23 = function () {
    return this.f26_1;
  };
  protoOf(LocalTimeFormat).g26 = function (value) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IncompleteLocalTime();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.format.LocalTimeFormat.intermediateFromValue.<anonymous>' call
    this_0.j21(value);
    return this_0;
  };
  protoOf(LocalTimeFormat).f23 = function (value) {
    return this.g26(value instanceof LocalTime_0 ? value : THROW_CCE());
  };
  protoOf(LocalTimeFormat).h26 = function (intermediate) {
    return intermediate.v21();
  };
  protoOf(LocalTimeFormat).h23 = function (intermediate) {
    return this.h26(intermediate instanceof IncompleteLocalTime ? intermediate : THROW_CCE());
  };
  protoOf(LocalTimeFormat).i23 = function () {
    return get_emptyIncompleteLocalTime();
  };
  function AbstractWithTimeBuilder() {
  }
  function HourDirective(padding) {
    var tmp = TimeFields_getInstance().i26_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.s26_1 = padding;
  }
  protoOf(HourDirective).equals = function (other) {
    var tmp;
    if (other instanceof HourDirective) {
      tmp = this.s26_1.equals(other.s26_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(HourDirective).hashCode = function () {
    return this.s26_1.hashCode();
  };
  function MinuteDirective(padding) {
    var tmp = TimeFields_getInstance().j26_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.x26_1 = padding;
  }
  protoOf(MinuteDirective).equals = function (other) {
    var tmp;
    if (other instanceof MinuteDirective) {
      tmp = this.x26_1.equals(other.x26_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(MinuteDirective).hashCode = function () {
    return this.x26_1.hashCode();
  };
  function SecondDirective(padding) {
    var tmp = TimeFields_getInstance().k26_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.c27_1 = padding;
  }
  protoOf(SecondDirective).equals = function (other) {
    var tmp;
    if (other instanceof SecondDirective) {
      tmp = this.c27_1.equals(other.c27_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SecondDirective).hashCode = function () {
    return this.c27_1.hashCode();
  };
  function Companion_5() {
    Companion_instance_5 = this;
    this.d27_1 = listOf([0, 0, 0, 0, 0, 0, 0, 0, 0]);
    this.e27_1 = listOf([2, 1, 0, 2, 1, 0, 2, 1, 0]);
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function FractionalSecondDirective(minDigits, maxDigits, zerosToAdd) {
    Companion_getInstance_5();
    zerosToAdd = zerosToAdd === VOID ? Companion_getInstance_5().d27_1 : zerosToAdd;
    DecimalFractionFieldFormatDirective.call(this, TimeFields_getInstance().l26_1, minDigits, maxDigits, zerosToAdd);
    this.j27_1 = minDigits;
    this.k27_1 = maxDigits;
  }
  protoOf(FractionalSecondDirective).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof FractionalSecondDirective) {
      tmp_0 = this.j27_1 === other.j27_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.k27_1 === other.k27_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(FractionalSecondDirective).hashCode = function () {
    return imul(31, this.j27_1) + this.k27_1 | 0;
  };
  function TimeFields() {
    TimeFields_instance = this;
    this.i26_1 = new UnsignedFieldSpec(new PropertyAccessor(hour$factory_0()), 0, 23);
    this.j26_1 = new UnsignedFieldSpec(new PropertyAccessor(minute$factory_0()), 0, 59);
    this.k26_1 = new UnsignedFieldSpec(new PropertyAccessor(second$factory_0()), 0, 59, VOID, 0);
    this.l26_1 = new GenericFieldSpec(new PropertyAccessor(fractionOfSecond$factory()), VOID, new DecimalFraction(0, 9));
    this.m26_1 = new GenericFieldSpec(new PropertyAccessor(amPm$factory_0()));
    this.n26_1 = new UnsignedFieldSpec(new PropertyAccessor(hourOfAmPm$factory_0()), 1, 12);
  }
  var TimeFields_instance;
  function TimeFields_getInstance() {
    if (TimeFields_instance == null)
      new TimeFields();
    return TimeFields_instance;
  }
  function ISO_TIME$delegate$lambda() {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    var tmp = Companion_instance_4;
    return tmp.d26(ISO_TIME$delegate$lambda$lambda);
  }
  function ISO_TIME$delegate$lambda$lambda($this$build) {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    $this$build.k20();
    char($this$build, _Char___init__impl__6a9atx(58));
    $this$build.l20();
    var tmp = [ISO_TIME$delegate$lambda$lambda$lambda];
    alternativeParsing($this$build, tmp, ISO_TIME$delegate$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function ISO_TIME$delegate$lambda$lambda$lambda($this$alternativeParsing) {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    return Unit_instance;
  }
  function ISO_TIME$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    char($this$alternativeParsing, _Char___init__impl__6a9atx(58));
    $this$alternativeParsing.m20();
    optional($this$alternativeParsing, VOID, ISO_TIME$delegate$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_TIME$delegate$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    char($this$optional, _Char___init__impl__6a9atx(46));
    $this$optional.n20(1, 9);
    return Unit_instance;
  }
  function AmPmMarker_AM_getInstance() {
    AmPmMarker_initEntries();
    return AmPmMarker_AM_instance;
  }
  function AmPmMarker_PM_getInstance() {
    AmPmMarker_initEntries();
    return AmPmMarker_PM_instance;
  }
  function ISO_TIME$factory() {
    return getPropertyCallableRef('ISO_TIME', 0, KProperty0, function () {
      return get_ISO_TIME();
    }, null);
  }
  function hour$factory_0() {
    return getPropertyCallableRef('hour', 1, KMutableProperty1, function (receiver) {
      return receiver.n1z();
    }, function (receiver, value) {
      return receiver.m1z(value);
    });
  }
  function minute$factory_0() {
    return getPropertyCallableRef('minute', 1, KMutableProperty1, function (receiver) {
      return receiver.r1z();
    }, function (receiver, value) {
      return receiver.q1z(value);
    });
  }
  function second$factory_0() {
    return getPropertyCallableRef('second', 1, KMutableProperty1, function (receiver) {
      return receiver.v1z();
    }, function (receiver, value) {
      return receiver.u1z(value);
    });
  }
  function fractionOfSecond$factory() {
    return getPropertyCallableRef('fractionOfSecond', 1, KMutableProperty1, function (receiver) {
      return receiver.l1z();
    }, function (receiver, value) {
      return receiver.k1z(value);
    });
  }
  function amPm$factory_0() {
    return getPropertyCallableRef('amPm', 1, KMutableProperty1, function (receiver) {
      return receiver.j1z();
    }, function (receiver, value) {
      return receiver.c1z(value);
    });
  }
  function hourOfAmPm$factory_0() {
    return getPropertyCallableRef('hourOfAmPm', 1, KMutableProperty1, function (receiver) {
      return receiver.p1z();
    }, function (receiver, value) {
      return receiver.o1z(value);
    });
  }
  var properties_initialized_LocalTimeFormat_kt_l1b0w1;
  function _init_properties_LocalTimeFormat_kt__5i3lfh() {
    if (!properties_initialized_LocalTimeFormat_kt_l1b0w1) {
      properties_initialized_LocalTimeFormat_kt_l1b0w1 = true;
      ISO_TIME$delegate = lazy(ISO_TIME$delegate$lambda);
      emptyIncompleteLocalTime = new IncompleteLocalTime();
    }
  }
  function get_ISO_OFFSET() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    // Inline function 'kotlin.getValue' call
    var this_0 = ISO_OFFSET$delegate;
    ISO_OFFSET$factory();
    return this_0.v();
  }
  var ISO_OFFSET$delegate;
  function get_ISO_OFFSET_BASIC() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    // Inline function 'kotlin.getValue' call
    var this_0 = ISO_OFFSET_BASIC$delegate;
    ISO_OFFSET_BASIC$factory();
    return this_0.v();
  }
  var ISO_OFFSET_BASIC$delegate;
  function get_FOUR_DIGIT_OFFSET() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    // Inline function 'kotlin.getValue' call
    var this_0 = FOUR_DIGIT_OFFSET$delegate;
    FOUR_DIGIT_OFFSET$factory();
    return this_0.v();
  }
  var FOUR_DIGIT_OFFSET$delegate;
  function get_emptyIncompleteUtcOffset() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    return emptyIncompleteUtcOffset;
  }
  var emptyIncompleteUtcOffset;
  function UtcOffsetFieldContainer() {
  }
  function IncompleteUtcOffset(isNegative, totalHoursAbs, minutesOfHour, secondsOfMinute) {
    isNegative = isNegative === VOID ? null : isNegative;
    totalHoursAbs = totalHoursAbs === VOID ? null : totalHoursAbs;
    minutesOfHour = minutesOfHour === VOID ? null : minutesOfHour;
    secondsOfMinute = secondsOfMinute === VOID ? null : secondsOfMinute;
    this.x1z_1 = isNegative;
    this.y1z_1 = totalHoursAbs;
    this.z1z_1 = minutesOfHour;
    this.a20_1 = secondsOfMinute;
  }
  protoOf(IncompleteUtcOffset).w1z = function (_set____db54di) {
    this.x1z_1 = _set____db54di;
  };
  protoOf(IncompleteUtcOffset).b20 = function () {
    return this.x1z_1;
  };
  protoOf(IncompleteUtcOffset).g20 = function (_set____db54di) {
    this.y1z_1 = _set____db54di;
  };
  protoOf(IncompleteUtcOffset).h20 = function () {
    return this.y1z_1;
  };
  protoOf(IncompleteUtcOffset).c20 = function (_set____db54di) {
    this.z1z_1 = _set____db54di;
  };
  protoOf(IncompleteUtcOffset).d20 = function () {
    return this.z1z_1;
  };
  protoOf(IncompleteUtcOffset).e20 = function (_set____db54di) {
    this.a20_1 = _set____db54di;
  };
  protoOf(IncompleteUtcOffset).f20 = function () {
    return this.a20_1;
  };
  protoOf(IncompleteUtcOffset).u21 = function () {
    var sign = this.x1z_1 === true ? -1 : 1;
    var tmp0_safe_receiver = this.y1z_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.format.IncompleteUtcOffset.toUtcOffset.<anonymous>' call
      tmp = imul(tmp0_safe_receiver, sign);
    }
    var tmp_0 = tmp;
    var tmp1_safe_receiver = this.z1z_1;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.format.IncompleteUtcOffset.toUtcOffset.<anonymous>' call
      tmp_1 = imul(tmp1_safe_receiver, sign);
    }
    var tmp_2 = tmp_1;
    var tmp2_safe_receiver = this.a20_1;
    var tmp_3;
    if (tmp2_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.format.IncompleteUtcOffset.toUtcOffset.<anonymous>' call
      tmp_3 = imul(tmp2_safe_receiver, sign);
    }
    return UtcOffset_0(tmp_0, tmp_2, tmp_3);
  };
  protoOf(IncompleteUtcOffset).l21 = function (offset) {
    this.x1z_1 = offset.d22() < 0;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = offset.d22();
    var totalSecondsAbs = abs(this_0);
    this.y1z_1 = totalSecondsAbs / 3600 | 0;
    this.z1z_1 = (totalSecondsAbs / 60 | 0) % 60 | 0;
    this.a20_1 = totalSecondsAbs % 60 | 0;
  };
  protoOf(IncompleteUtcOffset).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof IncompleteUtcOffset) {
      tmp_2 = this.x1z_1 == other.x1z_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.y1z_1 == other.y1z_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.z1z_1 == other.z1z_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.a20_1 == other.a20_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IncompleteUtcOffset).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.x1z_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.y1z_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    var tmp_0 = tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_1 = this.z1z_1;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
    var tmp_1 = tmp_0 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_2 = this.a20_1;
    var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    return tmp_1 + (tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2) | 0;
  };
  protoOf(IncompleteUtcOffset).i20 = function () {
    return new IncompleteUtcOffset(this.x1z_1, this.y1z_1, this.z1z_1, this.a20_1);
  };
  protoOf(IncompleteUtcOffset).toString = function () {
    var tmp0_safe_receiver = this.x1z_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.format.IncompleteUtcOffset.toString.<anonymous>' call
      tmp = tmp0_safe_receiver ? '-' : '+';
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0 = tmp1_elvis_lhs == null ? ' ' : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = this.y1z_1;
    var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
    var tmp3_elvis_lhs = this.z1z_1;
    var tmp_2 = toString(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs);
    var tmp4_elvis_lhs = this.a20_1;
    return tmp_0 + tmp_1 + ':' + tmp_2 + ':' + toString(tmp4_elvis_lhs == null ? '??' : tmp4_elvis_lhs);
  };
  function UtcOffsetWholeHoursDirective(padding) {
    var tmp = OffsetFields_getInstance().q27_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.x27_1 = padding;
  }
  protoOf(UtcOffsetWholeHoursDirective).equals = function (other) {
    var tmp;
    if (other instanceof UtcOffsetWholeHoursDirective) {
      tmp = this.x27_1.equals(other.x27_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(UtcOffsetWholeHoursDirective).hashCode = function () {
    return this.x27_1.hashCode();
  };
  function Companion_6() {
  }
  protoOf(Companion_6).y27 = function (block) {
    var builder = new Builder_3(new AppendableFormatStructure());
    block(builder);
    return new UtcOffsetFormat(builder.b21());
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function Builder_3(actualBuilder) {
    this.z27_1 = actualBuilder;
  }
  protoOf(Builder_3).f22 = function () {
    return this.z27_1;
  };
  protoOf(Builder_3).j22 = function (structure) {
    this.z27_1.i22(structure);
  };
  protoOf(Builder_3).k22 = function () {
    return new Builder_3(new AppendableFormatStructure());
  };
  function UtcOffsetFormat(actualFormat) {
    AbstractDateTimeFormat.call(this);
    this.a28_1 = actualFormat;
  }
  protoOf(UtcOffsetFormat).d23 = function () {
    return this.a28_1;
  };
  protoOf(UtcOffsetFormat).b28 = function (value) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IncompleteUtcOffset();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.format.UtcOffsetFormat.intermediateFromValue.<anonymous>' call
    this_0.l21(value);
    return this_0;
  };
  protoOf(UtcOffsetFormat).f23 = function (value) {
    return this.b28(value instanceof UtcOffset ? value : THROW_CCE());
  };
  protoOf(UtcOffsetFormat).c28 = function (intermediate) {
    return intermediate.u21();
  };
  protoOf(UtcOffsetFormat).h23 = function (intermediate) {
    return this.c28(intermediate instanceof IncompleteUtcOffset ? intermediate : THROW_CCE());
  };
  protoOf(UtcOffsetFormat).i23 = function () {
    return get_emptyIncompleteUtcOffset();
  };
  function OffsetFields$sign$1() {
    this.d28_1 = new PropertyAccessor(isNegative$factory_0());
  }
  protoOf(OffsetFields$sign$1).b20 = function () {
    return this.d28_1;
  };
  protoOf(OffsetFields$sign$1).e28 = function (obj) {
    var tmp;
    var tmp_0;
    var tmp0_elvis_lhs = obj.h20();
    if ((tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) === 0) {
      var tmp1_elvis_lhs = obj.d20();
      tmp_0 = (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) === 0;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp2_elvis_lhs = obj.f20();
      tmp = (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) === 0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OffsetFields$sign$1).f28 = function (obj) {
    return this.e28((!(obj == null) ? isInterface(obj, UtcOffsetFieldContainer) : false) ? obj : THROW_CCE());
  };
  function OffsetFields() {
    OffsetFields_instance = this;
    var tmp = this;
    tmp.p27_1 = new OffsetFields$sign$1();
    var tmp_0 = this;
    var tmp0_accessor = new PropertyAccessor(totalHoursAbs$factory_0());
    var tmp1_sign = this.p27_1;
    tmp_0.q27_1 = new UnsignedFieldSpec(tmp0_accessor, 0, 18, VOID, 0, tmp1_sign);
    var tmp_1 = this;
    var tmp0_accessor_0 = new PropertyAccessor(minutesOfHour$factory_0());
    var tmp1_sign_0 = this.p27_1;
    tmp_1.r27_1 = new UnsignedFieldSpec(tmp0_accessor_0, 0, 59, VOID, 0, tmp1_sign_0);
    var tmp_2 = this;
    var tmp0_accessor_1 = new PropertyAccessor(secondsOfMinute$factory_0());
    var tmp1_sign_1 = this.p27_1;
    tmp_2.s27_1 = new UnsignedFieldSpec(tmp0_accessor_1, 0, 59, VOID, 0, tmp1_sign_1);
  }
  var OffsetFields_instance;
  function OffsetFields_getInstance() {
    if (OffsetFields_instance == null)
      new OffsetFields();
    return OffsetFields_instance;
  }
  function AbstractWithOffsetBuilder() {
  }
  function UtcOffsetMinuteOfHourDirective(padding) {
    var tmp = OffsetFields_getInstance().r27_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.k28_1 = padding;
  }
  protoOf(UtcOffsetMinuteOfHourDirective).equals = function (other) {
    var tmp;
    if (other instanceof UtcOffsetMinuteOfHourDirective) {
      tmp = this.k28_1.equals(other.k28_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(UtcOffsetMinuteOfHourDirective).hashCode = function () {
    return this.k28_1.hashCode();
  };
  function UtcOffsetSecondOfMinuteDirective(padding) {
    var tmp = OffsetFields_getInstance().s27_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.p28_1 = padding;
  }
  protoOf(UtcOffsetSecondOfMinuteDirective).equals = function (other) {
    var tmp;
    if (other instanceof UtcOffsetSecondOfMinuteDirective) {
      tmp = this.p28_1.equals(other.p28_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(UtcOffsetSecondOfMinuteDirective).hashCode = function () {
    return this.p28_1.hashCode();
  };
  function ISO_OFFSET$delegate$lambda() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp = Companion_instance_6;
    return tmp.y27(ISO_OFFSET$delegate$lambda$lambda);
  }
  function ISO_OFFSET$delegate$lambda$lambda($this$build) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp = [ISO_OFFSET$delegate$lambda$lambda$lambda];
    alternativeParsing($this$build, tmp, ISO_OFFSET$delegate$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function ISO_OFFSET$delegate$lambda$lambda$lambda($this$alternativeParsing) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$alternativeParsing.v20('z');
    return Unit_instance;
  }
  function ISO_OFFSET$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    optional($this$alternativeParsing, 'Z', ISO_OFFSET$delegate$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_OFFSET$delegate$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$optional.o20();
    char($this$optional, _Char___init__impl__6a9atx(58));
    $this$optional.z22();
    optional($this$optional, VOID, ISO_OFFSET$delegate$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_OFFSET$delegate$lambda$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    char($this$optional, _Char___init__impl__6a9atx(58));
    $this$optional.b23();
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp = Companion_instance_6;
    return tmp.y27(ISO_OFFSET_BASIC$delegate$lambda$lambda);
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda($this$build) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp = [ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda];
    alternativeParsing($this$build, tmp, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda($this$alternativeParsing) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$alternativeParsing.v20('z');
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    optional($this$alternativeParsing, 'Z', ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$optional.o20();
    optional($this$optional, VOID, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$optional.z22();
    optional($this$optional, VOID, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$optional.b23();
    return Unit_instance;
  }
  function FOUR_DIGIT_OFFSET$delegate$lambda() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp = Companion_instance_6;
    return tmp.y27(FOUR_DIGIT_OFFSET$delegate$lambda$lambda);
  }
  function FOUR_DIGIT_OFFSET$delegate$lambda$lambda($this$build) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$build.o20();
    $this$build.z22();
    return Unit_instance;
  }
  function ISO_OFFSET$factory() {
    return getPropertyCallableRef('ISO_OFFSET', 0, KProperty0, function () {
      return get_ISO_OFFSET();
    }, null);
  }
  function ISO_OFFSET_BASIC$factory() {
    return getPropertyCallableRef('ISO_OFFSET_BASIC', 0, KProperty0, function () {
      return get_ISO_OFFSET_BASIC();
    }, null);
  }
  function FOUR_DIGIT_OFFSET$factory() {
    return getPropertyCallableRef('FOUR_DIGIT_OFFSET', 0, KProperty0, function () {
      return get_FOUR_DIGIT_OFFSET();
    }, null);
  }
  function totalHoursAbs$factory_0() {
    return getPropertyCallableRef('totalHoursAbs', 1, KMutableProperty1, function (receiver) {
      return receiver.h20();
    }, function (receiver, value) {
      return receiver.g20(value);
    });
  }
  function minutesOfHour$factory_0() {
    return getPropertyCallableRef('minutesOfHour', 1, KMutableProperty1, function (receiver) {
      return receiver.d20();
    }, function (receiver, value) {
      return receiver.c20(value);
    });
  }
  function secondsOfMinute$factory_0() {
    return getPropertyCallableRef('secondsOfMinute', 1, KMutableProperty1, function (receiver) {
      return receiver.f20();
    }, function (receiver, value) {
      return receiver.e20(value);
    });
  }
  function isNegative$factory_0() {
    return getPropertyCallableRef('isNegative', 1, KMutableProperty1, function (receiver) {
      return receiver.b20();
    }, function (receiver, value) {
      return receiver.w1z(value);
    });
  }
  var properties_initialized_UtcOffsetFormat_kt_6y9jku;
  function _init_properties_UtcOffsetFormat_kt__9r9ddw() {
    if (!properties_initialized_UtcOffsetFormat_kt_6y9jku) {
      properties_initialized_UtcOffsetFormat_kt_6y9jku = true;
      ISO_OFFSET$delegate = lazy(ISO_OFFSET$delegate$lambda);
      ISO_OFFSET_BASIC$delegate = lazy(ISO_OFFSET_BASIC$delegate$lambda);
      FOUR_DIGIT_OFFSET$delegate = lazy(FOUR_DIGIT_OFFSET$delegate$lambda);
      emptyIncompleteUtcOffset = new IncompleteUtcOffset();
    }
  }
  function AppendableFormatStructure() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.h22_1 = ArrayList_init_$Create$_0();
  }
  protoOf(AppendableFormatStructure).b21 = function () {
    return new ConcatenatedFormatStructure(this.h22_1);
  };
  protoOf(AppendableFormatStructure).i22 = function (format) {
    if (isInterface(format, NonConcatenatedFormatStructure)) {
      this.h22_1.e(format);
    } else {
      if (format instanceof ConcatenatedFormatStructure) {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = format.s23_1.g();
        while (tmp0_iterator.h()) {
          var element = tmp0_iterator.i();
          // Inline function 'kotlinx.datetime.internal.format.AppendableFormatStructure.add.<anonymous>' call
          this.h22_1.e(element);
        }
      }
    }
  };
  function Accessor$getterNotNull$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.q28(p0);
    };
    l.callableName = 'getterNotNull';
    return l;
  }
  function SignedIntFieldFormatDirective(field, minDigits, maxDigits, spacePadding, outputPlusOnExceededWidth) {
    this.m24_1 = field;
    this.n24_1 = minDigits;
    this.o24_1 = maxDigits;
    this.p24_1 = spacePadding;
    this.q24_1 = outputPlusOnExceededWidth;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.n24_1 == null || this.n24_1 >= 0)) {
      // Inline function 'kotlinx.datetime.internal.format.SignedIntFieldFormatDirective.<anonymous>' call
      var message = 'The minimum number of digits (' + this.n24_1 + ') is negative';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.o24_1 == null || this.n24_1 == null || this.o24_1 >= this.n24_1)) {
      // Inline function 'kotlinx.datetime.internal.format.SignedIntFieldFormatDirective.<anonymous>' call
      var message_0 = 'The maximum number of digits (' + this.o24_1 + ') is less than the minimum number of digits (' + this.n24_1 + ')';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  protoOf(SignedIntFieldFormatDirective).r24 = function () {
    return this.m24_1;
  };
  protoOf(SignedIntFieldFormatDirective).p23 = function () {
    var tmp = Accessor$getterNotNull$ref(this.m24_1.r28());
    var tmp0_elvis_lhs = this.n24_1;
    var formatter = new SignedIntFormatterStructure(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, this.q24_1);
    return !(this.p24_1 == null) ? new SpacePaddedFormatter(formatter, this.p24_1) : formatter;
  };
  protoOf(SignedIntFieldFormatDirective).r23 = function () {
    return SignedIntParser(this.n24_1, this.o24_1, this.p24_1, this.m24_1.r28(), this.m24_1.s28(), this.q24_1);
  };
  function Accessor$getterNotNull$ref_0($boundThis) {
    var l = function (p0) {
      return $boundThis.q28(p0);
    };
    l.callableName = 'getterNotNull';
    return l;
  }
  function UnsignedIntFieldFormatDirective(field, minDigits, spacePadding) {
    this.x24_1 = field;
    this.y24_1 = minDigits;
    this.z24_1 = spacePadding;
    this.a25_1 = this.x24_1.z28_1;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.y24_1 >= 0)) {
      // Inline function 'kotlinx.datetime.internal.format.UnsignedIntFieldFormatDirective.<anonymous>' call
      var message = 'The minimum number of digits (' + this.y24_1 + ') is negative';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.a25_1 >= this.y24_1)) {
      // Inline function 'kotlinx.datetime.internal.format.UnsignedIntFieldFormatDirective.<anonymous>' call
      var message_0 = 'The maximum number of digits (' + this.a25_1 + ') is less than the minimum number of digits (' + this.y24_1 + ')';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    if (!(this.z24_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.z24_1 > this.y24_1)) {
        // Inline function 'kotlinx.datetime.internal.format.UnsignedIntFieldFormatDirective.<anonymous>' call
        var message_1 = 'The space padding (' + this.z24_1 + ') should be more than the minimum number of digits (' + this.y24_1 + ')';
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }
    }
  }
  protoOf(UnsignedIntFieldFormatDirective).r24 = function () {
    return this.x24_1;
  };
  protoOf(UnsignedIntFieldFormatDirective).p23 = function () {
    var formatter = new UnsignedIntFormatterStructure(Accessor$getterNotNull$ref_0(this.x24_1.t28_1), this.y24_1);
    return !(this.z24_1 == null) ? new SpacePaddedFormatter(formatter, this.z24_1) : formatter;
  };
  protoOf(UnsignedIntFieldFormatDirective).r23 = function () {
    return spaceAndZeroPaddedUnsignedInt(this.y24_1, this.a25_1, this.z24_1, this.x24_1.t28_1, this.x24_1.w28_1);
  };
  function getStringValue($this, target) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.internal.format.NamedUnsignedIntFieldFormatDirective.getStringValue.<anonymous>' call
    var it = $this.f25_1.t28_1.q28(target);
    var tmp0_elvis_lhs = getOrNull($this.g25_1, it - $this.f25_1.u28_1 | 0);
    return tmp0_elvis_lhs == null ? 'The value ' + it + ' of ' + $this.f25_1.w28_1 + ' does not have a corresponding string representation' : tmp0_elvis_lhs;
  }
  function AssignableString($outer) {
    this.a29_1 = $outer;
  }
  protoOf(AssignableString).b29 = function (container, newValue) {
    var tmp0_safe_receiver = this.a29_1.f25_1.t28_1.c29(container, this.a29_1.g25_1.s(newValue) + this.a29_1.f25_1.u28_1 | 0);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.internal.format.AssignableString.trySetWithoutReassigning.<anonymous>' call
      tmp = this.a29_1.g25_1.p(tmp0_safe_receiver - this.a29_1.f25_1.u28_1 | 0);
    }
    return tmp;
  };
  protoOf(AssignableString).c29 = function (container, newValue) {
    var tmp = (container == null ? true : !(container == null)) ? container : THROW_CCE();
    return this.b29(tmp, (!(newValue == null) ? typeof newValue === 'string' : false) ? newValue : THROW_CCE());
  };
  protoOf(AssignableString).s28 = function () {
    return this.a29_1.h25_1;
  };
  function NamedUnsignedIntFieldFormatDirective$getStringValue$ref($boundThis) {
    var l = function (p0) {
      return getStringValue($boundThis, p0);
    };
    l.callableName = 'getStringValue';
    return l;
  }
  function NamedUnsignedIntFieldFormatDirective(field, values, name) {
    this.f25_1 = field;
    this.g25_1 = values;
    this.h25_1 = name;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.g25_1.j() === ((this.f25_1.v28_1 - this.f25_1.u28_1 | 0) + 1 | 0))) {
      // Inline function 'kotlinx.datetime.internal.format.NamedUnsignedIntFieldFormatDirective.<anonymous>' call
      var message = 'The number of values (' + this.g25_1.j() + ') in ' + toString(this.g25_1) + ' does not match the range of the field (' + ((this.f25_1.v28_1 - this.f25_1.u28_1 | 0) + 1 | 0) + ')';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(NamedUnsignedIntFieldFormatDirective).r24 = function () {
    return this.f25_1;
  };
  protoOf(NamedUnsignedIntFieldFormatDirective).p23 = function () {
    return new StringFormatterStructure(NamedUnsignedIntFieldFormatDirective$getStringValue$ref(this));
  };
  protoOf(NamedUnsignedIntFieldFormatDirective).r23 = function () {
    return new ParserStructure(listOf_0(new StringSetParserOperation(this.g25_1, new AssignableString(this), 'one of ' + toString(this.g25_1) + ' for ' + this.h25_1)), emptyList());
  };
  function Accessor$getterNotNull$ref_1($boundThis) {
    var l = function (p0) {
      return $boundThis.q28(p0);
    };
    l.callableName = 'getterNotNull';
    return l;
  }
  function DecimalFractionFieldFormatDirective(field, minDigits, maxDigits, zerosToAdd) {
    this.l27_1 = field;
    this.m27_1 = minDigits;
    this.n27_1 = maxDigits;
    this.o27_1 = zerosToAdd;
  }
  protoOf(DecimalFractionFieldFormatDirective).r24 = function () {
    return this.l27_1;
  };
  protoOf(DecimalFractionFieldFormatDirective).p23 = function () {
    return new DecimalFractionFormatterStructure(Accessor$getterNotNull$ref_1(this.l27_1.r28()), this.m27_1, this.n27_1, this.o27_1);
  };
  protoOf(DecimalFractionFieldFormatDirective).r23 = function () {
    return new ParserStructure(listOf_0(new NumberSpanParserOperation(listOf_0(new FractionPartConsumer(this.m27_1, this.n27_1, this.l27_1.r28(), this.l27_1.s28())))), emptyList());
  };
  function GenericFieldSpec(accessor, name, defaultValue, sign) {
    name = name === VOID ? accessor.s28() : name;
    defaultValue = defaultValue === VOID ? null : defaultValue;
    sign = sign === VOID ? null : sign;
    AbstractFieldSpec.call(this);
    this.d29_1 = accessor;
    this.e29_1 = name;
    this.f29_1 = defaultValue;
    this.g29_1 = sign;
  }
  protoOf(GenericFieldSpec).r28 = function () {
    return this.d29_1;
  };
  protoOf(GenericFieldSpec).s28 = function () {
    return this.e29_1;
  };
  protoOf(GenericFieldSpec).h29 = function () {
    return this.f29_1;
  };
  protoOf(GenericFieldSpec).i29 = function () {
    return this.g29_1;
  };
  function PropertyAccessor(property) {
    this.j29_1 = property;
  }
  protoOf(PropertyAccessor).s28 = function () {
    return this.j29_1.callableName;
  };
  protoOf(PropertyAccessor).k29 = function (container, newValue) {
    var oldValue = this.j29_1.get(container);
    var tmp;
    if (oldValue === null) {
      this.j29_1.set(container, newValue);
      tmp = null;
    } else if (equals(oldValue, newValue)) {
      tmp = null;
    } else {
      tmp = oldValue;
    }
    return tmp;
  };
  protoOf(PropertyAccessor).c29 = function (container, newValue) {
    var tmp = (container == null ? true : !(container == null)) ? container : THROW_CCE();
    return this.k29(tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  protoOf(PropertyAccessor).l29 = function (container) {
    return this.j29_1.get(container);
  };
  function UnsignedFieldSpec(accessor, minValue, maxValue, name, defaultValue, sign) {
    name = name === VOID ? accessor.s28() : name;
    defaultValue = defaultValue === VOID ? null : defaultValue;
    sign = sign === VOID ? null : sign;
    AbstractFieldSpec.call(this);
    this.t28_1 = accessor;
    this.u28_1 = minValue;
    this.v28_1 = maxValue;
    this.w28_1 = name;
    this.x28_1 = defaultValue;
    this.y28_1 = sign;
    var tmp = this;
    var tmp_0;
    if (this.v28_1 < 10) {
      tmp_0 = 1;
    } else if (this.v28_1 < 100) {
      tmp_0 = 2;
    } else if (this.v28_1 < 1000) {
      tmp_0 = 3;
    } else {
      throw IllegalArgumentException_init_$Create$('Max value ' + this.v28_1 + ' is too large');
    }
    tmp.z28_1 = tmp_0;
  }
  protoOf(UnsignedFieldSpec).r28 = function () {
    return this.t28_1;
  };
  protoOf(UnsignedFieldSpec).s28 = function () {
    return this.w28_1;
  };
  protoOf(UnsignedFieldSpec).h29 = function () {
    return this.x28_1;
  };
  protoOf(UnsignedFieldSpec).i29 = function () {
    return this.y28_1;
  };
  function Accessor() {
  }
  function AbstractFieldSpec() {
  }
  protoOf(AbstractFieldSpec).toString = function () {
    return 'The field ' + this.s28() + ' (default value is ' + toString_1(this.h29()) + ')';
  };
  function CachedFormatStructure(formats) {
    ConcatenatedFormatStructure.call(this, formats);
    this.n23_1 = protoOf(ConcatenatedFormatStructure).p23.call(this);
    this.o23_1 = protoOf(ConcatenatedFormatStructure).r23.call(this);
  }
  protoOf(CachedFormatStructure).p23 = function () {
    return this.n23_1;
  };
  protoOf(CachedFormatStructure).r23 = function () {
    return this.o23_1;
  };
  function BasicFormatStructure(directive) {
    this.m29_1 = directive;
  }
  protoOf(BasicFormatStructure).toString = function () {
    return 'BasicFormatStructure(' + toString(this.m29_1) + ')';
  };
  protoOf(BasicFormatStructure).equals = function (other) {
    var tmp;
    if (other instanceof BasicFormatStructure) {
      tmp = equals(this.m29_1, other.m29_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(BasicFormatStructure).hashCode = function () {
    return hashCode(this.m29_1);
  };
  protoOf(BasicFormatStructure).r23 = function () {
    return this.m29_1.r23();
  };
  protoOf(BasicFormatStructure).p23 = function () {
    return this.m29_1.p23();
  };
  function ConstantFormatStructure(string) {
    this.n29_1 = string;
  }
  protoOf(ConstantFormatStructure).toString = function () {
    return 'ConstantFormatStructure(' + this.n29_1 + ')';
  };
  protoOf(ConstantFormatStructure).equals = function (other) {
    var tmp;
    if (other instanceof ConstantFormatStructure) {
      tmp = this.n29_1 === other.n29_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ConstantFormatStructure).hashCode = function () {
    return getStringHashCode(this.n29_1);
  };
  protoOf(ConstantFormatStructure).r23 = function () {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this.n29_1;
    if (charSequenceLength(this_0) === 0) {
      tmp = emptyList();
    } else {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_1 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.internal.format.ConstantFormatStructure.parser.<anonymous>' call
      var tmp_0;
      if (isDigit(charSequenceGet(this.n29_1, 0))) {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.text.takeWhile' call
          var this_2 = this.n29_1;
          var inductionVariable = 0;
          var last = this_2.length;
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'kotlinx.datetime.internal.format.ConstantFormatStructure.parser.<anonymous>.<anonymous>' call
              var it = charSequenceGet(this_2, index);
              if (!isDigit(it)) {
                // Inline function 'kotlin.text.substring' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp$ret$4 = this_2.substring(0, index);
                break $l$block;
              }
            }
             while (inductionVariable < last);
          tmp$ret$4 = this_2;
        }
        this_1.e(new NumberSpanParserOperation(listOf_0(new ConstantNumberConsumer(tmp$ret$4))));
        var tmp$ret$8;
        $l$block_0: {
          // Inline function 'kotlin.text.dropWhile' call
          var this_3 = this.n29_1;
          var inductionVariable_0 = 0;
          var last_0 = charSequenceLength(this_3) - 1 | 0;
          if (inductionVariable_0 <= last_0)
            do {
              var index_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'kotlinx.datetime.internal.format.ConstantFormatStructure.parser.<anonymous>.<anonymous>' call
              var it_0 = charSequenceGet(this_3, index_0);
              if (!isDigit(it_0)) {
                // Inline function 'kotlin.text.substring' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp$ret$8 = this_3.substring(index_0);
                break $l$block_0;
              }
            }
             while (inductionVariable_0 <= last_0);
          tmp$ret$8 = '';
        }
        tmp_0 = tmp$ret$8;
      } else {
        tmp_0 = this.n29_1;
      }
      var suffix = tmp_0;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(suffix) > 0) {
        if (isDigit(charSequenceGet(suffix, suffix.length - 1 | 0))) {
          var tmp$ret$13;
          $l$block_1: {
            // Inline function 'kotlin.text.dropLastWhile' call
            var inductionVariable_1 = get_lastIndex(suffix);
            if (0 <= inductionVariable_1)
              do {
                var index_1 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + -1 | 0;
                // Inline function 'kotlinx.datetime.internal.format.ConstantFormatStructure.parser.<anonymous>.<anonymous>' call
                var it_1 = charSequenceGet(suffix, index_1);
                if (!isDigit(it_1)) {
                  // Inline function 'kotlin.text.substring' call
                  var endIndex = index_1 + 1 | 0;
                  // Inline function 'kotlin.js.asDynamic' call
                  tmp$ret$13 = suffix.substring(0, endIndex);
                  break $l$block_1;
                }
              }
               while (0 <= inductionVariable_1);
            tmp$ret$13 = '';
          }
          this_1.e(new PlainStringParserOperation(tmp$ret$13));
          var tmp$ret$17;
          $l$block_2: {
            // Inline function 'kotlin.text.takeLastWhile' call
            var inductionVariable_2 = get_lastIndex(suffix);
            if (0 <= inductionVariable_2)
              do {
                var index_2 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + -1 | 0;
                // Inline function 'kotlinx.datetime.internal.format.ConstantFormatStructure.parser.<anonymous>.<anonymous>' call
                var it_2 = charSequenceGet(suffix, index_2);
                if (!isDigit(it_2)) {
                  // Inline function 'kotlin.text.substring' call
                  var startIndex = index_2 + 1 | 0;
                  // Inline function 'kotlin.js.asDynamic' call
                  tmp$ret$17 = suffix.substring(startIndex);
                  break $l$block_2;
                }
              }
               while (0 <= inductionVariable_2);
            tmp$ret$17 = suffix;
          }
          this_1.e(new NumberSpanParserOperation(listOf_0(new ConstantNumberConsumer(tmp$ret$17))));
        } else {
          this_1.e(new PlainStringParserOperation(suffix));
        }
      }
      tmp = this_1.y4();
    }
    return new ParserStructure(tmp, emptyList());
  };
  protoOf(ConstantFormatStructure).p23 = function () {
    return new ConstantStringFormatterStructure(this.n29_1);
  };
  function formatter$checkIfAllNegative(this$0, value) {
    var seenNonZero = false;
    var tmp0_iterator = this$0.q29_1.g();
    $l$loop: while (tmp0_iterator.h()) {
      var check = tmp0_iterator.i();
      if (check.b20().l29(value) === true)
        seenNonZero = true;
      else if (check.f28(value))
        continue $l$loop;
      else
        return false;
    }
    return seenNonZero;
  }
  function SignedFormatStructure$parser$lambda(this$0) {
    return function (value, isNegative) {
      var tmp0_iterator = this$0.q29_1.g();
      while (tmp0_iterator.h()) {
        var field = tmp0_iterator.i();
        var wasNegative = field.b20().l29(value) === true;
        field.b20().c29(value, !(isNegative === wasNegative));
      }
      return Unit_instance;
    };
  }
  function SignedFormatStructure$formatter$checkIfAllNegative$ref(this$0) {
    var l = function (p0) {
      return formatter$checkIfAllNegative(this$0, p0);
    };
    l.callableName = 'checkIfAllNegative';
    return l;
  }
  function SignedFormatStructure(format, withPlusSign) {
    this.o29_1 = format;
    this.p29_1 = withPlusSign;
    var tmp = this;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = basicFormats(this.o29_1);
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'kotlinx.datetime.internal.format.SignedFormatStructure.fieldSigns.<anonymous>' call
      var tmp0_safe_receiver = element.r24().i29();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.e(tmp0_safe_receiver);
      }
    }
    tmp.q29_1 = toSet(destination);
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!this.q29_1.o()) {
      // Inline function 'kotlinx.datetime.internal.format.SignedFormatStructure.<anonymous>' call
      var message = 'Signed format must contain at least one field with a sign';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(SignedFormatStructure).toString = function () {
    return 'SignedFormatStructure(' + toString(this.o29_1) + ')';
  };
  protoOf(SignedFormatStructure).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof SignedFormatStructure) {
      tmp_0 = equals(this.o29_1, other.o29_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.p29_1 === other.p29_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SignedFormatStructure).hashCode = function () {
    return imul(31, hashCode(this.o29_1)) + getBooleanHashCode(this.p29_1) | 0;
  };
  protoOf(SignedFormatStructure).r23 = function () {
    return concat(listOf([new ParserStructure(listOf_0(new SignParser(SignedFormatStructure$parser$lambda(this), this.p29_1, 'sign for ' + toString(this.q29_1))), emptyList()), this.o29_1.r23()]));
  };
  protoOf(SignedFormatStructure).p23 = function () {
    var innerFormat = this.o29_1.p23();
    return new SignedFormatter(innerFormat, SignedFormatStructure$formatter$checkIfAllNegative$ref(this), this.p29_1);
  };
  function Companion_7() {
  }
  protoOf(Companion_7).r29 = function (field) {
    var default_0 = field.h29();
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!(default_0 == null)) {
      // Inline function 'kotlinx.datetime.internal.format.Companion.fromField.<anonymous>' call
      var message = "The field '" + field.s28() + "' does not define a default value";
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return new PropertyWithDefault(field.r28(), default_0);
  };
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function PropertyWithDefault(accessor, defaultValue) {
    this.s29_1 = accessor;
    this.t29_1 = defaultValue;
  }
  function OptionalFormatStructure$parser$lambda(this$0) {
    return function (it) {
      var tmp0_iterator = this$0.w29_1.g();
      while (tmp0_iterator.h()) {
        var field = tmp0_iterator.i();
        // Inline function 'kotlinx.datetime.internal.format.PropertyWithDefault.assignDefault' call
        field.s29_1.c29(it, field.t29_1);
      }
      return Unit_instance;
    };
  }
  function Accessor$getter$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.l29(p0);
    };
    l.callableName = 'getter';
    return l;
  }
  function Predicate$test$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.x29(p0);
    };
    l.callableName = 'test';
    return l;
  }
  function Truth$test$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.y29(p0);
    };
    l.callableName = 'test';
    return l;
  }
  function OptionalFormatStructure(onZero, format) {
    this.u29_1 = onZero;
    this.v29_1 = format;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = basicFormats(this.v29_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'kotlinx.datetime.internal.format.OptionalFormatStructure.fields.<anonymous>' call
      var tmp$ret$0 = item.r24();
      destination.e(tmp$ret$0);
    }
    var this_1 = distinct(destination);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.g();
    while (tmp0_iterator_0.h()) {
      var item_0 = tmp0_iterator_0.i();
      // Inline function 'kotlinx.datetime.internal.format.OptionalFormatStructure.fields.<anonymous>' call
      var tmp$ret$3 = Companion_instance_7.r29(item_0);
      destination_0.e(tmp$ret$3);
    }
    tmp.w29_1 = destination_0;
  }
  protoOf(OptionalFormatStructure).toString = function () {
    return 'Optional(' + this.u29_1 + ', ' + toString(this.v29_1) + ')';
  };
  protoOf(OptionalFormatStructure).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof OptionalFormatStructure) {
      tmp_0 = this.u29_1 === other.u29_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.v29_1, other.v29_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OptionalFormatStructure).hashCode = function () {
    return imul(31, getStringHashCode(this.u29_1)) + hashCode(this.v29_1) | 0;
  };
  protoOf(OptionalFormatStructure).r23 = function () {
    var tmp = emptyList();
    var tmp_0 = this.v29_1.r23();
    var tmp_1 = (new ConstantFormatStructure(this.u29_1)).r23();
    var tmp_2;
    if (this.w29_1.o()) {
      tmp_2 = emptyList();
    } else {
      tmp_2 = listOf_0(new UnconditionalModification(OptionalFormatStructure$parser$lambda(this)));
    }
    return new ParserStructure(tmp, listOf([tmp_0, concat(listOf([tmp_1, new ParserStructure(tmp_2, emptyList())]))]));
  };
  protoOf(OptionalFormatStructure).p23 = function () {
    var formatter = this.v29_1.p23();
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.w29_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'kotlinx.datetime.internal.format.OptionalFormatStructure.formatter.<anonymous>' call
      // Inline function 'kotlinx.datetime.internal.format.PropertyWithDefault.isDefaultComparisonPredicate' call
      var tmp$ret$1 = new ComparisonPredicate(item.t29_1, Accessor$getter$ref(item.s29_1));
      destination.e(tmp$ret$1);
    }
    var predicate = conjunctionPredicate(destination);
    var tmp;
    if (predicate instanceof Truth) {
      tmp = new ConstantStringFormatterStructure(this.u29_1);
    } else {
      var tmp_0 = to(Predicate$test$ref(predicate), new ConstantStringFormatterStructure(this.u29_1));
      tmp = new ConditionalFormatter(listOf([tmp_0, to(Truth$test$ref(Truth_instance), formatter)]));
    }
    return tmp;
  };
  function AlternativesParsingFormatStructure(mainFormat, formats) {
    this.z29_1 = mainFormat;
    this.a2a_1 = formats;
  }
  protoOf(AlternativesParsingFormatStructure).toString = function () {
    return 'AlternativesParsing(' + toString(this.a2a_1) + ')';
  };
  protoOf(AlternativesParsingFormatStructure).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof AlternativesParsingFormatStructure) {
      tmp_0 = equals(this.z29_1, other.z29_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.a2a_1, other.a2a_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AlternativesParsingFormatStructure).hashCode = function () {
    return imul(31, hashCode(this.z29_1)) + hashCode(this.a2a_1) | 0;
  };
  protoOf(AlternativesParsingFormatStructure).r23 = function () {
    var tmp = emptyList();
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.internal.format.AlternativesParsingFormatStructure.parser.<anonymous>' call
    this_0.e(this.z29_1.r23());
    var tmp0_iterator = this.a2a_1.g();
    while (tmp0_iterator.h()) {
      var format = tmp0_iterator.i();
      this_0.e(format.r23());
    }
    var tmp$ret$2 = this_0.y4();
    return new ParserStructure(tmp, tmp$ret$2);
  };
  protoOf(AlternativesParsingFormatStructure).p23 = function () {
    return this.z29_1.p23();
  };
  function ConcatenatedFormatStructure(formats) {
    this.s23_1 = formats;
  }
  protoOf(ConcatenatedFormatStructure).toString = function () {
    return 'ConcatenatedFormatStructure(' + joinToString(this.s23_1, ', ') + ')';
  };
  protoOf(ConcatenatedFormatStructure).equals = function (other) {
    var tmp;
    if (other instanceof ConcatenatedFormatStructure) {
      tmp = equals(this.s23_1, other.s23_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ConcatenatedFormatStructure).hashCode = function () {
    return hashCode(this.s23_1);
  };
  protoOf(ConcatenatedFormatStructure).r23 = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.s23_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'kotlinx.datetime.internal.format.ConcatenatedFormatStructure.parser.<anonymous>' call
      var tmp$ret$0 = item.r23();
      destination.e(tmp$ret$0);
    }
    return concat(destination);
  };
  protoOf(ConcatenatedFormatStructure).p23 = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.s23_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'kotlinx.datetime.internal.format.ConcatenatedFormatStructure.formatter.<anonymous>' call
      var tmp$ret$0 = item.p23();
      destination.e(tmp$ret$0);
    }
    var formatters = destination;
    var tmp;
    if (formatters.j() === 1) {
      tmp = single(formatters);
    } else {
      tmp = new ConcatenatedFormatter(formatters);
    }
    return tmp;
  };
  function NonConcatenatedFormatStructure() {
  }
  function basicFormats(format) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.internal.format.basicFormats.<anonymous>' call
    basicFormats$_anonymous_$rec_hkf0lf(this_0, format);
    return this_0.y4();
  }
  function basicFormats$_anonymous_$rec_hkf0lf($this_buildList, format) {
    if (format instanceof BasicFormatStructure) {
      $this_buildList.e(format.m29_1);
    } else {
      if (format instanceof ConcatenatedFormatStructure) {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = format.s23_1.g();
        while (tmp0_iterator.h()) {
          var element = tmp0_iterator.i();
          // Inline function 'kotlinx.datetime.internal.format.basicFormats.<anonymous>$rec.<anonymous>' call
          basicFormats$_anonymous_$rec_hkf0lf($this_buildList, element);
        }
      } else {
        if (!(format instanceof ConstantFormatStructure)) {
          if (format instanceof SignedFormatStructure) {
            basicFormats$_anonymous_$rec_hkf0lf($this_buildList, format.o29_1);
          } else {
            if (format instanceof AlternativesParsingFormatStructure) {
              basicFormats$_anonymous_$rec_hkf0lf($this_buildList, format.z29_1);
              // Inline function 'kotlin.collections.forEach' call
              var tmp0_iterator_0 = format.a2a_1.g();
              while (tmp0_iterator_0.h()) {
                var element_0 = tmp0_iterator_0.i();
                // Inline function 'kotlinx.datetime.internal.format.basicFormats.<anonymous>$rec.<anonymous>' call
                basicFormats$_anonymous_$rec_hkf0lf($this_buildList, element_0);
              }
            } else {
              if (format instanceof OptionalFormatStructure) {
                basicFormats$_anonymous_$rec_hkf0lf($this_buildList, format.v29_1);
              }
            }
          }
        }
      }
    }
  }
  function conjunctionPredicate(predicates) {
    return predicates.o() ? Truth_instance : predicates.j() === 1 ? single(predicates) : new ConjunctionPredicate(predicates);
  }
  function ComparisonPredicate(expectedValue, getter) {
    this.b2a_1 = expectedValue;
    this.c2a_1 = getter;
  }
  protoOf(ComparisonPredicate).x29 = function (value) {
    return equals(this.c2a_1(value), this.b2a_1);
  };
  function Truth() {
  }
  protoOf(Truth).y29 = function (value) {
    return true;
  };
  protoOf(Truth).x29 = function (value) {
    return this.y29((value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  var Truth_instance;
  function Truth_getInstance() {
    return Truth_instance;
  }
  function ConjunctionPredicate(predicates) {
    this.d2a_1 = predicates;
  }
  protoOf(ConjunctionPredicate).x29 = function (value) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = this.d2a_1;
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.o();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'kotlinx.datetime.internal.format.ConjunctionPredicate.test.<anonymous>' call
        if (!element.x29(value)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  function FormatterStructure() {
  }
  function SpacePaddedFormatter(formatter, padding) {
    this.f2a_1 = formatter;
    this.g2a_1 = padding;
  }
  protoOf(SpacePaddedFormatter).e2a = function (obj, builder, minusNotRequired) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.internal.format.formatter.SpacePaddedFormatter.format.<anonymous>' call
    var it = StringBuilder_init_$Create$();
    this.f2a_1.e2a(obj, it, minusNotRequired);
    var string = it.toString();
    // Inline function 'kotlin.repeat' call
    var times = this.g2a_1 - string.length | 0;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.datetime.internal.format.formatter.SpacePaddedFormatter.format.<anonymous>' call
        builder.p7(_Char___init__impl__6a9atx(32));
      }
       while (inductionVariable < times);
    builder.f(string);
  };
  function SignedFormatter(formatter, allSubFormatsNegative, alwaysOutputSign) {
    this.h2a_1 = formatter;
    this.i2a_1 = allSubFormatsNegative;
    this.j2a_1 = alwaysOutputSign;
  }
  protoOf(SignedFormatter).e2a = function (obj, builder, minusNotRequired) {
    var tmp;
    if (!minusNotRequired && this.i2a_1(obj)) {
      tmp = _Char___init__impl__6a9atx(45);
    } else if (this.j2a_1) {
      tmp = _Char___init__impl__6a9atx(43);
    } else {
      tmp = null;
    }
    var sign = tmp;
    var tmp_0 = sign;
    if ((tmp_0 == null ? null : new Char(tmp_0)) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_1 = sign;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.internal.format.formatter.SignedFormatter.format.<anonymous>' call
      var it = (tmp_1 == null ? null : new Char(tmp_1)).f1_1;
      builder.p7(it);
    }
    var tmp_2;
    if (minusNotRequired) {
      tmp_2 = true;
    } else {
      var tmp_3 = sign;
      tmp_2 = equals(tmp_3 == null ? null : new Char(tmp_3), new Char(_Char___init__impl__6a9atx(45)));
    }
    this.h2a_1.e2a(obj, builder, tmp_2);
  };
  function ConditionalFormatter(formatters) {
    this.k2a_1 = formatters;
  }
  protoOf(ConditionalFormatter).e2a = function (obj, builder, minusNotRequired) {
    var tmp0_iterator = this.k2a_1.g();
    while (tmp0_iterator.h()) {
      var tmp1_loop_parameter = tmp0_iterator.i();
      var condition = tmp1_loop_parameter.vd();
      var formatter = tmp1_loop_parameter.wd();
      if (condition(obj)) {
        formatter.e2a(obj, builder, minusNotRequired);
        return Unit_instance;
      }
    }
  };
  function ConcatenatedFormatter(formatters) {
    this.l2a_1 = formatters;
  }
  protoOf(ConcatenatedFormatter).e2a = function (obj, builder, minusNotRequired) {
    var tmp0_iterator = this.l2a_1.g();
    while (tmp0_iterator.h()) {
      var formatter = tmp0_iterator.i();
      formatter.e2a(obj, builder, minusNotRequired);
    }
  };
  function SignedIntFormatterStructure(number, zeroPadding, outputPlusOnExceededWidth) {
    this.m2a_1 = number;
    this.n2a_1 = zeroPadding;
    this.o2a_1 = outputPlusOnExceededWidth;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.n2a_1 >= 0)) {
      // Inline function 'kotlinx.datetime.internal.format.formatter.SignedIntFormatterStructure.<anonymous>' call
      var message = 'The minimum number of digits (' + this.n2a_1 + ') is negative';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.n2a_1 <= 9)) {
      // Inline function 'kotlinx.datetime.internal.format.formatter.SignedIntFormatterStructure.<anonymous>' call
      var message_0 = 'The minimum number of digits (' + this.n2a_1 + ') exceeds the length of an Int';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  protoOf(SignedIntFormatterStructure).e2a = function (obj, builder, minusNotRequired) {
    var innerBuilder = StringBuilder_init_$Create$();
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.internal.format.formatter.SignedIntFormatterStructure.format.<anonymous>' call
    var it = this.m2a_1(obj);
    var number = minusNotRequired && it < 0 ? -it | 0 : it;
    if (!(this.o2a_1 == null) && number >= get_POWERS_OF_TEN()[this.o2a_1]) {
      innerBuilder.p7(_Char___init__impl__6a9atx(43));
    }
    // Inline function 'kotlin.math.absoluteValue' call
    if (abs(number) < get_POWERS_OF_TEN()[this.n2a_1 - 1 | 0]) {
      if (number >= 0) {
        innerBuilder.cb(number + get_POWERS_OF_TEN()[this.n2a_1] | 0).hb(0);
      } else {
        innerBuilder.cb(number - get_POWERS_OF_TEN()[this.n2a_1] | 0).hb(1);
      }
    } else {
      innerBuilder.cb(number);
    }
    builder.f(innerBuilder);
  };
  function UnsignedIntFormatterStructure(number, zeroPadding) {
    this.p2a_1 = number;
    this.q2a_1 = zeroPadding;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.q2a_1 >= 0)) {
      // Inline function 'kotlinx.datetime.internal.format.formatter.UnsignedIntFormatterStructure.<anonymous>' call
      var message = 'The minimum number of digits (' + this.q2a_1 + ') is negative';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.q2a_1 <= 9)) {
      // Inline function 'kotlinx.datetime.internal.format.formatter.UnsignedIntFormatterStructure.<anonymous>' call
      var message_0 = 'The minimum number of digits (' + this.q2a_1 + ') exceeds the length of an Int';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  protoOf(UnsignedIntFormatterStructure).e2a = function (obj, builder, minusNotRequired) {
    var num = this.p2a_1(obj);
    var numberStr = num.toString();
    // Inline function 'kotlin.repeat' call
    var times = this.q2a_1 - numberStr.length | 0;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.datetime.internal.format.formatter.UnsignedIntFormatterStructure.format.<anonymous>' call
        builder.p7(_Char___init__impl__6a9atx(48));
      }
       while (inductionVariable < times);
    builder.f(numberStr);
  };
  function StringFormatterStructure(string) {
    this.r2a_1 = string;
  }
  protoOf(StringFormatterStructure).e2a = function (obj, builder, minusNotRequired) {
    builder.f(this.r2a_1(obj));
  };
  function DecimalFractionFormatterStructure(number, minDigits, maxDigits, zerosToAdd) {
    this.s2a_1 = number;
    this.t2a_1 = minDigits;
    this.u2a_1 = maxDigits;
    this.v2a_1 = zerosToAdd;
    // Inline function 'kotlin.require' call
    var containsArg = this.t2a_1;
    // Inline function 'kotlin.contracts.contract' call
    if (!(1 <= containsArg ? containsArg <= 9 : false)) {
      // Inline function 'kotlinx.datetime.internal.format.formatter.DecimalFractionFormatterStructure.<anonymous>' call
      var message = 'The minimum number of digits (' + this.t2a_1 + ') is not in range 1..9';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    var containsLower = this.t2a_1;
    var containsArg_0 = this.u2a_1;
    // Inline function 'kotlin.contracts.contract' call
    if (!(containsLower <= containsArg_0 ? containsArg_0 <= 9 : false)) {
      // Inline function 'kotlinx.datetime.internal.format.formatter.DecimalFractionFormatterStructure.<anonymous>' call
      var message_0 = 'The maximum number of digits (' + this.u2a_1 + ') is not in range ' + this.t2a_1 + '..9';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  protoOf(DecimalFractionFormatterStructure).e2a = function (obj, builder, minusNotRequired) {
    var number = this.s2a_1(obj);
    var numberWithRequiredPrecision = number.c26(this.u2a_1);
    var zerosToStrip = 0;
    while (this.u2a_1 > (this.t2a_1 + zerosToStrip | 0) && (numberWithRequiredPrecision % get_POWERS_OF_TEN()[zerosToStrip + 1 | 0] | 0) === 0) {
      zerosToStrip = zerosToStrip + 1 | 0;
    }
    var zerosToAddBack = this.v2a_1.p((this.u2a_1 - zerosToStrip | 0) - 1 | 0);
    if (zerosToStrip >= zerosToAddBack)
      zerosToStrip = zerosToStrip - zerosToAddBack | 0;
    var digitsToOutput = this.u2a_1 - zerosToStrip | 0;
    var numberToOutput = numberWithRequiredPrecision / get_POWERS_OF_TEN()[zerosToStrip] | 0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = (numberToOutput + get_POWERS_OF_TEN()[digitsToOutput] | 0).toString().substring(1);
    builder.f(tmp$ret$1);
  };
  function ConstantStringFormatterStructure(string) {
    this.w2a_1 = string;
  }
  protoOf(ConstantStringFormatterStructure).e2a = function (obj, builder, minusNotRequired) {
    builder.f(this.w2a_1);
  };
  function FractionPartConsumer(minLength, maxLength, setter, name) {
    NumberConsumer.call(this, minLength == maxLength ? minLength : null, name);
    this.z2a_1 = minLength;
    this.a2b_1 = maxLength;
    this.b2b_1 = setter;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.z2a_1 == null || numberRangeToNumber(1, 9).if(this.z2a_1))) {
      // Inline function 'kotlinx.datetime.internal.format.parser.FractionPartConsumer.<anonymous>' call
      var message = 'Invalid length for field ' + this.d2b_1 + ': ' + this.a();
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(FractionPartConsumer).e2b = function (storage, input) {
    var tmp;
    if (!(this.z2a_1 == null) && input.length < this.z2a_1) {
      tmp = new TooFewDigits(this.z2a_1);
    } else if (!(this.a2b_1 == null) && input.length > this.a2b_1) {
      tmp = new TooManyDigits(this.a2b_1);
    } else {
      var numerator = toIntOrNull(input);
      tmp = numerator == null ? new TooManyDigits(9) : setWithoutReassigning(this.b2b_1, storage, new DecimalFraction(numerator, input.length));
    }
    return tmp;
  };
  function ConstantNumberConsumer(expected) {
    NumberConsumer.call(this, expected.length, 'the predefined string ' + expected);
    this.h2b_1 = expected;
  }
  protoOf(ConstantNumberConsumer).e2b = function (storage, input) {
    var tmp;
    if (input === this.h2b_1) {
      tmp = null;
    } else {
      tmp = new WrongConstant(this.h2b_1);
    }
    return tmp;
  };
  function NumberConsumer(length, whatThisExpects) {
    this.c2b_1 = length;
    this.d2b_1 = whatThisExpects;
  }
  protoOf(NumberConsumer).a = function () {
    return this.c2b_1;
  };
  function ExpectedInt() {
  }
  protoOf(ExpectedInt).i2b = function () {
    return 'expected an Int value';
  };
  var ExpectedInt_instance;
  function ExpectedInt_getInstance() {
    return ExpectedInt_instance;
  }
  function TooManyDigits(maxDigits) {
    this.j2b_1 = maxDigits;
  }
  protoOf(TooManyDigits).i2b = function () {
    return 'expected at most ' + this.j2b_1 + ' digits';
  };
  function TooFewDigits(minDigits) {
    this.k2b_1 = minDigits;
  }
  protoOf(TooFewDigits).i2b = function () {
    return 'expected at least ' + this.k2b_1 + ' digits';
  };
  function WrongConstant(expected) {
    this.l2b_1 = expected;
  }
  protoOf(WrongConstant).i2b = function () {
    return "expected '" + this.l2b_1 + "'";
  };
  function Conflicting(conflicting) {
    this.m2b_1 = conflicting;
  }
  protoOf(Conflicting).i2b = function () {
    return "attempted to overwrite the existing value '" + toString(this.m2b_1) + "'";
  };
  function setWithoutReassigning(_this__u8e3s4, receiver, value) {
    var tmp0_elvis_lhs = _this__u8e3s4.c29(receiver, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var conflictingValue = tmp;
    return new Conflicting(conflictingValue);
  }
  function UnsignedIntConsumer(minLength, maxLength, setter, name, multiplyByMinus1) {
    multiplyByMinus1 = multiplyByMinus1 === VOID ? false : multiplyByMinus1;
    NumberConsumer.call(this, minLength == maxLength ? minLength : null, name);
    this.p2b_1 = minLength;
    this.q2b_1 = maxLength;
    this.r2b_1 = setter;
    this.s2b_1 = multiplyByMinus1;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.a() == null || numberRangeToNumber(1, 9).if(this.a()))) {
      // Inline function 'kotlinx.datetime.internal.format.parser.UnsignedIntConsumer.<anonymous>' call
      var message = 'Invalid length for field ' + this.d2b_1 + ': ' + this.a();
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(UnsignedIntConsumer).e2b = function (storage, input) {
    var tmp;
    if (!(this.q2b_1 == null) && input.length > this.q2b_1) {
      tmp = new TooManyDigits(this.q2b_1);
    } else if (!(this.p2b_1 == null) && input.length < this.p2b_1) {
      tmp = new TooFewDigits(this.p2b_1);
    } else {
      var result = toIntOrNull(input);
      tmp = result == null ? ExpectedInt_instance : setWithoutReassigning(this.r2b_1, storage, this.s2b_1 ? -result | 0 : result);
    }
    return tmp;
  };
  function ParseError(position, message) {
    this.t2b_1 = position;
    this.u2b_1 = message;
  }
  function _ParseResult___init__impl__gvz3cn(value) {
    return value;
  }
  function _ParseResult___get_value__impl__86mnxf($this) {
    return $this;
  }
  function Companion_8() {
  }
  protoOf(Companion_8).v2b = function (indexOfNextUnparsed) {
    return _ParseResult___init__impl__gvz3cn(indexOfNextUnparsed);
  };
  protoOf(Companion_8).w2b = function (position, message) {
    return _ParseResult___init__impl__gvz3cn(new ParseError(position, message));
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function _Parser___init__impl__gdyfby(commands) {
    return commands;
  }
  function _get_commands__a20n1($this) {
    return $this;
  }
  function Parser__match_impl_nzt83d($this, input, initialContainer, startIndex) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var errors = ArrayList_init_$Create$_0();
    // Inline function 'kotlinx.datetime.internal.format.parser.Parser.parse' call
    var parseOptions = mutableListOf([new ParserState(initialContainer, _get_commands__a20n1($this), startIndex)]);
    iterate_over_alternatives: while (true) {
      var tmp0_elvis_lhs = removeLastOrNull(parseOptions);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break iterate_over_alternatives;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var state = tmp;
      var output = state.x2b_1.i20();
      var inputPosition = state.z2b_1;
      var parserStructure = state.y2b_1;
      // Inline function 'kotlin.run' call
      var this_0 = new Parser($this);
      // Inline function 'kotlin.contracts.contract' call
      $l$block: {
        // Inline function 'kotlinx.datetime.internal.format.parser.Parser.parse.<anonymous>' call
        this_0.a2c_1;
        var inductionVariable = 0;
        var last = parserStructure.b2c_1.j() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var ix = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlinx.datetime.internal.format.parser.ParseResult.match' call
            var this_1 = parserStructure.b2c_1.p(ix).d2c(output, input, inputPosition);
            var tmp0_subject = _ParseResult___get_value__impl__86mnxf(this_1);
            var tmp_0;
            if (typeof tmp0_subject === 'number') {
              inputPosition = _ParseResult___get_value__impl__86mnxf(this_1);
              tmp_0 = Unit_instance;
            } else {
              if (tmp0_subject instanceof ParseError) {
                // Inline function 'kotlinx.datetime.internal.format.parser.Parser.match.<anonymous>' call
                var it = _ParseResult___get_value__impl__86mnxf(this_1);
                errors.e(it);
                break $l$block;
              } else {
                var message = 'Unexpected parse result: ' + toString(_ParseResult___get_value__impl__86mnxf(this_1));
                throw IllegalStateException_init_$Create$(toString(message));
              }
            }
          }
           while (inductionVariable <= last);
        if (parserStructure.c2c_1.o()) {
          if (false || inputPosition === charSequenceLength(input)) {
            // Inline function 'kotlinx.datetime.internal.format.parser.Parser.match.<anonymous>' call
            return output;
          } else {
            // Inline function 'kotlinx.datetime.internal.format.parser.Parser.match.<anonymous>' call
            var tmp_1 = inputPosition;
            var it_0 = new ParseError(tmp_1, Parser$match$lambda);
            errors.e(it_0);
          }
        } else {
          var inductionVariable_0 = parserStructure.c2c_1.j() - 1 | 0;
          if (0 <= inductionVariable_0)
            do {
              var ix_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              parseOptions.e(new ParserState(output, parserStructure.c2c_1.p(ix_0), inputPosition));
            }
             while (0 <= inductionVariable_0);
        }
      }
    }
    // Inline function 'kotlin.collections.sortByDescending' call
    if (errors.j() > 1) {
      // Inline function 'kotlin.comparisons.compareByDescending' call
      var tmp_2 = Parser$match$lambda_0;
      var tmp$ret$4 = new sam$kotlin_Comparator$0(tmp_2);
      sortWith(errors, tmp$ret$4);
    }
    throw new ParseException(errors);
  }
  function Parser__match$default_impl_x2xlti($this, input, initialContainer, startIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    var tmp;
    if ($super === VOID) {
      tmp = Parser__match_impl_nzt83d($this, input, initialContainer, startIndex);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new Parser(tmp_0)).e2c.call(new Parser($this), input, initialContainer, startIndex);
    }
    return tmp;
  }
  function ParserState(output, parserStructure, inputPosition) {
    this.x2b_1 = output;
    this.y2b_1 = parserStructure;
    this.z2b_1 = inputPosition;
  }
  function Parser__toString_impl_x33iea($this) {
    return 'Parser(commands=' + $this.toString() + ')';
  }
  function Parser__hashCode_impl_bbxllf($this) {
    return hashCode($this);
  }
  function Parser__equals_impl_djxokv($this, other) {
    if (!(other instanceof Parser))
      return false;
    var tmp0_other_with_cast = other instanceof Parser ? other.a2c_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.f2c_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).pb = function (a, b) {
    return this.f2c_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.pb(a, b);
  };
  function Parser$match$lambda() {
    return 'There is more input to consume';
  }
  function Parser$match$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'kotlinx.datetime.internal.format.parser.Parser.match.<anonymous>' call
    var tmp = b.t2b_1;
    // Inline function 'kotlinx.datetime.internal.format.parser.Parser.match.<anonymous>' call
    var tmp$ret$1 = a.t2b_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function Parser(commands) {
    this.a2c_1 = commands;
  }
  protoOf(Parser).toString = function () {
    return Parser__toString_impl_x33iea(this.a2c_1);
  };
  protoOf(Parser).hashCode = function () {
    return Parser__hashCode_impl_bbxllf(this.a2c_1);
  };
  protoOf(Parser).equals = function (other) {
    return Parser__equals_impl_djxokv(this.a2c_1, other);
  };
  function ParserStructure(operations, followedBy) {
    this.b2c_1 = operations;
    this.c2c_1 = followedBy;
  }
  protoOf(ParserStructure).toString = function () {
    return joinToString(this.b2c_1, ', ') + '(' + joinToString(this.c2c_1, ';') + ')';
  };
  function ParseException(errors) {
    Exception_init_$Init$(formatError(errors), this);
    captureStack(this, ParseException);
  }
  function concat(_this__u8e3s4) {
    // Inline function 'kotlin.collections.foldRight' call
    var accumulator = new ParserStructure(emptyList(), emptyList());
    if (!_this__u8e3s4.o()) {
      var iterator = _this__u8e3s4.q(_this__u8e3s4.j());
      while (iterator.g4()) {
        // Inline function 'kotlinx.datetime.internal.format.parser.concat.<anonymous>' call
        var parser = iterator.h4();
        var acc = accumulator;
        accumulator = concat$append(parser, acc);
      }
    }
    var naiveParser = accumulator;
    return concat$simplify(naiveParser, emptyList());
  }
  function formatError(errors) {
    if (errors.j() === 1) {
      return 'Position ' + errors.p(0).t2b_1 + ': ' + errors.p(0).u2b_1();
    }
    var averageMessageLength = 33;
    var tmp0_buffer = StringBuilder_init_$Create$_0(imul(averageMessageLength, errors.j()));
    return joinTo(errors, tmp0_buffer, ', ', 'Errors: ', VOID, VOID, VOID, formatError$lambda).toString();
  }
  function concat$append(_this__u8e3s4, other) {
    var tmp;
    if (_this__u8e3s4.c2c_1.o()) {
      tmp = new ParserStructure(plus(_this__u8e3s4.b2c_1, other.b2c_1), other.c2c_1);
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = _this__u8e3s4.c2c_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        // Inline function 'kotlinx.datetime.internal.format.parser.concat.append.<anonymous>' call
        var tmp$ret$0 = concat$append(item, other);
        destination.e(tmp$ret$0);
      }
      tmp = new ParserStructure(_this__u8e3s4.b2c_1, destination);
    }
    return tmp;
  }
  function concat$simplify(_this__u8e3s4, unconditionalModifications) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var newOperations = ArrayList_init_$Create$_0();
    var currentNumberSpan = null;
    var unconditionalModificationsForTails = toMutableList(unconditionalModifications);
    var tmp0_iterator = _this__u8e3s4.b2c_1.g();
    while (tmp0_iterator.h()) {
      var op = tmp0_iterator.i();
      if (op instanceof NumberSpanParserOperation) {
        if (!(currentNumberSpan == null)) {
          currentNumberSpan.n(op.g2c_1);
        } else {
          currentNumberSpan = toMutableList(op.g2c_1);
        }
      } else {
        if (op instanceof UnconditionalModification) {
          unconditionalModificationsForTails.e(op);
        } else {
          if (!(currentNumberSpan == null)) {
            newOperations.e(new NumberSpanParserOperation(currentNumberSpan));
            currentNumberSpan = null;
          }
          newOperations.e(op);
        }
      }
    }
    // Inline function 'kotlin.collections.ifEmpty' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = _this__u8e3s4.c2c_1;
    var destination = ArrayList_init_$Create$_0();
    var tmp0_iterator_0 = this_0.g();
    while (tmp0_iterator_0.h()) {
      var element = tmp0_iterator_0.i();
      // Inline function 'kotlinx.datetime.internal.format.parser.concat.simplify.<anonymous>' call
      var simplified = concat$simplify(element, unconditionalModificationsForTails);
      var tmp;
      if (simplified.b2c_1.o()) {
        // Inline function 'kotlin.collections.ifEmpty' call
        var this_1 = simplified.c2c_1;
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (this_1.o()) {
          // Inline function 'kotlinx.datetime.internal.format.parser.concat.simplify.<anonymous>.<anonymous>' call
          tmp_0 = listOf_0(simplified);
        } else {
          tmp_0 = this_1;
        }
        tmp = tmp_0;
      } else {
        tmp = listOf_0(simplified);
      }
      var list = tmp;
      addAll(destination, list);
    }
    // Inline function 'kotlin.contracts.contract' call
    var tmp_1;
    if (destination.o()) {
      // Inline function 'kotlinx.datetime.internal.format.parser.concat.simplify.<anonymous>' call
      tmp_1 = listOf_0(new ParserStructure(unconditionalModificationsForTails, emptyList()));
    } else {
      tmp_1 = destination;
    }
    var mergedTails = tmp_1;
    var tmp_2;
    if (currentNumberSpan == null) {
      tmp_2 = new ParserStructure(newOperations, mergedTails);
    } else {
      var tmp$ret$8;
      $l$block_0: {
        // Inline function 'kotlin.collections.none' call
        var tmp_3;
        if (isInterface(mergedTails, Collection)) {
          tmp_3 = mergedTails.o();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$8 = true;
          break $l$block_0;
        }
        var tmp0_iterator_1 = mergedTails.g();
        while (tmp0_iterator_1.h()) {
          var element_0 = tmp0_iterator_1.i();
          // Inline function 'kotlinx.datetime.internal.format.parser.concat.simplify.<anonymous>' call
          var tmp0_safe_receiver = firstOrNull(element_0.b2c_1);
          var tmp_4;
          if (tmp0_safe_receiver == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.datetime.internal.format.parser.concat.simplify.<anonymous>.<anonymous>' call
            tmp_4 = tmp0_safe_receiver instanceof NumberSpanParserOperation;
          }
          if (tmp_4 === true) {
            tmp$ret$8 = false;
            break $l$block_0;
          }
        }
        tmp$ret$8 = true;
      }
      if (tmp$ret$8) {
        newOperations.e(new NumberSpanParserOperation(currentNumberSpan));
        tmp_2 = new ParserStructure(newOperations, mergedTails);
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(mergedTails, 10));
        var tmp0_iterator_2 = mergedTails.g();
        while (tmp0_iterator_2.h()) {
          var item = tmp0_iterator_2.i();
          // Inline function 'kotlinx.datetime.internal.format.parser.concat.simplify.<anonymous>' call
          var firstOperation = firstOrNull(item.b2c_1);
          var tmp_5;
          if (firstOperation instanceof NumberSpanParserOperation) {
            tmp_5 = new ParserStructure(plus(listOf_0(new NumberSpanParserOperation(plus(currentNumberSpan, firstOperation.g2c_1))), drop(item.b2c_1, 1)), item.c2c_1);
          } else {
            if (firstOperation == null) {
              tmp_5 = new ParserStructure(listOf_0(new NumberSpanParserOperation(currentNumberSpan)), item.c2c_1);
            } else {
              tmp_5 = new ParserStructure(plus(listOf_0(new NumberSpanParserOperation(currentNumberSpan)), item.b2c_1), item.c2c_1);
            }
          }
          var tmp$ret$12 = tmp_5;
          destination_0.e(tmp$ret$12);
        }
        var newTails = destination_0;
        tmp_2 = new ParserStructure(newOperations, newTails);
      }
    }
    return tmp_2;
  }
  function formatError$lambda(it) {
    return 'position ' + it.t2b_1 + ": '" + it.u2b_1() + "'";
  }
  function SignedIntParser(minDigits, maxDigits, spacePadding, setter, name, plusOnExceedsWidth) {
    var parsers = mutableListOf([spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name, true)]);
    if (!(plusOnExceedsWidth == null)) {
      parsers.e(spaceAndZeroPaddedUnsignedInt(minDigits, plusOnExceedsWidth, spacePadding, setter, name));
      parsers.e(new ParserStructure(listOf([new PlainStringParserOperation('+'), new NumberSpanParserOperation(listOf_0(new UnsignedIntConsumer(plusOnExceedsWidth + 1 | 0, maxDigits, setter, name, false)))]), emptyList()));
    } else {
      parsers.e(spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name));
    }
    return new ParserStructure(emptyList(), parsers);
  }
  function spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name, withMinus) {
    withMinus = withMinus === VOID ? false : withMinus;
    var minNumberLength = (minDigits == null ? 1 : minDigits) + (withMinus ? 1 : 0) | 0;
    var tmp;
    if (maxDigits == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.datetime.internal.format.parser.spaceAndZeroPaddedUnsignedInt.<anonymous>' call
      tmp = withMinus ? maxDigits + 1 | 0 : maxDigits;
    }
    var tmp2_elvis_lhs = tmp;
    var maxNumberLength = tmp2_elvis_lhs == null ? 2147483647 : tmp2_elvis_lhs;
    var spacePadding_0 = spacePadding == null ? 0 : spacePadding;
    // Inline function 'kotlin.comparisons.minOf' call
    var maxPaddedNumberLength = Math.min(maxNumberLength, spacePadding_0);
    if (minNumberLength >= maxPaddedNumberLength)
      return spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, minNumberLength, maxNumberLength);
    var accumulated = spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, minNumberLength, minNumberLength);
    var inductionVariable = minNumberLength;
    if (inductionVariable < maxPaddedNumberLength)
      do {
        var accumulatedWidth = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        accumulated = new ParserStructure(emptyList(), listOf([spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, accumulatedWidth + 1 | 0, accumulatedWidth + 1 | 0), concat(listOf([new ParserStructure(listOf_0(new PlainStringParserOperation(' ')), emptyList()), accumulated]))]));
      }
       while (inductionVariable < maxPaddedNumberLength);
    var tmp_0;
    if (spacePadding_0 > maxNumberLength) {
      var prepadding = new PlainStringParserOperation(repeat(' ', spacePadding_0 - maxNumberLength | 0));
      tmp_0 = concat(listOf([new ParserStructure(listOf_0(prepadding), emptyList()), accumulated]));
    } else if (spacePadding_0 === maxNumberLength) {
      tmp_0 = accumulated;
    } else {
      var r = new ParserStructure(emptyList(), listOf([spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, spacePadding_0 + 1 | 0, maxNumberLength), accumulated]));
      tmp_0 = r;
    }
    return tmp_0;
  }
  function TrieNode(children, isTerminal) {
    var tmp;
    if (children === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$_0();
    } else {
      tmp = children;
    }
    children = tmp;
    isTerminal = isTerminal === VOID ? false : isTerminal;
    this.j2c_1 = children;
    this.k2c_1 = isTerminal;
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.l2c_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).pb = function (a, b) {
    return this.l2c_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.pb(a, b);
  };
  function _init_$reduceTrie(trie) {
    var tmp0_iterator = trie.j2c_1.g();
    while (tmp0_iterator.h()) {
      var child = tmp0_iterator.i().wd();
      _init_$reduceTrie(child);
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var newChildren = ArrayList_init_$Create$_0();
    var tmp2_iterator = trie.j2c_1.g();
    while (tmp2_iterator.h()) {
      var tmp3_loop_parameter = tmp2_iterator.i();
      var key = tmp3_loop_parameter.vd();
      var child_0 = tmp3_loop_parameter.wd();
      if (!child_0.k2c_1 && child_0.j2c_1.j() === 1) {
        var tmp4_container = single(child_0.j2c_1);
        var grandChildKey = tmp4_container.vd();
        var grandChild = tmp4_container.wd();
        newChildren.e(to(key + grandChildKey, grandChild));
      } else {
        newChildren.e(to(key, child_0));
      }
    }
    trie.j2c_1.s1();
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = StringSetParserOperation$reduceTrie$lambda;
    var tmp$ret$1 = new sam$kotlin_Comparator$0_0(tmp);
    var tmp$ret$2 = sortedWith(newChildren, tmp$ret$1);
    trie.j2c_1.n(tmp$ret$2);
  }
  function StringSetParserOperation$lambda($key) {
    return function (it) {
      // Inline function 'kotlinx.datetime.internal.format.parser.StringSetParserOperation.<anonymous>' call
      var tmp$ret$0 = it.td_1;
      return compareValues(tmp$ret$0, $key);
    };
  }
  function StringSetParserOperation$consume$lambda(this$0, $input, $startIndex, $index) {
    return function () {
      // Inline function 'kotlin.text.substring' call
      var this_0 = $input;
      var startIndex = $startIndex;
      var endIndex = $index._v;
      var tmp$ret$0 = toString(charSequenceSubSequence(this_0, startIndex, endIndex));
      return 'Expected ' + this$0.n2c_1 + ' but got ' + tmp$ret$0;
    };
  }
  function StringSetParserOperation$reduceTrie$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'kotlinx.datetime.internal.format.parser.StringSetParserOperation.reduceTrie.<anonymous>' call
    var tmp = a.td_1;
    // Inline function 'kotlinx.datetime.internal.format.parser.StringSetParserOperation.reduceTrie.<anonymous>' call
    var tmp$ret$1 = b.td_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function StringSetParserOperation(strings, setter, whatThisExpects) {
    this.m2c_1 = setter;
    this.n2c_1 = whatThisExpects;
    this.o2c_1 = new TrieNode();
    var tmp0_iterator = strings.g();
    while (tmp0_iterator.h()) {
      var string = tmp0_iterator.i();
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.text.isNotEmpty' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(charSequenceLength(string) > 0)) {
        // Inline function 'kotlinx.datetime.internal.format.parser.StringSetParserOperation.<anonymous>' call
        var message = 'Found an empty string in ' + this.n2c_1;
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      var node = this.o2c_1;
      var inductionVariable = 0;
      var last = string.length;
      while (inductionVariable < last) {
        var char = charSequenceGet(string, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.binarySearchBy' call
        var this_0 = node.j2c_1;
        var key = toString_0(char);
        var toIndex = this_0.j();
        var searchResult = binarySearch(this_0, 0, toIndex, StringSetParserOperation$lambda(key));
        var tmp;
        if (searchResult < 0) {
          // Inline function 'kotlin.also' call
          var this_1 = new TrieNode();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlinx.datetime.internal.format.parser.StringSetParserOperation.<anonymous>' call
          node.j2c_1.u1((-searchResult | 0) - 1 | 0, to(toString_0(char), this_1));
          tmp = this_1;
        } else {
          tmp = node.j2c_1.p(searchResult).ud_1;
        }
        node = tmp;
      }
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!!node.k2c_1) {
        // Inline function 'kotlinx.datetime.internal.format.parser.StringSetParserOperation.<anonymous>' call
        var message_0 = "The string '" + string + "' was passed several times";
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      node.k2c_1 = true;
    }
    _init_$reduceTrie(this.o2c_1);
  }
  protoOf(StringSetParserOperation).d2c = function (storage, input, startIndex) {
    var node = this.o2c_1;
    var index = {_v: startIndex};
    var lastMatch = null;
    loop: while (index._v <= charSequenceLength(input)) {
      if (node.k2c_1)
        lastMatch = index._v;
      var tmp0_iterator = node.j2c_1.g();
      while (tmp0_iterator.h()) {
        var tmp1_loop_parameter = tmp0_iterator.i();
        var key = tmp1_loop_parameter.vd();
        var child = tmp1_loop_parameter.wd();
        if (startsWith(input, key, index._v)) {
          node = child;
          index._v = index._v + key.length | 0;
          continue loop;
        }
      }
      break loop;
    }
    var tmp;
    if (!(lastMatch == null)) {
      // Inline function 'kotlin.text.substring' call
      var endIndex = lastMatch;
      var tmp$ret$0 = toString(charSequenceSubSequence(input, startIndex, endIndex));
      tmp = setWithoutReassigning_0(this.m2c_1, storage, tmp$ret$0, startIndex, lastMatch);
    } else {
      var tmp_0 = Companion_instance_8;
      tmp = tmp_0.w2b(startIndex, StringSetParserOperation$consume$lambda(this, input, startIndex, index));
    }
    return tmp;
  };
  function _get_whatThisExpects__4pg11j($this) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.g2c_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'kotlinx.datetime.internal.format.parser.NumberSpanParserOperation.<get-whatThisExpects>.<anonymous>' call
      var length = item.a();
      var tmp$ret$0 = (length == null ? 'at least one digit' : '' + length + ' digits') + (' for ' + item.d2b_1);
      destination.e(tmp$ret$0);
    }
    var consumerLengths = destination;
    var tmp;
    if ($this.i2c_1) {
      tmp = 'a number with at least ' + $this.h2c_1 + ' digits: ' + toString(consumerLengths);
    } else {
      tmp = 'a number with exactly ' + $this.h2c_1 + ' digits: ' + toString(consumerLengths);
    }
    return tmp;
  }
  function NumberSpanParserOperation$consume$lambda(this$0) {
    return function () {
      return 'Unexpected end of input: yet to parse ' + _get_whatThisExpects__4pg11j(this$0);
    };
  }
  function NumberSpanParserOperation$consume$lambda_0($digitsInRow, this$0) {
    return function () {
      return 'Only found ' + $digitsInRow._v + ' digits in a row, but need to parse ' + _get_whatThisExpects__4pg11j(this$0);
    };
  }
  function NumberSpanParserOperation$consume$lambda_1($numberString, this$0, $i, $error) {
    return function () {
      return "Can not interpret the string '" + $numberString + "' as " + this$0.g2c_1.p($i).d2b_1 + ': ' + $error.i2b();
    };
  }
  function NumberSpanParserOperation(consumers) {
    this.g2c_1 = consumers;
    var tmp = this;
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this.g2c_1.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      var tmp_0 = sum;
      // Inline function 'kotlinx.datetime.internal.format.parser.NumberSpanParserOperation.minLength.<anonymous>' call
      var tmp0_elvis_lhs = element.a();
      sum = tmp_0 + (tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs) | 0;
    }
    tmp.h2c_1 = sum;
    var tmp_1 = this;
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = this.g2c_1;
      var tmp_2;
      if (isInterface(this_0, Collection)) {
        tmp_2 = this_0.o();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.g();
      while (tmp0_iterator_0.h()) {
        var element_0 = tmp0_iterator_0.i();
        // Inline function 'kotlinx.datetime.internal.format.parser.NumberSpanParserOperation.isFlexible.<anonymous>' call
        if (element_0.a() == null) {
          tmp$ret$2 = true;
          break $l$block_0;
        }
      }
      tmp$ret$2 = false;
    }
    tmp_1.i2c_1 = tmp$ret$2;
    // Inline function 'kotlin.require' call
    var tmp$ret$4;
    $l$block_2: {
      // Inline function 'kotlin.collections.all' call
      var this_1 = this.g2c_1;
      var tmp_3;
      if (isInterface(this_1, Collection)) {
        tmp_3 = this_1.o();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$4 = true;
        break $l$block_2;
      }
      var tmp0_iterator_1 = this_1.g();
      while (tmp0_iterator_1.h()) {
        var element_1 = tmp0_iterator_1.i();
        // Inline function 'kotlinx.datetime.internal.format.parser.NumberSpanParserOperation.<anonymous>' call
        var tmp0_elvis_lhs_0 = element_1.a();
        if (!((tmp0_elvis_lhs_0 == null ? 2147483647 : tmp0_elvis_lhs_0) > 0)) {
          tmp$ret$4 = false;
          break $l$block_2;
        }
      }
      tmp$ret$4 = true;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp$ret$4) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    var tmp$ret$7;
    $l$block_3: {
      // Inline function 'kotlin.collections.count' call
      var this_2 = this.g2c_1;
      var tmp_4;
      if (isInterface(this_2, Collection)) {
        tmp_4 = this_2.o();
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp$ret$7 = 0;
        break $l$block_3;
      }
      var count = 0;
      var tmp0_iterator_2 = this_2.g();
      while (tmp0_iterator_2.h()) {
        var element_2 = tmp0_iterator_2.i();
        // Inline function 'kotlinx.datetime.internal.format.parser.NumberSpanParserOperation.<anonymous>' call
        if (element_2.a() == null) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$7 = count;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!(tmp$ret$7 <= 1)) {
      // Inline function 'kotlinx.datetime.internal.format.parser.NumberSpanParserOperation.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_3 = this.g2c_1;
      var destination = ArrayList_init_$Create$_0();
      var tmp0_iterator_3 = this_3.g();
      while (tmp0_iterator_3.h()) {
        var element_3 = tmp0_iterator_3.i();
        // Inline function 'kotlinx.datetime.internal.format.parser.NumberSpanParserOperation.<anonymous>.<anonymous>' call
        if (element_3.a() == null) {
          destination.e(element_3);
        }
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_4 = destination.g();
      while (tmp0_iterator_4.h()) {
        var item = tmp0_iterator_4.i();
        // Inline function 'kotlinx.datetime.internal.format.parser.NumberSpanParserOperation.<anonymous>.<anonymous>' call
        var tmp$ret$12 = item.d2b_1;
        destination_0.e(tmp$ret$12);
      }
      var fieldNames = destination_0;
      var message_0 = 'At most one variable-length numeric field in a row is allowed, but got several: ' + toString(fieldNames) + '. ' + 'Parsing is undefined: for example, with variable-length month number ' + "and variable-length day of month, '111' can be parsed as Jan 11th or Nov 1st.";
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  protoOf(NumberSpanParserOperation).d2c = function (storage, input, startIndex) {
    if ((startIndex + this.h2c_1 | 0) > charSequenceLength(input)) {
      var tmp = Companion_instance_8;
      return tmp.w2b(startIndex, NumberSpanParserOperation$consume$lambda(this));
    }
    var digitsInRow = {_v: 0};
    while ((startIndex + digitsInRow._v | 0) < charSequenceLength(input) && isDigit(charSequenceGet(input, startIndex + digitsInRow._v | 0))) {
      digitsInRow._v = digitsInRow._v + 1 | 0;
      digitsInRow._v;
    }
    if (digitsInRow._v < this.h2c_1) {
      var tmp_0 = Companion_instance_8;
      return tmp_0.w2b(startIndex, NumberSpanParserOperation$consume$lambda_0(digitsInRow, this));
    }
    var index = startIndex;
    var inductionVariable = 0;
    var last = this.g2c_1.j() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_elvis_lhs = this.g2c_1.p(i).a();
        var length = tmp1_elvis_lhs == null ? (digitsInRow._v - this.h2c_1 | 0) + 1 | 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.text.substring' call
        var startIndex_0 = index;
        var endIndex = index + length | 0;
        var numberString = toString(charSequenceSubSequence(input, startIndex_0, endIndex));
        var error = this.g2c_1.p(i).e2b(storage, numberString);
        if (!(error == null)) {
          var tmp_1 = Companion_instance_8;
          var tmp_2 = index;
          return tmp_1.w2b(tmp_2, NumberSpanParserOperation$consume$lambda_1(numberString, this, i, error));
        }
        index = index + length | 0;
      }
       while (inductionVariable <= last);
    return Companion_instance_8.v2b(index);
  };
  protoOf(NumberSpanParserOperation).toString = function () {
    return _get_whatThisExpects__4pg11j(this);
  };
  function PlainStringParserOperation$consume$lambda(this$0) {
    return function () {
      return "Unexpected end of input: yet to parse '" + this$0.p2c_1 + "'";
    };
  }
  function PlainStringParserOperation$consume$lambda_0(this$0, $input, $startIndex, $i) {
    return function () {
      // Inline function 'kotlin.text.substring' call
      var this_0 = $input;
      var startIndex = $startIndex;
      var endIndex = ($startIndex + $i | 0) + 1 | 0;
      var tmp$ret$0 = toString(charSequenceSubSequence(this_0, startIndex, endIndex));
      return 'Expected ' + this$0.p2c_1 + ' but got ' + tmp$ret$0;
    };
  }
  function PlainStringParserOperation(string) {
    this.p2c_1 = string;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.p2c_1;
    // Inline function 'kotlin.contracts.contract' call
    if (!(charSequenceLength(this_0) > 0)) {
      // Inline function 'kotlinx.datetime.internal.format.parser.PlainStringParserOperation.<anonymous>' call
      var message = 'Empty string is not allowed';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isDigit(charSequenceGet(this.p2c_1, 0))) {
      // Inline function 'kotlinx.datetime.internal.format.parser.PlainStringParserOperation.<anonymous>' call
      var message_0 = "String '" + this.p2c_1 + "' starts with a digit";
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isDigit(charSequenceGet(this.p2c_1, this.p2c_1.length - 1 | 0))) {
      // Inline function 'kotlinx.datetime.internal.format.parser.PlainStringParserOperation.<anonymous>' call
      var message_1 = "String '" + this.p2c_1 + "' ends with a digit";
      throw IllegalArgumentException_init_$Create$(toString(message_1));
    }
  }
  protoOf(PlainStringParserOperation).d2c = function (storage, input, startIndex) {
    if ((startIndex + this.p2c_1.length | 0) > charSequenceLength(input)) {
      var tmp = Companion_instance_8;
      return tmp.w2b(startIndex, PlainStringParserOperation$consume$lambda(this));
    }
    var inductionVariable = 0;
    var last = charSequenceLength(this.p2c_1) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charSequenceGet(input, startIndex + i | 0) === charSequenceGet(this.p2c_1, i))) {
          var tmp_0 = Companion_instance_8;
          return tmp_0.w2b(startIndex, PlainStringParserOperation$consume$lambda_0(this, input, startIndex, i));
        }
      }
       while (inductionVariable <= last);
    return Companion_instance_8.v2b(startIndex + this.p2c_1.length | 0);
  };
  protoOf(PlainStringParserOperation).toString = function () {
    return "'" + this.p2c_1 + "'";
  };
  function SignParser$consume$lambda(this$0, $char) {
    return function () {
      return 'Expected ' + this$0.s2c_1 + ' but got ' + toString_0($char);
    };
  }
  function SignParser(isNegativeSetter, withPlusSign, whatThisExpects) {
    this.q2c_1 = isNegativeSetter;
    this.r2c_1 = withPlusSign;
    this.s2c_1 = whatThisExpects;
  }
  protoOf(SignParser).d2c = function (storage, input, startIndex) {
    if (startIndex >= charSequenceLength(input))
      return Companion_instance_8.v2b(startIndex);
    var char = charSequenceGet(input, startIndex);
    if (char === _Char___init__impl__6a9atx(45)) {
      this.q2c_1(storage, true);
      return Companion_instance_8.v2b(startIndex + 1 | 0);
    }
    if (char === _Char___init__impl__6a9atx(43) && this.r2c_1) {
      this.q2c_1(storage, false);
      return Companion_instance_8.v2b(startIndex + 1 | 0);
    }
    var tmp = Companion_instance_8;
    return tmp.w2b(startIndex, SignParser$consume$lambda(this, char));
  };
  protoOf(SignParser).toString = function () {
    return this.s2c_1;
  };
  function UnconditionalModification(operation) {
    this.t2c_1 = operation;
  }
  protoOf(UnconditionalModification).d2c = function (storage, input, startIndex) {
    this.t2c_1(storage);
    return Companion_instance_8.v2b(startIndex);
  };
  function setWithoutReassigning_0(_this__u8e3s4, receiver, value, position, nextIndex) {
    var conflictingValue = _this__u8e3s4.c29(receiver, value);
    var tmp;
    if (conflictingValue === null) {
      tmp = Companion_instance_8.v2b(nextIndex);
    } else {
      var tmp_0 = Companion_instance_8;
      tmp = tmp_0.w2b(position, setWithoutReassigning$lambda(conflictingValue, value, _this__u8e3s4));
    }
    return tmp;
  }
  function spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths($withMinus, $setter, $name, minNumberLength, maxNumberLength) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(maxNumberLength >= (1 + ($withMinus ? 1 : 0) | 0))) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.internal.format.parser.spaceAndZeroPaddedUnsignedInt.numberOfRequiredLengths.<anonymous>' call
    if ($withMinus) {
      this_0.e(new PlainStringParserOperation('-'));
    }
    this_0.e(new NumberSpanParserOperation(listOf_0(new UnsignedIntConsumer(minNumberLength - ($withMinus ? 1 : 0) | 0, maxNumberLength - ($withMinus ? 1 : 0) | 0, $setter, $name, $withMinus))));
    var tmp$ret$3 = this_0.y4();
    return new ParserStructure(tmp$ret$3, emptyList());
  }
  function setWithoutReassigning$lambda($conflictingValue, $value, $this_setWithoutReassigning) {
    return function () {
      return "Attempting to assign conflicting values '" + toString_1($conflictingValue) + "' and '" + toString_1($value) + "' to field '" + $this_setWithoutReassigning.s28() + "'";
    };
  }
  function get_POWERS_OF_TEN() {
    _init_properties_math_kt__tgcmt4();
    return POWERS_OF_TEN;
  }
  var POWERS_OF_TEN;
  function DecimalFraction(fractionalPart, digits) {
    this.a26_1 = fractionalPart;
    this.b26_1 = digits;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.b26_1 >= 0)) {
      // Inline function 'kotlinx.datetime.internal.DecimalFraction.<anonymous>' call
      var message = 'Digits must be non-negative, but was ' + this.b26_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(DecimalFraction).c26 = function (newDigits) {
    return newDigits === this.b26_1 ? this.a26_1 : newDigits > this.b26_1 ? imul(this.a26_1, get_POWERS_OF_TEN()[newDigits - this.b26_1 | 0]) : this.a26_1 / get_POWERS_OF_TEN()[this.b26_1 - newDigits | 0] | 0;
  };
  protoOf(DecimalFraction).u2c = function (other) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = this.b26_1;
    var b = other.b26_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.internal.DecimalFraction.compareTo.<anonymous>' call
    var maxPrecision = Math.max(a, b);
    return compareTo(this.c26(maxPrecision), other.c26(maxPrecision));
  };
  protoOf(DecimalFraction).d = function (other) {
    return this.u2c(other instanceof DecimalFraction ? other : THROW_CCE());
  };
  protoOf(DecimalFraction).equals = function (other) {
    var tmp;
    if (other instanceof DecimalFraction) {
      tmp = this.u2c(other) === 0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DecimalFraction).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.datetime.internal.DecimalFraction.toString.<anonymous>' call
    var denominator = get_POWERS_OF_TEN()[this.b26_1];
    this_0.cb(this.a26_1 / denominator | 0);
    this_0.p7(_Char___init__impl__6a9atx(46));
    this_0.o7(removePrefix((denominator + (this.a26_1 % denominator | 0) | 0).toString(), '1'));
    return this_0.toString();
  };
  protoOf(DecimalFraction).hashCode = function () {
    throw UnsupportedOperationException_init_$Create$('DecimalFraction is not supposed to be used as a hash key');
  };
  var properties_initialized_math_kt_amm9wq;
  function _init_properties_math_kt__tgcmt4() {
    if (!properties_initialized_math_kt_amm9wq) {
      properties_initialized_math_kt_amm9wq = true;
      // Inline function 'kotlin.intArrayOf' call
      POWERS_OF_TEN = new Int32Array([1, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000]);
    }
  }
  function InstantIso8601Serializer() {
    InstantIso8601Serializer_instance = this;
    this.v2c_1 = PrimitiveSerialDescriptor('kotlinx.datetime.Instant', STRING_getInstance());
  }
  protoOf(InstantIso8601Serializer).t1d = function () {
    return this.v2c_1;
  };
  protoOf(InstantIso8601Serializer).v1d = function (decoder) {
    return Companion_getInstance_9().w2c(decoder.s1g());
  };
  protoOf(InstantIso8601Serializer).x2c = function (encoder, value) {
    encoder.a1i(value.toString());
  };
  protoOf(InstantIso8601Serializer).u1d = function (encoder, value) {
    return this.x2c(encoder, value instanceof Instant_0 ? value : THROW_CCE());
  };
  var InstantIso8601Serializer_instance;
  function InstantIso8601Serializer_getInstance() {
    if (InstantIso8601Serializer_instance == null)
      new InstantIso8601Serializer();
    return InstantIso8601Serializer_instance;
  }
  function LocalDateIso8601Serializer() {
    LocalDateIso8601Serializer_instance = this;
    this.y2c_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDate', STRING_getInstance());
  }
  protoOf(LocalDateIso8601Serializer).t1d = function () {
    return this.y2c_1;
  };
  protoOf(LocalDateIso8601Serializer).v1d = function (decoder) {
    return Companion_getInstance_10().b2d(decoder.s1g());
  };
  protoOf(LocalDateIso8601Serializer).c2d = function (encoder, value) {
    encoder.a1i(value.toString());
  };
  protoOf(LocalDateIso8601Serializer).u1d = function (encoder, value) {
    return this.c2d(encoder, value instanceof LocalDate_0 ? value : THROW_CCE());
  };
  var LocalDateIso8601Serializer_instance;
  function LocalDateIso8601Serializer_getInstance() {
    if (LocalDateIso8601Serializer_instance == null)
      new LocalDateIso8601Serializer();
    return LocalDateIso8601Serializer_instance;
  }
  function LocalDateTimeIso8601Serializer() {
    LocalDateTimeIso8601Serializer_instance = this;
    this.d2d_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDateTime', STRING_getInstance());
  }
  protoOf(LocalDateTimeIso8601Serializer).t1d = function () {
    return this.d2d_1;
  };
  protoOf(LocalDateTimeIso8601Serializer).v1d = function (decoder) {
    return Companion_getInstance_11().g2d(decoder.s1g());
  };
  protoOf(LocalDateTimeIso8601Serializer).h2d = function (encoder, value) {
    encoder.a1i(value.toString());
  };
  protoOf(LocalDateTimeIso8601Serializer).u1d = function (encoder, value) {
    return this.h2d(encoder, value instanceof LocalDateTime_0 ? value : THROW_CCE());
  };
  var LocalDateTimeIso8601Serializer_instance;
  function LocalDateTimeIso8601Serializer_getInstance() {
    if (LocalDateTimeIso8601Serializer_instance == null)
      new LocalDateTimeIso8601Serializer();
    return LocalDateTimeIso8601Serializer_instance;
  }
  function LocalTimeIso8601Serializer() {
    LocalTimeIso8601Serializer_instance = this;
    this.i2d_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalTime', STRING_getInstance());
  }
  protoOf(LocalTimeIso8601Serializer).t1d = function () {
    return this.i2d_1;
  };
  protoOf(LocalTimeIso8601Serializer).v1d = function (decoder) {
    return Companion_getInstance_12().l2d(decoder.s1g());
  };
  protoOf(LocalTimeIso8601Serializer).m2d = function (encoder, value) {
    encoder.a1i(value.toString());
  };
  protoOf(LocalTimeIso8601Serializer).u1d = function (encoder, value) {
    return this.m2d(encoder, value instanceof LocalTime_0 ? value : THROW_CCE());
  };
  var LocalTimeIso8601Serializer_instance;
  function LocalTimeIso8601Serializer_getInstance() {
    if (LocalTimeIso8601Serializer_instance == null)
      new LocalTimeIso8601Serializer();
    return LocalTimeIso8601Serializer_instance;
  }
  function UtcOffsetSerializer() {
    UtcOffsetSerializer_instance = this;
    this.n2d_1 = PrimitiveSerialDescriptor('kotlinx.datetime.UtcOffset', STRING_getInstance());
  }
  protoOf(UtcOffsetSerializer).t1d = function () {
    return this.n2d_1;
  };
  protoOf(UtcOffsetSerializer).v1d = function (decoder) {
    return Companion_getInstance_13().o2d(decoder.s1g());
  };
  protoOf(UtcOffsetSerializer).p2d = function (encoder, value) {
    encoder.a1i(value.toString());
  };
  protoOf(UtcOffsetSerializer).u1d = function (encoder, value) {
    return this.p2d(encoder, value instanceof UtcOffset ? value : THROW_CCE());
  };
  var UtcOffsetSerializer_instance;
  function UtcOffsetSerializer_getInstance() {
    if (UtcOffsetSerializer_instance == null)
      new UtcOffsetSerializer();
    return UtcOffsetSerializer_instance;
  }
  var DayOfWeek_MONDAY_instance;
  var DayOfWeek_TUESDAY_instance;
  var DayOfWeek_WEDNESDAY_instance;
  var DayOfWeek_THURSDAY_instance;
  var DayOfWeek_FRIDAY_instance;
  var DayOfWeek_SATURDAY_instance;
  var DayOfWeek_SUNDAY_instance;
  function values() {
    return [DayOfWeek_MONDAY_getInstance(), DayOfWeek_TUESDAY_getInstance(), DayOfWeek_WEDNESDAY_getInstance(), DayOfWeek_THURSDAY_getInstance(), DayOfWeek_FRIDAY_getInstance(), DayOfWeek_SATURDAY_getInstance(), DayOfWeek_SUNDAY_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var DayOfWeek_entriesInitialized;
  function DayOfWeek_initEntries() {
    if (DayOfWeek_entriesInitialized)
      return Unit_instance;
    DayOfWeek_entriesInitialized = true;
    DayOfWeek_MONDAY_instance = new DayOfWeek_0('MONDAY', 0);
    DayOfWeek_TUESDAY_instance = new DayOfWeek_0('TUESDAY', 1);
    DayOfWeek_WEDNESDAY_instance = new DayOfWeek_0('WEDNESDAY', 2);
    DayOfWeek_THURSDAY_instance = new DayOfWeek_0('THURSDAY', 3);
    DayOfWeek_FRIDAY_instance = new DayOfWeek_0('FRIDAY', 4);
    DayOfWeek_SATURDAY_instance = new DayOfWeek_0('SATURDAY', 5);
    DayOfWeek_SUNDAY_instance = new DayOfWeek_0('SUNDAY', 6);
  }
  var $ENTRIES;
  function DayOfWeek_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function toDayOfWeek(_this__u8e3s4) {
    return DayOfWeek(_this__u8e3s4.value());
  }
  function DayOfWeek_MONDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_MONDAY_instance;
  }
  function DayOfWeek_TUESDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_TUESDAY_instance;
  }
  function DayOfWeek_WEDNESDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_WEDNESDAY_instance;
  }
  function DayOfWeek_THURSDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_THURSDAY_instance;
  }
  function DayOfWeek_FRIDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_FRIDAY_instance;
  }
  function DayOfWeek_SATURDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_SATURDAY_instance;
  }
  function DayOfWeek_SUNDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_SUNDAY_instance;
  }
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlinx.datetime.jsTry' call
    // Inline function 'kotlinx.datetime.Companion.DISTANT_PAST.<anonymous>' call
    var tmp$ret$1 = Instant.ofEpochSecond((new Long(-931914497, -750)).d3(), 999999999);
    tmp.p21_1 = new Instant_0(tmp$ret$1);
    var tmp_0 = this;
    // Inline function 'kotlinx.datetime.jsTry' call
    // Inline function 'kotlinx.datetime.Companion.DISTANT_FUTURE.<anonymous>' call
    var tmp$ret$3 = Instant.ofEpochSecond((new Long(1151527680, 720)).d3(), 0);
    tmp_0.q21_1 = new Instant_0(tmp$ret$3);
    this.r21_1 = new Instant_0(Instant.MIN);
    this.s21_1 = new Instant_0(Instant.MAX);
  }
  protoOf(Companion_9).q2d = function (epochMilliseconds) {
    var tmp;
    try {
      // Inline function 'kotlin.Long.div' call
      var tmp_0 = epochMilliseconds.o2(toLong(1000));
      // Inline function 'kotlin.Long.times' call
      // Inline function 'kotlin.Long.rem' call
      var tmp$ret$2 = epochMilliseconds.p2(toLong(1000)).n2(toLong(1000000));
      tmp = this.r2d(tmp_0, tmp$ret$2);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        if (!isJodaDateTimeException(e))
          throw e;
        tmp_1 = epochMilliseconds.a1(new Long(0, 0)) > 0 ? this.s21_1 : this.r21_1;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  };
  protoOf(Companion_9).s2d = function (input, format) {
    var tmp;
    try {
      tmp = format.k23(input).w21();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throw DateTimeFormatException_init_$Create$_2("Failed to parse an instant from '" + toString(input) + "'", e);
      } else {
        throw $p;
      }
    }
    return tmp;
  };
  protoOf(Companion_9).w2c = function (input, format, $super) {
    format = format === VOID ? Formats_getInstance().c21_1 : format;
    return $super === VOID ? this.s2d(input, format) : $super.s2d.call(this, input, format);
  };
  protoOf(Companion_9).r2d = function (epochSeconds, nanosecondAdjustment) {
    var tmp;
    try {
      // Inline function 'kotlin.floorDiv' call
      var other = new Long(1000000000, 0);
      var q = nanosecondAdjustment.o2(other);
      if (nanosecondAdjustment.z2(other).a1(new Long(0, 0)) < 0 && !q.n2(other).equals(nanosecondAdjustment)) {
        q = q.r2();
      }
      var tmp$ret$0 = q;
      var secs = safeAdd(epochSeconds, tmp$ret$0);
      // Inline function 'kotlin.mod' call
      var other_0 = new Long(1000000000, 0);
      var r = nanosecondAdjustment.p2(other_0);
      var nos = r.l2(other_0.x2(r.z2(other_0).x2(r.y2(r.s2())).v2(63))).c3();
      // Inline function 'kotlinx.datetime.jsTry' call
      // Inline function 'kotlinx.datetime.Companion.fromEpochSeconds.<anonymous>' call
      var tmp$ret$3 = Instant.ofEpochSecond(secs.d3(), nos);
      tmp = new Instant_0(tmp$ret$3);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        var tmp_1;
        if (!isJodaDateTimeException(e)) {
          tmp_1 = !(e instanceof ArithmeticException);
        } else {
          tmp_1 = false;
        }
        if (tmp_1)
          throw e;
        tmp_0 = epochSeconds.a1(new Long(0, 0)) > 0 ? this.s21_1 : this.r21_1;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(Companion_9).t21 = function (epochSeconds, nanosecondAdjustment) {
    var tmp;
    try {
      // Inline function 'kotlinx.datetime.jsTry' call
      // Inline function 'kotlinx.datetime.Companion.fromEpochSeconds.<anonymous>' call
      var tmp$ret$1 = Instant.ofEpochSecond(epochSeconds.d3(), nanosecondAdjustment);
      tmp = new Instant_0(tmp$ret$1);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (!isJodaDateTimeException(e))
          throw e;
        tmp_0 = epochSeconds.a1(new Long(0, 0)) > 0 ? this.s21_1 : this.r21_1;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function Instant_0(value) {
    Companion_getInstance_9();
    this.m21_1 = value;
  }
  protoOf(Instant_0).n21 = function () {
    return numberToLong(this.m21_1.epochSecond());
  };
  protoOf(Instant_0).o21 = function () {
    return numberToInt(this.m21_1.nano());
  };
  protoOf(Instant_0).t2d = function (other) {
    return this.m21_1.compareTo(other.m21_1);
  };
  protoOf(Instant_0).d = function (other) {
    return this.t2d(other instanceof Instant_0 ? other : THROW_CCE());
  };
  protoOf(Instant_0).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof Instant_0) {
        tmp_0 = this.m21_1 === other.m21_1 || this.m21_1.equals(other.m21_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(Instant_0).hashCode = function () {
    return this.m21_1.hashCode();
  };
  protoOf(Instant_0).toString = function () {
    return this.m21_1.toString();
  };
  function isJodaDateTimeParseException(_this__u8e3s4) {
    return hasJsExceptionName(_this__u8e3s4, 'DateTimeParseException');
  }
  function isJodaDateTimeException(_this__u8e3s4) {
    return hasJsExceptionName(_this__u8e3s4, 'DateTimeException');
  }
  function Companion_10() {
    Companion_instance_10 = this;
    this.z2c_1 = new LocalDate_0(LocalDate.MIN);
    this.a2d_1 = new LocalDate_0(LocalDate.MAX);
  }
  protoOf(Companion_10).u2d = function (input, format) {
    var tmp;
    if (format === Formats_getInstance_0().k1y()) {
      var tmp_0;
      try {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlinx.datetime.jsTry' call
        // Inline function 'kotlinx.datetime.Companion.parse.<anonymous>' call
        var this_0 = LocalDate.parse(toString(input));
        // Inline function 'kotlin.contracts.contract' call
        tmp_0 = new LocalDate_0(this_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (isJodaDateTimeParseException(e))
            throw DateTimeFormatException_init_$Create$_1(e);
          throw e;
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    } else {
      tmp = format.k23(input);
    }
    return tmp;
  };
  protoOf(Companion_10).b2d = function (input, format, $super) {
    format = format === VOID ? getIsoDateFormat() : format;
    return $super === VOID ? this.u2d(input, format) : $super.u2d.call(this, input, format);
  };
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function Formats_0() {
    Formats_instance_0 = this;
    this.j1y_1 = get_ISO_DATE_BASIC();
  }
  protoOf(Formats_0).k1y = function () {
    return get_ISO_DATE();
  };
  var Formats_instance_0;
  function Formats_getInstance_0() {
    if (Formats_instance_0 == null)
      new Formats_0();
    return Formats_instance_0;
  }
  function LocalDate_init_$Init$(year, monthNumber, dayOfMonth, $this) {
    var tmp;
    try {
      // Inline function 'kotlinx.datetime.jsTry' call
      // Inline function 'kotlinx.datetime.LocalDate.<init>.<anonymous>' call
      tmp = LocalDate.of(year, monthNumber, dayOfMonth);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (isJodaDateTimeException(e))
          throw IllegalArgumentException_init_$Create$_0(e);
        throw e;
      } else {
        throw $p;
      }
    }
    LocalDate_0.call($this, tmp);
    return $this;
  }
  function LocalDate_init_$Create$(year, monthNumber, dayOfMonth) {
    return LocalDate_init_$Init$(year, monthNumber, dayOfMonth, objectCreate(protoOf(LocalDate_0)));
  }
  function LocalDate_0(value) {
    Companion_getInstance_10();
    this.y21_1 = value;
  }
  protoOf(LocalDate_0).b1z = function () {
    return this.y21_1.year();
  };
  protoOf(LocalDate_0).z1y = function () {
    return this.y21_1.monthValue();
  };
  protoOf(LocalDate_0).v1y = function () {
    return this.y21_1.dayOfMonth();
  };
  protoOf(LocalDate_0).t23 = function () {
    return toDayOfWeek(this.y21_1.dayOfWeek());
  };
  protoOf(LocalDate_0).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof LocalDate_0) {
        tmp_0 = this.y21_1 === other.y21_1 || this.y21_1.equals(other.y21_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(LocalDate_0).hashCode = function () {
    return this.y21_1.hashCode();
  };
  protoOf(LocalDate_0).toString = function () {
    return this.y21_1.toString();
  };
  protoOf(LocalDate_0).v2d = function (other) {
    return this.y21_1.compareTo(other.y21_1);
  };
  protoOf(LocalDate_0).d = function (other) {
    return this.v2d(other instanceof LocalDate_0 ? other : THROW_CCE());
  };
  protoOf(LocalDate_0).z21 = function () {
    return numberToInt(this.y21_1.toEpochDay());
  };
  function LocalDateTime_init_$Init$(date, time, $this) {
    // Inline function 'kotlinx.datetime.jsTry' call
    // Inline function 'kotlinx.datetime.LocalDateTime.<init>.<anonymous>' call
    var tmp$ret$1 = LocalDateTime.of(date.y21_1, time.a22_1);
    LocalDateTime_0.call($this, tmp$ret$1);
    return $this;
  }
  function LocalDateTime_init_$Create$(date, time) {
    return LocalDateTime_init_$Init$(date, time, objectCreate(protoOf(LocalDateTime_0)));
  }
  function Companion_11() {
    Companion_instance_11 = this;
    this.e2d_1 = new LocalDateTime_0(LocalDateTime.MIN);
    this.f2d_1 = new LocalDateTime_0(LocalDateTime.MAX);
  }
  protoOf(Companion_11).w2d = function (input, format) {
    var tmp;
    if (format === Formats_getInstance_1().l1y_1) {
      var tmp_0;
      try {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlinx.datetime.jsTry' call
        // Inline function 'kotlinx.datetime.Companion.parse.<anonymous>' call
        var this_0 = LocalDateTime.parse(toString(input));
        // Inline function 'kotlin.contracts.contract' call
        tmp_0 = new LocalDateTime_0(this_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (isJodaDateTimeParseException(e))
            throw DateTimeFormatException_init_$Create$_1(e);
          throw e;
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    } else {
      tmp = format.k23(input);
    }
    return tmp;
  };
  protoOf(Companion_11).g2d = function (input, format, $super) {
    format = format === VOID ? getIsoDateTimeFormat() : format;
    return $super === VOID ? this.w2d(input, format) : $super.w2d.call(this, input, format);
  };
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function Formats_1() {
    Formats_instance_1 = this;
    this.l1y_1 = get_ISO_DATETIME();
  }
  var Formats_instance_1;
  function Formats_getInstance_1() {
    if (Formats_instance_1 == null)
      new Formats_1();
    return Formats_instance_1;
  }
  function LocalDateTime_0(value) {
    Companion_getInstance_11();
    this.f21_1 = value;
  }
  protoOf(LocalDateTime_0).g21 = function () {
    return new LocalDate_0(this.f21_1.toLocalDate());
  };
  protoOf(LocalDateTime_0).i21 = function () {
    return new LocalTime_0(this.f21_1.toLocalTime());
  };
  protoOf(LocalDateTime_0).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof LocalDateTime_0) {
        tmp_0 = this.f21_1 === other.f21_1 || this.f21_1.equals(other.f21_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(LocalDateTime_0).hashCode = function () {
    return this.f21_1.hashCode();
  };
  protoOf(LocalDateTime_0).toString = function () {
    return this.f21_1.toString();
  };
  protoOf(LocalDateTime_0).x2d = function (other) {
    return this.f21_1.compareTo(other.f21_1);
  };
  protoOf(LocalDateTime_0).d = function (other) {
    return this.x2d(other instanceof LocalDateTime_0 ? other : THROW_CCE());
  };
  function LocalTime_init_$Init$(hour, minute, second, nanosecond, $this) {
    second = second === VOID ? 0 : second;
    nanosecond = nanosecond === VOID ? 0 : nanosecond;
    var tmp;
    try {
      // Inline function 'kotlinx.datetime.jsTry' call
      // Inline function 'kotlinx.datetime.LocalTime.<init>.<anonymous>' call
      tmp = LocalTime.of(hour, minute, second, nanosecond);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (isJodaDateTimeException(e))
          throw IllegalArgumentException_init_$Create$_0(e);
        throw e;
      } else {
        throw $p;
      }
    }
    LocalTime_0.call($this, tmp);
    return $this;
  }
  function LocalTime_init_$Create$(hour, minute, second, nanosecond) {
    return LocalTime_init_$Init$(hour, minute, second, nanosecond, objectCreate(protoOf(LocalTime_0)));
  }
  function Companion_12() {
    Companion_instance_12 = this;
    this.j2d_1 = new LocalTime_0(LocalTime.MIN);
    this.k2d_1 = new LocalTime_0(LocalTime.MAX);
  }
  protoOf(Companion_12).y2d = function (input, format) {
    var tmp;
    if (format === Formats_instance_2.k1y()) {
      var tmp_0;
      try {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlinx.datetime.jsTry' call
        // Inline function 'kotlinx.datetime.Companion.parse.<anonymous>' call
        var this_0 = LocalTime.parse(toString(input));
        // Inline function 'kotlin.contracts.contract' call
        tmp_0 = new LocalTime_0(this_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (isJodaDateTimeParseException(e))
            throw DateTimeFormatException_init_$Create$_1(e);
          throw e;
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    } else {
      tmp = format.k23(input);
    }
    return tmp;
  };
  protoOf(Companion_12).l2d = function (input, format, $super) {
    format = format === VOID ? getIsoTimeFormat() : format;
    return $super === VOID ? this.y2d(input, format) : $super.y2d.call(this, input, format);
  };
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  function Formats_2() {
  }
  protoOf(Formats_2).k1y = function () {
    return get_ISO_TIME();
  };
  var Formats_instance_2;
  function Formats_getInstance_2() {
    return Formats_instance_2;
  }
  function LocalTime_0(value) {
    Companion_getInstance_12();
    this.a22_1 = value;
  }
  protoOf(LocalTime_0).n1z = function () {
    return this.a22_1.hour();
  };
  protoOf(LocalTime_0).r1z = function () {
    return this.a22_1.minute();
  };
  protoOf(LocalTime_0).v1z = function () {
    return this.a22_1.second();
  };
  protoOf(LocalTime_0).t1z = function () {
    return numberToInt(this.a22_1.nano());
  };
  protoOf(LocalTime_0).b22 = function () {
    return this.a22_1.toSecondOfDay();
  };
  protoOf(LocalTime_0).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof LocalTime_0) {
        tmp_0 = this.a22_1 === other.a22_1 || this.a22_1.equals(other.a22_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(LocalTime_0).hashCode = function () {
    return this.a22_1.hashCode();
  };
  protoOf(LocalTime_0).toString = function () {
    return this.a22_1.toString();
  };
  protoOf(LocalTime_0).z2d = function (other) {
    return this.a22_1.compareTo(other.a22_1);
  };
  protoOf(LocalTime_0).d = function (other) {
    return this.z2d(other instanceof LocalTime_0 ? other : THROW_CCE());
  };
  function toLocalDateTime(_this__u8e3s4, offset) {
    var tmp;
    try {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.datetime.jsTry' call
      // Inline function 'kotlinx.datetime.toLocalDateTime.<anonymous>' call
      var this_0 = LocalDateTime.ofInstant(_this__u8e3s4.m21_1, offset.c22_1);
      // Inline function 'kotlin.contracts.contract' call
      tmp = new LocalDateTime_0(this_0);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (isJodaDateTimeException(e))
          throw DateTimeArithmeticException_init_$Create$_0(e);
        throw e;
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function get_isoFormat() {
    _init_properties_UtcOffset_kt__93zod7();
    // Inline function 'kotlin.getValue' call
    var this_0 = isoFormat$delegate;
    isoFormat$factory();
    return this_0.v();
  }
  var isoFormat$delegate;
  function get_isoBasicFormat() {
    _init_properties_UtcOffset_kt__93zod7();
    // Inline function 'kotlin.getValue' call
    var this_0 = isoBasicFormat$delegate;
    isoBasicFormat$factory();
    return this_0.v();
  }
  var isoBasicFormat$delegate;
  function get_fourDigitsFormat() {
    _init_properties_UtcOffset_kt__93zod7();
    // Inline function 'kotlin.getValue' call
    var this_0 = fourDigitsFormat$delegate;
    fourDigitsFormat$factory();
    return this_0.v();
  }
  var fourDigitsFormat$delegate;
  function Companion_13() {
    Companion_instance_13 = this;
    this.t1x_1 = new UtcOffset(ZoneOffset.UTC);
  }
  protoOf(Companion_13).a2e = function (input, format) {
    return format === Formats_instance_3.k1y() ? parseWithFormat(input, get_isoFormat()) : format === Formats_instance_3.b2e() ? parseWithFormat(input, get_isoBasicFormat()) : format === Formats_instance_3.z20() ? parseWithFormat(input, get_fourDigitsFormat()) : format.k23(input);
  };
  protoOf(Companion_13).o2d = function (input, format, $super) {
    format = format === VOID ? getIsoUtcOffsetFormat() : format;
    return $super === VOID ? this.a2e(input, format) : $super.a2e.call(this, input, format);
  };
  var Companion_instance_13;
  function Companion_getInstance_13() {
    if (Companion_instance_13 == null)
      new Companion_13();
    return Companion_instance_13;
  }
  function Formats_3() {
  }
  protoOf(Formats_3).k1y = function () {
    return get_ISO_OFFSET();
  };
  protoOf(Formats_3).b2e = function () {
    return get_ISO_OFFSET_BASIC();
  };
  protoOf(Formats_3).z20 = function () {
    return get_FOUR_DIGIT_OFFSET();
  };
  var Formats_instance_3;
  function Formats_getInstance_3() {
    return Formats_instance_3;
  }
  function UtcOffset(zoneOffset) {
    Companion_getInstance_13();
    this.c22_1 = zoneOffset;
  }
  protoOf(UtcOffset).d22 = function () {
    return this.c22_1.totalSeconds();
  };
  protoOf(UtcOffset).hashCode = function () {
    return this.c22_1.hashCode();
  };
  protoOf(UtcOffset).equals = function (other) {
    var tmp;
    if (other instanceof UtcOffset) {
      tmp = this.c22_1 === other.c22_1 || this.c22_1.equals(other.c22_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(UtcOffset).toString = function () {
    return this.c22_1.toString();
  };
  function UtcOffset_0(hours, minutes, seconds) {
    hours = hours === VOID ? null : hours;
    minutes = minutes === VOID ? null : minutes;
    seconds = seconds === VOID ? null : seconds;
    _init_properties_UtcOffset_kt__93zod7();
    var tmp;
    try {
      var tmp_0;
      if (!(hours == null)) {
        // Inline function 'kotlinx.datetime.jsTry' call
        // Inline function 'kotlinx.datetime.UtcOffset.<anonymous>' call
        var tmp_1 = ZoneOffset;
        var tmp_2 = minutes == null ? 0 : minutes;
        var tmp$ret$1 = tmp_1.ofHoursMinutesSeconds(hours, tmp_2, seconds == null ? 0 : seconds);
        tmp_0 = new UtcOffset(tmp$ret$1);
      } else if (!(minutes == null)) {
        // Inline function 'kotlinx.datetime.jsTry' call
        // Inline function 'kotlinx.datetime.UtcOffset.<anonymous>' call
        var tmp_3 = ZoneOffset;
        var tmp_4 = minutes / 60 | 0;
        var tmp_5 = minutes % 60 | 0;
        var tmp$ret$3 = tmp_3.ofHoursMinutesSeconds(tmp_4, tmp_5, seconds == null ? 0 : seconds);
        tmp_0 = new UtcOffset(tmp$ret$3);
      } else {
        // Inline function 'kotlinx.datetime.jsTry' call
        // Inline function 'kotlinx.datetime.UtcOffset.<anonymous>' call
        var tmp_6 = ZoneOffset;
        var tmp$ret$5 = tmp_6.ofTotalSeconds(seconds == null ? 0 : seconds);
        tmp_0 = new UtcOffset(tmp$ret$5);
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_7;
      if ($p instanceof Error) {
        var e = $p;
        var tmp_8;
        if (isJodaDateTimeException(e)) {
          throw IllegalArgumentException_init_$Create$_0(e);
        } else {
          throw e;
        }
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function parseWithFormat(input, format) {
    _init_properties_UtcOffset_kt__93zod7();
    var tmp;
    try {
      // Inline function 'kotlinx.datetime.jsTry' call
      // Inline function 'kotlinx.datetime.parseWithFormat.<anonymous>' call
      tmp = format.parse(toString(input)).get(ChronoField.OFFSET_SECONDS);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (isJodaDateTimeParseException(e))
          throw DateTimeFormatException_init_$Create$_1(e);
        if (isJodaDateTimeException(e))
          throw DateTimeFormatException_init_$Create$_1(e);
        throw e;
      } else {
        throw $p;
      }
    }
    return UtcOffset_0(VOID, VOID, tmp);
  }
  function isoFormat$delegate$lambda() {
    _init_properties_UtcOffset_kt__93zod7();
    return (new DateTimeFormatterBuilder()).parseCaseInsensitive().appendOffsetId().toFormatter(ResolverStyle.STRICT);
  }
  function isoBasicFormat$delegate$lambda() {
    _init_properties_UtcOffset_kt__93zod7();
    return (new DateTimeFormatterBuilder()).parseCaseInsensitive().appendOffset('+HHmmss', 'Z').toFormatter(ResolverStyle.STRICT);
  }
  function fourDigitsFormat$delegate$lambda() {
    _init_properties_UtcOffset_kt__93zod7();
    return (new DateTimeFormatterBuilder()).parseCaseInsensitive().appendOffset('+HHMM', '+0000').toFormatter(ResolverStyle.STRICT);
  }
  function isoFormat$factory() {
    return getPropertyCallableRef('isoFormat', 0, KProperty0, function () {
      return get_isoFormat();
    }, null);
  }
  function isoBasicFormat$factory() {
    return getPropertyCallableRef('isoBasicFormat', 0, KProperty0, function () {
      return get_isoBasicFormat();
    }, null);
  }
  function fourDigitsFormat$factory() {
    return getPropertyCallableRef('fourDigitsFormat', 0, KProperty0, function () {
      return get_fourDigitsFormat();
    }, null);
  }
  var properties_initialized_UtcOffset_kt_4gxffr;
  function _init_properties_UtcOffset_kt__93zod7() {
    if (!properties_initialized_UtcOffset_kt_4gxffr) {
      properties_initialized_UtcOffset_kt_4gxffr = true;
      isoFormat$delegate = lazy(isoFormat$delegate$lambda);
      isoBasicFormat$delegate = lazy(isoBasicFormat$delegate$lambda);
      fourDigitsFormat$delegate = lazy(fourDigitsFormat$delegate$lambda);
    }
  }
  function safeMultiply(a, b) {
    if (b.equals(new Long(-1, -1))) {
      if (a.equals(new Long(0, -2147483648))) {
        throw ArithmeticException_init_$Create$('Multiplication overflows a long: ' + a.toString() + ' * ' + b.toString());
      }
      return a.s2();
    } else if (b.equals(new Long(0, 0)))
      return new Long(0, 0);
    else if (b.equals(new Long(1, 0)))
      return a;
    var total = a.n2(b);
    if (!total.o2(b).equals(a)) {
      throw ArithmeticException_init_$Create$('Multiplication overflows a long: ' + a.toString() + ' * ' + b.toString());
    }
    return total;
  }
  function safeAdd(a, b) {
    var sum = a.l2(b);
    if (a.z2(sum).a1(new Long(0, 0)) < 0 && a.z2(b).a1(new Long(0, 0)) >= 0) {
      throw ArithmeticException_init_$Create$('Addition overflows a long: ' + a.toString() + ' + ' + b.toString());
    }
    return sum;
  }
  function hasJsExceptionName(_this__u8e3s4, name) {
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.name == name;
  }
  //region block: post-declaration
  protoOf(Builder).l22 = appendAlternativeParsingImpl;
  protoOf(Builder).m22 = appendOptionalImpl;
  protoOf(Builder).v20 = chars;
  protoOf(Builder).b21 = build;
  protoOf(Builder).n22 = addFormatStructureForDate;
  protoOf(Builder).o22 = addFormatStructureForTime;
  protoOf(Builder).p22 = year;
  protoOf(Builder).u20 = year$default;
  protoOf(Builder).q22 = monthNumber;
  protoOf(Builder).r22 = monthNumber$default;
  protoOf(Builder).t20 = monthName;
  protoOf(Builder).q20 = dayOfMonth;
  protoOf(Builder).s22 = dayOfMonth$default;
  protoOf(Builder).y20 = dayOfWeek;
  protoOf(Builder).j20 = date;
  protoOf(Builder).t22 = hour;
  protoOf(Builder).k20 = hour$default;
  protoOf(Builder).u22 = minute;
  protoOf(Builder).l20 = minute$default;
  protoOf(Builder).v22 = second;
  protoOf(Builder).m20 = second$default;
  protoOf(Builder).n20 = secondFraction;
  protoOf(Builder).w22 = time;
  protoOf(Builder).x22 = offsetHours;
  protoOf(Builder).o20 = offsetHours$default;
  protoOf(Builder).y22 = offsetMinutesOfHour;
  protoOf(Builder).z22 = offsetMinutesOfHour$default;
  protoOf(Builder).a23 = offsetSecondsOfMinute;
  protoOf(Builder).b23 = offsetSecondsOfMinute$default;
  protoOf(Builder).p20 = offset;
  protoOf(Builder_0).l22 = appendAlternativeParsingImpl;
  protoOf(Builder_0).m22 = appendOptionalImpl;
  protoOf(Builder_0).v20 = chars;
  protoOf(Builder_0).b21 = build;
  protoOf(Builder_0).p22 = year;
  protoOf(Builder_0).u20 = year$default;
  protoOf(Builder_0).q22 = monthNumber;
  protoOf(Builder_0).r22 = monthNumber$default;
  protoOf(Builder_0).q20 = dayOfMonth;
  protoOf(Builder_0).s22 = dayOfMonth$default;
  protoOf(Builder_1).l22 = appendAlternativeParsingImpl;
  protoOf(Builder_1).m22 = appendOptionalImpl;
  protoOf(Builder_1).v20 = chars;
  protoOf(Builder_1).b21 = build;
  protoOf(Builder_1).n22 = addFormatStructureForDate;
  protoOf(Builder_1).o22 = addFormatStructureForTime;
  protoOf(Builder_1).p22 = year;
  protoOf(Builder_1).u20 = year$default;
  protoOf(Builder_1).q22 = monthNumber;
  protoOf(Builder_1).r22 = monthNumber$default;
  protoOf(Builder_1).q20 = dayOfMonth;
  protoOf(Builder_1).s22 = dayOfMonth$default;
  protoOf(Builder_1).j20 = date;
  protoOf(Builder_1).t22 = hour;
  protoOf(Builder_1).k20 = hour$default;
  protoOf(Builder_1).u22 = minute;
  protoOf(Builder_1).l20 = minute$default;
  protoOf(Builder_1).v22 = second;
  protoOf(Builder_1).m20 = second$default;
  protoOf(Builder_1).n20 = secondFraction;
  protoOf(Builder_1).w22 = time;
  protoOf(IncompleteLocalTime).k1z = set_fractionOfSecond;
  protoOf(IncompleteLocalTime).l1z = get_fractionOfSecond;
  protoOf(Builder_2).l22 = appendAlternativeParsingImpl;
  protoOf(Builder_2).m22 = appendOptionalImpl;
  protoOf(Builder_2).v20 = chars;
  protoOf(Builder_2).b21 = build;
  protoOf(Builder_2).t22 = hour;
  protoOf(Builder_2).k20 = hour$default;
  protoOf(Builder_2).u22 = minute;
  protoOf(Builder_2).l20 = minute$default;
  protoOf(Builder_2).v22 = second;
  protoOf(Builder_2).m20 = second$default;
  protoOf(Builder_2).n20 = secondFraction;
  protoOf(Builder_3).l22 = appendAlternativeParsingImpl;
  protoOf(Builder_3).m22 = appendOptionalImpl;
  protoOf(Builder_3).v20 = chars;
  protoOf(Builder_3).b21 = build;
  protoOf(Builder_3).x22 = offsetHours;
  protoOf(Builder_3).o20 = offsetHours$default;
  protoOf(Builder_3).y22 = offsetMinutesOfHour;
  protoOf(Builder_3).z22 = offsetMinutesOfHour$default;
  protoOf(Builder_3).a23 = offsetSecondsOfMinute;
  protoOf(Builder_3).b23 = offsetSecondsOfMinute$default;
  protoOf(PropertyAccessor).q28 = getterNotNull;
  protoOf(SpacePaddedFormatter).q23 = format$default;
  protoOf(SignedFormatter).q23 = format$default;
  protoOf(ConditionalFormatter).q23 = format$default;
  protoOf(ConcatenatedFormatter).q23 = format$default;
  protoOf(SignedIntFormatterStructure).q23 = format$default;
  protoOf(UnsignedIntFormatterStructure).q23 = format$default;
  protoOf(StringFormatterStructure).q23 = format$default;
  protoOf(DecimalFractionFormatterStructure).q23 = format$default;
  protoOf(ConstantStringFormatterStructure).q23 = format$default;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_2 = new Companion_2();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Truth_instance = new Truth();
  ExpectedInt_instance = new ExpectedInt();
  Companion_instance_8 = new Companion_8();
  Formats_instance_2 = new Formats_2();
  Formats_instance_3 = new Formats_3();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_instance;
  _.$_$.b = Companion_getInstance_9;
  _.$_$.c = char;
  _.$_$.d = format;
  //endregion
  return _;
}));
